import React, { useState, useEffect,useRef } from "react";
import { addHours } from "date-fns";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as fullStar, faStarHalfAlt, faStar as emptyStar } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import {
  format,
  addMonths,
  subMonths,
  startOfWeek,
  endOfWeek,
  addDays,
  subDays,
} from "date-fns";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import image1 from "../assets/house.png";
import fridgeCleaning from "../assets/fridge.png";
import ovenCleaning from "../assets/oven.png";
import windowCleaning from "../assets/windows.png";
import Bed from "../assets/beds.png";
import axios from "axios";
import { BaseUrl } from "../App";

// import { Circles } from "react-loader-spinner";

import { useAuth } from "../components/AuthContext";
import { FadeLoader } from 'react-spinners';

const MyBookingPage = () => {
  const { isAuthenticated } = useAuth();
  const [features, setFeatures] = useState([]);
  const [email, setEmail] = useState(""); // State for email input
  const [password, setPassword] = useState(""); // State for password input
  const [UserTypelocal, setUserTypelocal] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [activeView, setActiveView] = useState("month"); // Manage active view: 'month', 'week', or 'day'
  const [showModal, setShowModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [getidbyadmin, setgetidbyadmin] = useState(null);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  // const [crmgetdata, setCrmgetdata] = useState([]);
  console.log(getidbyadmin);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showBookingSummary, setShowBookingSummary] = useState(false);
  const [showBookingSummary2, setShowBookingSummary2] = useState(false);
  const [isServiceOpen, setIsServiceOpen] = useState(false); // Toggle "Choose Services"
  const [isCalendarOpen, setIsCalendarOpen] = useState(false); // Toggle Calendar panel
  const [isFormOpen, setIsFormOpen] = useState(false);
  // const [selectedOption, setSelectedOption] = useState("");
  const [userId, setUserId] = useState(null);
  const [bookingSuccessMessage, setBookingSuccessMessage] = useState("");
  const [daySelected, setDaySelected] = useState(null); // Track selected day
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [apiCallsPending, setApiCallsPending] = useState(0)
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [allServices, setallServices] = useState([]);
  console.log(allServices);
 // Add these state variables at the top with your existing states
const [settings, setSettings] = useState({});
const [zipCodeError, setZipCodeError] = useState("");
  const [useriddata, setuseriddata] = useState(null);
  console.log(useriddata);
  const [idpromocode, setidpromocode] = useState(null);
  const [optiondata, setoptiondata] = useState([]);
  const [personalDetails, setPersonalDetails] = useState({
    streetAddress: "",
    zipCode: "",
    city: "",
    state: "",
  });
  const [appointmentDetails, setAppointmentDetails] = useState({
    streetAddress: "",
    zipCode: "",
    city: "",
    state: "",
  });
  const [hoveredEvent, setHoveredEvent] = useState(null);
  const [userType, setUserType] = useState("new");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // useEffect(() => {
  //   const user = sessionStorage.getItem("userId");
  //   if (user) {
  //     setuserid(user); // This sets `useridd`, not `useriddata`
  //     setIsLoggedIn(true);
  //   } else {
  //     setIsLoggedIn(false);
  //   }
  // }, []);
  useEffect(() => {
    const userId = sessionStorage.getItem("userId");
    const userType = sessionStorage.getItem("userType");
  
    if (userId && userType === "client") {
      setuserid(userId); // or setUseridData if that's what you're using
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);
  

  const [sameAsAbove, setSameAsAbove] = useState(false);
  const [selectedFrequency, setSelectedFrequency] = useState("");
  const [selectedDiscount, setSelectedDiscount] = useState(0);
  const [Distext, setSelectedDistext] = useState(10);
  const [text, setText] = useState();
  const navigate = useNavigate();
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedservices, setselectedservices] = useState(0);
  const [showImageSection, setShowImageSection] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [residential, setResidential] = useState(false);
  const [commercial, setCommercial] = useState(false);
  const [bookingBill, setBookingBill] = useState([]);
  console.log(bookingBill);
  const [bedroom, setBedroom] = useState({});
  const [bathroom, setBathroom] = useState(0);
  const [quantities, setQuantities] = useState([0, 0, 0]);
  const [officeresidential, setofficeResidential] = useState(false);
  const [officecommercial, officesetCommercial] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [bookedSlots, setBookedSlots] = useState({});
  const [selectedMethod, setSelectedMethod] = useState(null);
  console.log(selectedMethod);
  const [bookingappointment, setbookingappointment] = useState([]);
  console.log(bookingappointment);
  const [propertyQuantities, setPropertyQuantities] = useState({
    Build_walls: 0,
    Build_doors: 0,
    Build_windows: 0,
  });
  const [officeQuantities, setOfficeQuantities] = useState({
    desk: 0,
    window: 0,
  });
  const [tax, settax] = useState(0);
  const [damagedFloors, setDamagedFloors] = useState(0);
  const [doorJams, setDoorJams] = useState(0);
  const [packing, setPacking] = useState(0);
  const [storeroom, setStoreroom] = useState(0);
  const [area, setArea] = useState(0);
  const [timeSlots, setTimeSlots] = useState([]);
  console.log(timeSlots);
  const [officearea, setOfficeArea] = useState(0);
  const [extraDamagedFloors, setExtraDamagedFloors] = useState(0);
  const [extraDoorJams, setExtraDoorJams] = useState(0);
  const [Disamount, setDisamount] = useState(0);
  const [officeextraDamagedFloors, setofficeExtraDamagedFloors] = useState(0);
  const [officeextraDoorJams, setofficeExtraDoorJams] = useState(0);
  const [adminData, setAdminData] = useState(null);
  const [calenderdata, setcalenderdata] = useState([]);
  const [Services_frequently_discount, setServices_frequently_discount] =
    useState([]);
  const [icon, setIcon] = useState("+"); // State to control the icon (either "+" or "-")
  const [activeTab, setActiveTab] = useState("Residential");
  const [formData, setFormData] = useState({
    serviceLocation: "",
    zipCode: "",
    selectedService: "",
    image: image1,
    showHouseOptions: false,
    showPlumbingOptions: false,
    showCarpenterOptions: false,
    showOfficeOptions: false,

    bedroomCount: "",
    bathroomCount: "",
  });
  const [crmgetdata, setcrmgetdata] = useState([]);
  const [dayseleted, setdayseleted] = useState(null);
  const [timeSelected, settimeSelected] = useState(null);
  const [userDetails, setUserDetails] = useState({
    id: "",
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    phone: "",
    streetAddress: "",
    city: "",
    state: "",
    zipCode: "",
    postalCode: "",
    specialRequests: "",
  });
  const [databooking, setdatabooking] = useState([]);
  const [activeService, setActiveService] = useState(null);
  const [serviceCounts, setServiceCounts] = useState({});
  const extraServices = [
    { image: fridgeCleaning, name: "Fridge Cleaning", price: "$50" },
    { image: ovenCleaning, name: "Oven Cleaning", price: "$40" },
    { image: windowCleaning, name: "Inside Window Cleaning", price: "$30" },
  ];
  const [paymentMethod, setPaymentMethod] = useState(""); // Set default to 'payLocally'
  const [showAllEvents, setShowAllEvents] = useState(false);
  const [totalTime, setTotalTime] = useState(0); // To track total time
  const [detailsdata, setDetailsdata] = useState({});
  console.log(detailsdata);
  const [Detailsiud, setDetailsiud] = useState(null); // Set default to
  // const [showForm, setShowForm] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [notes, setNotes] = useState("");
  const [rescheduleDate, setRescheduleDate] = useState(""); // Changed name here
  const [rescheduledData, setRescheduledData] = useState(null);
  const [subtotale, setsubtotale] = useState(0);
  const [isBookingComplete, setIsBookingComplete] = useState(false);
  const [useridd, setuserid] = useState(null);
  const [promoCode, setPromoCode] = useState("");
  const [appliedPromoCode, setAppliedPromoCode] = useState(null);
  const [promoCodes, setPromoCodes] = useState([]);
  const [promoDiscount, setPromoDiscount] = useState(0);
  const [vacuum, setVacuum] = useState("no");
  const [parking, setParking] = useState("no");
  const [access, setAccess] = useState("home");
  const parseCtFrontDesc = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const featureElements = doc.querySelectorAll(".features");
    const featuresArray = [];

    featureElements.forEach((feature) => {
      const title = feature.querySelector(".feature-tittle")?.textContent || "";
      const text = feature.querySelector(".feature-text")?.textContent || "";
      featuresArray.push({ title, text });
    });

    return featuresArray;
  };
  const handleRescheduleClick = () => {
    setShowRescheduleModal(true);
  };

    const renderRatingStars = (rating) => {
      return (
        <div className="flex items-center space-x-1">
          {[1, 2, 3, 4, 5].map((star) => {
            const isFilled = star <= Math.floor(rating);
            const isHalfFilled = star === Math.floor(rating) + 1 && rating % 1 !== 0;
            return (
              <span key={star} className="text-lg text-yellow-500">
                {isFilled ? (
                  <FontAwesomeIcon icon={fullStar} />
                ) : isHalfFilled ? (
                  <FontAwesomeIcon icon={faStarHalfAlt} />
                ) : (
                  <FontAwesomeIcon icon={emptyStar} className="text-gray-300" />
                )}
              </span>
            );
          })}
        </div>
      );
    };

// Fetch settings from API
const fetchSettings = async () => {
  setLoading(true);
  try {
    const response = await axios.post(
      `${BaseUrl}/backend/api/settings.php`,
      {
        action: "get_all_settings",
        api_key: "1",
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.status === "true" && response.data.statuscode === 200) {
      const fetchedSettings = response.data.response.reduce((acc, item) => {
        if (item.option_name === "ct_postal_code") {
          acc[item.option_name] = item.postalcode; // Store postal codes
        } else {
          acc[item.option_name] = item.option_value; // Store other settings
        }
        return acc;
      }, {});

      setSettings((prevSettings) => ({
        ...prevSettings,
        ...fetchedSettings,
      }));

      // Parse ct_front_desc if it exists
      if (fetchedSettings.ct_front_desc) {
        const parsedFeatures = parseCtFrontDesc(fetchedSettings.ct_front_desc);
        setFeatures(parsedFeatures);
      }
    } else {
      throw new Error(response.data.response || "Failed to fetch settings");
    }
  } catch (error) {
    setError(error.message);
  } finally {
    setLoading(false);
  }
};
  // Call fetchSettings on component mount
useEffect(() => {
  fetchSettings();
}, []);
const handleZipCodeChange = (e) => {
  const value = e.target.value;
  setFormData({
    ...formData,
    zipCode: value,
  });

  // Split postal codes into an array for comparison
  const validZipCodes = settings["ct_postal_code"]?.split(",") || [];

  // Check if the entered zip code matches any valid postal code
  if (value.length > 0 && !validZipCodes.includes(value)) {
    setZipCodeError("Our service is not available at your location");
  } else {
    setZipCodeError(""); // Clear error if valid or empty
  }
};
  const fetchTimeSlots = async (date) => {
    // Pehle check karo ke staff_id (getidbyadmin) available hai ya nahi
    if (!getidbyadmin) {
      alert("Staff ID missing! Please select a provider.");
      return;
    }

    if (!date) {
      alert("Please select a date.");
      return;
    }

    const formattedDate = format(date, "dd-MM-yyyy");

    const payload = {
      action: "get_slots",
      api_key: "1",
      selected_date: formattedDate,
      staff_id: getidbyadmin, // Ensure ID is present
    };
    setLoading(true);
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/slots.php`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response.data.response);
      setTimeSlots(response.data.response);
    } catch (error) {
      console.error("Error fetching time slots:", error);
      setTimeSlots([]);
    } finally {
      setLoading(false);
    }
  };

  // useEffect only depends on selectedDate now
  useEffect(() => {
    if (selectedDate) {
      fetchTimeSlots(selectedDate);
    }
  }, [selectedDate]);

  // Close modal
  const closeRescheduleModal = () => {
    // Changed name here
    setShowRescheduleModal(false);
  };

  const handleUpdate = (e, rescheduleDate) => {
    e.preventDefault();

    // Validate the rescheduleDate
    if (!rescheduleDate || isNaN(new Date(rescheduleDate).getTime())) {
      alert("Invalid date. Please provide a valid date.");
      return;
    }

    // Format the reschedule date into a readable format
    const formattedDate = new Date(rescheduleDate)
      .toISOString()
      .slice(0, 19)
      .replace("T", " ");

    // Data to save
    const dataToSave = {
      rescheduleDate: formattedDate,
    };

    // Log data to the console (optional)
    console.log("Rescheduled Data: ", dataToSave);

    // Save the data into state (without displaying it on the page)
    setRescheduledData(dataToSave);

    // Optionally, handle additional actions (like resetting the form or other states)
    closeRescheduleModal();
  };

  const handleRejectClick = () => {
    setShowForm(!showForm); // Toggle form visibility
  };

  const handleReject = async (id, e) => {
    setLoading(true);

    e.preventDefault();
    console.log("Reject Reason:", rejectReason, id);
    // Add your logic here to handle the reject reason
    try {
      // Define the request payload
      const payload = {
        action: "reject_appointment", // Action to fetch all services
        api_key: 1,
        order_id: id,
        reject_reason: rejectReason,
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/appointment_reject.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data) {
        setSuccessMessage("Reject Appointment Successfully!");
        const services = response.data;
        console.log(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }
      bookeddata();
      handleCloseModal();
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }

    setShowForm(false); // Close the form after submission
  };

  const handlePaymentChange = (e) => {
    setPaymentMethod(e.target.value);
  };
  const handleImageSectionToggle = () => {
    setShowImageSection((prevState) => !prevState); // Toggle the visibility of the image section
    setIcon((prevIcon) => (prevIcon === "+" ? "-" : "+")); // Toggle the icon between "+" and "-"
  };
  const editNavigate = () => {
    navigate("editcustomer");
  };

  const handleBedroomChange = (unitId, value) => {
    setBedroom((prevSelections) => ({
      ...prevSelections,
      [unitId]: value,
    }));
  };
  const addItemToBill = (id, itemName, quantity, pricePerItem, serviceTitle) => {
    setBookingBill((prevBill) => {
      // Find if the item already exists in the bill
      const existingItemIndex = prevBill.findIndex(
        (item) => item.unit_id === id && item.name === itemName
      );
  
      let updatedBill;
  
      if (existingItemIndex !== -1) {
        // If the item exists, replace it with the new quantity
        updatedBill = [...prevBill];
        if (quantity > 0) {
          updatedBill[existingItemIndex] = {
            method_id: selectedMethod.method_id,
            service_id: selectedService,
            unit_id: id,
            type: "unit",
            name: itemName,
            service_title: serviceTitle,
            qty: quantity, // Replace the old quantity with the new one
            rate: quantity * pricePerItem, // Recalculate the price
          };
        } else {
          // If quantity is 0, remove the item
          updatedBill.splice(existingItemIndex, 1);
        }
      } else if (quantity > 0) {
        // If the item doesn’t exist and quantity > 0, add it as a new entry
        updatedBill = [
          ...prevBill,
          {
            method_id: selectedMethod.method_id,
            service_id: selectedService,
            unit_id: id,
            type: "unit",
            name: itemName,
            service_title: serviceTitle,
            qty: quantity,
            rate: quantity * pricePerItem,
          },
        ];
      } else {
        // If quantity is 0 and item doesn’t exist, return the bill unchanged
        updatedBill = [...prevBill];
      }
  
      // Recalculate total time based on the updated bill
      const newTotalTime = updatedBill.reduce(
        (time, item) => time + (item.qty || 0) * 60,
        0
      );
      setTotalTime(newTotalTime);
  
      return updatedBill;
    });
  };
  const calculateTotal = () => {
    // Existing calculation for first two services
    const existingTotal = bookingBill.reduce(
      (total, item) => total + item.rate,
      0
    );

    // Calculation for third service
    if (selectedService === 3) {
      const propertyTotal =
        propertyQuantities.walls * 10 +
        propertyQuantities.doors * 10 +
        propertyQuantities.windows * 10 +
        damagedFloors * 10 +
        doorJams * 10;
      const areaTotal = area * 2 + extraDamagedFloors * 10 + extraDoorJams * 10;
      return existingTotal + propertyTotal + areaTotal;
    }
    if (selectedService === 4) {
      const officeTotal =
        (officeQuantities.rooms || 0) * 10 +
        (officeQuantities.bathrooms || 0) * 10 +
        (officeQuantities.kitchens || 0) * 10 +
        (packing || 0) * 10 +
        (storeroom || 0) * 10;

      const areaTotal =
        (officearea || 0) * 2 +
        (officeextraDamagedFloors || 0) * 10 +
        (officeextraDoorJams || 0) * 10;

      return existingTotal + officeTotal + areaTotal;
    }
    return existingTotal;
  };
  const fetchPromoCodes = async () => {
    try {
      const payload = {
        action: "get_all_coupons",
        api_key: "1",
      };

      const response = await axios.post(
        `${BaseUrl}/backend/api/promocode.php`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === "true") {
        setPromoCodes(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching promo codes:", error);
    }
  };
  // Add this useEffect to fetch promocodes on component mount
  useEffect(() => {
    fetchPromoCodes();
  }, []);

  // Add this function to apply promocode (place it near your other handler functions)
  const handleApplyPromoCode = () => {
    if (!selectedService || selectedService.length === 0) {
      alert("Please select at least one service");
      return;
    }

    const today = new Date();
    const foundPromo = promoCodes.find(
      (promo) =>
        promo.coupon_code === promoCode &&
        promo.status === "on" &&
        new Date(promo.coupon_expiry) >= today &&
        parseInt(promo.coupon_used) < parseInt(promo.coupon_limit)
      
    );

    if (foundPromo) {
      setidpromocode(foundPromo.id)
      setAppliedPromoCode(foundPromo);
      const discountValue =
        foundPromo.coupon_type === "P"
          ? (calculateTotal() * parseFloat(foundPromo.coupon_value)) / 100
          : parseFloat(foundPromo.coupon_value);
      setPromoDiscount(discountValue);
      setSuccessMessage("Promo code applied successfully!");
      setError("");
    } else {
      setAppliedPromoCode(null);
      setPromoDiscount(0);
      setError("Invalid or expired promo code");
    }
  };

  const handleCancelPromo = () => {
    setPromoDiscount(0);
    setAppliedPromoCode(null);
    setPromoCode(""); // Reset input field
    setError(""); // Clear error messages
  };

  // Modified calculateDiscountedTotal function
  const calculateDiscountedTotal = () => {
    const total = calculateTotal();
    setsubtotale(total);

    if (isNaN(total)) {
      console.error("Total calculation resulted in NaN:", total);
      return 0;
    }

    const frequencyDiscountPercentage = selectedDiscount;
    const frequencyDiscountAmount = (total * frequencyDiscountPercentage) / 100;
    const totalAfterFrequencyDiscount = total - frequencyDiscountAmount;

    const taxsum = total === 0 ? 0 : 10;
    const finalTotal = totalAfterFrequencyDiscount - promoDiscount + taxsum;

    setDisamount(frequencyDiscountAmount);
    settax(taxsum);
    setText(finalTotal);

    return finalTotal;
  };

  // Add useEffect to recalculate when promoDiscount changes
  useEffect(() => {
    calculateDiscountedTotal();
  }, [
    promoDiscount,
    selectedDiscount,
    bookingBill,
    propertyQuantities,
    area,
    damagedFloors,
    doorJams,
    officeQuantities,
    officearea,
    packing,
    storeroom,
  ]);
  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError("Please fill in both email and password.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/check_login.php`,
        {
          action: "check_login",
          api_key: 1,
          email: email,
          password: password,
        }
      );

      if (response.data.status === "true") {
        setError("");
        const userType = response.data?.usertype;
        const userIdFromResponse = response.data?.userId;

        console.log(userIdFromResponse);

        if (userType && userIdFromResponse) {
          setUserType(userType);
          setUserId(userIdFromResponse); // Set userId in state
          setIsLoggedIn(true);
          sessionStorage.setItem("userId", userIdFromResponse);
          sessionStorage.setItem("userType", userType);
          sessionStorage.setItem("isLoggedIn", "true");
        } else {
          setError("User type or user ID not found in the response.");
        }
      } else {
        setError(response.data.response || "Invalid email or password.");
      }
    } catch (error) {
      setError("An error occurred. Please try again later.");
      console.error("Login error:", error.response || error);
    } finally {
      setLoading(false);
    }
  };
  const handaldeleted = async (id) => {
    setLoading(true);

    try {
      // Define the request payload
      const payload = {
        action: "delete_booking", // Action to fetch all services
        api_key: 1,
        order_id: id,
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data) {
        setSuccessMessage("Delete Booking Successfully!");
        const services = response.data;
        console.log(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }

      bookeddata();
      handleCloseModal();
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handalconfirm_appointment = async (id) => {
    setLoading(true);

    console.log(id, "DADSA");
    try {
      // Define the request payload
      const payload = {
        action: "confirm_appointment", // Action to fetch all services
        api_key: "1",
        order_id: id,
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/appointment_confirm.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data) {
        setSuccessMessage("Confirm Booking Successfully!");
        const services = response.data;
        console.log(services);
        setIsBookingComplete(true);
      } else {
        console.log("API response indicates failure:", response.data);
      }

      bookeddata();
      handleCloseModal();
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const crmget = () => {
    setLoading(true);

    axios
      .get(`${BaseUrl}/backend/api/add_customer.php?action=getuser`)
      .then((response) => {
        console.log(response);
        if (response.data.status === "true") {
          setcrmgetdata(response.data.data);
        } else {
          console.log(response.data.message);
        }
      })
      .catch((err) => {
        console.log("An error occurred while fetching data");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const calendardata = () => {
    setLoading(true);

    axios
      .get(`${BaseUrl}/backend/api/services.php?action=week_days_available`)
      .then((response) => {
        console.log(response);
        if (response.data.status === "true") {
          setcalenderdata(response.data.data);
        } else {
          console.log(response.data.message);
        }
      })
      .catch((err) => {
        console.log("An error occurred while fetching data");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const generateTimeSlots = async () => {
      const today = new Date();
      const currentWeek = Math.ceil(today.getDate() / 7); // Week of the month (1st, 2nd, etc.)
      const currentDayOfWeek = today.getDay(); // Sunday = 0, Monday = 1, etc.
      console.log(currentWeek, currentDayOfWeek);

      // Filter schedule for the current week and weekday
      const selectedSchedule = calenderdata.find(
        (schedule) => schedule.provider_schedule_type === "weekly"
        // schedule.week_id === currentWeek &&
        // schedule.weekday_id === currentDayOfWeek &&
        // schedule.off_day === "N"
      );

      console.log(selectedSchedule);

      if (!selectedSchedule) {
        setTimeSlots([]); // If no schedule for the day, return empty slots
        return;
      }

      const dayStartTime = selectedSchedule.day_start_time;
      const dayEndTime = selectedSchedule.day_end_time;
      const slotDurationMinutes = 30;

      const startTime = new Date(`1970-01-01T${dayStartTime}Z`);
      const endTime = new Date(`1970-01-01T${dayEndTime}Z`);
      const slots = [];
      let currentTime = new Date(startTime);
      let slotId = 1;

      while (currentTime < endTime) {
        const slotStart = new Date(currentTime);
        const slotEnd = new Date(
          currentTime.getTime() + slotDurationMinutes * 60000
        );

        const formatTime = (time) => {
          let hours = time.getUTCHours();
          let minutes = time.getUTCMinutes().toString().padStart(2, "0");
          let period = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12;
          return `${hours}:${minutes} ${period}`;
        };

        const isToday =
          today.toDateString() === new Date(selectedDate).toDateString();
        const isPastSlot =
          isToday &&
          (today.getHours() > slotEnd.getUTCHours() ||
            (today.getHours() === slotEnd.getUTCHours() &&
              today.getMinutes() > slotEnd.getUTCMinutes()));

        slots.push({
          slot_id: slotId,
          slot_start: formatTime(slotStart),
          slot_end: formatTime(slotEnd),
          disabled: isPastSlot,
        });

        currentTime = slotEnd;
        slotId += 1;
      }

      setTimeSlots(slots);
    };

    generateTimeSlots();
    const interval = setInterval(generateTimeSlots, 60000);
    return () => clearInterval(interval);
  }, [selectedDate, calenderdata]); // Re-run when selectedDate changes

  useEffect(() => {
    calendardata();
  }, []);

  useEffect(() => {
    crmget();
  }, []);

  useEffect(() => {
    calculateDiscountedTotal(); // Calculate discounted total whenever discount or total changes
  }, [
    selectedService,
    bookingBill,
    propertyQuantities,
    area,
    damagedFloors,
    doorJams,
    officeQuantities,
    officearea,
    packing,
    storeroom,
  ]);
  useEffect(() => {
    const fetchAdminData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${BaseUrl}/backend/api/services.php?action=getadmindata`
        );
        console.log(response);
  
        if (response.data.status === "true") {
          // Filter admin data based on selectedService
          // const filteredAdminData = response.data.data.filter((provider) => {
          //   const serviceIdsArray = provider.service_ids
          //     .split(",")
          //     .map((id) => id.trim()); // Split and trim the service_ids string into an array
          //   return selectedService
          //     ? serviceIdsArray.includes(selectedService.toString())
          //     : true; // If no service selected, show all staff
          // });
          const filteredAdminData = response.data.data.filter((provider) => {
            const serviceIdsArray = provider.service_ids
              .split(",")
              .map((id) => id.trim());
          
            const matchesService = selectedService
              ? serviceIdsArray.includes(selectedService.toString())
              : true;
          
            const bookingEnabled = provider.enable_booking === "Y";
          
            return matchesService && bookingEnabled;
          });
          console.log(filteredAdminData)
            setAdminData(filteredAdminData); // Set filtered data
        } else {
          console.log(response.data.message);
        }
      } catch (err) {
        console.error("An error occurred while fetching data:", err);
        setError("Failed to fetch admin data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
  
    fetchAdminData();
  }, [selectedService]); // Add selectedService as a dependency so it refetches/filters when service changes

  useEffect(() => {
    // Update bedrooms and bathrooms directly in the bill
    const updateOrAddToBill = (itemName, quantity, pricePerItem) => {
      const existingItemIndex = bookingBill.findIndex(
        (item) => item.name === itemName
      );

      if (existingItemIndex !== -1) {
        const updatedBill = [...bookingBill];
        if (quantity > 0) {
          updatedBill[existingItemIndex] = {
            ...updatedBill[existingItemIndex],
            quantity,
            price: quantity * pricePerItem,
          };
        } else {
          updatedBill.splice(existingItemIndex, 1); // Remove the item if quantity is zero
        }
        setBookingBill(updatedBill);
      } else if (quantity > 0) {
        setBookingBill([
          ...bookingBill,
          { type: itemName, qty: quantity, rate: quantity * pricePerItem },
        ]);
      }
    };

    updateOrAddToBill("Bedrooms", bedroom, 5);
    updateOrAddToBill("Bathrooms", bathroom, 5);
  }, [bedroom, bathroom]);

  useEffect(() => {
    if (selectedService === 3) {
      // Initialize or reset variables related to Service 3
      setPropertyQuantities({
        walls: 0,
        doors: 0,
        windows: 0,
      });
      setDamagedFloors(0);
      setDoorJams(0);
      setArea(0);
      setExtraDamagedFloors(0);
      setExtraDoorJams(0);
    }
  }, [selectedService]); // Whenever `selectedService` changes handaldeleted  deleteallbooking

  useEffect(() => {
    if (selectedService === 4) {
      // Initialize or reset variables related to Service 4
      setOfficeQuantities({
        rooms: 0,
        bathrooms: 0,
        kitchens: 0,
      });
      setPacking(0);
      setStoreroom(0);
      setOfficeArea(0);
      setofficeExtraDamagedFloors(0);
      setofficeExtraDoorJams(0);
    }
  }, [selectedService]); // Whenever `selectedService` changes

  useEffect(() => {
    const maxAddons = Math.max(
      ...allServices.map((s) => (s.addons ? s.addons.length : 0)),
      extraServices.length
    );
    setQuantities(Array(maxAddons).fill(0));
  }, [allServices]);
  
  const removeItem = (idx) => {
    setBookingBill((prevBill) => {
      const updatedBill = prevBill.filter((_, index) => index !== idx);
      const removedItem = prevBill[idx];
  
      // Reset the quantity in the quantities array if the removed item is an addon
      if (removedItem.type) {
        const addonIndex = extraServices.findIndex(
          (addon) => addon.name === removedItem.type
        );
        if (addonIndex !== -1) {
          setQuantities((prevQuantities) => {
            const newQuantities = [...prevQuantities];
            newQuantities[addonIndex] = 0; // Reset to 0 when removed
            return newQuantities;
          });
        } else {
          // If the addon is from a service's addons (not extraServices), find it dynamically
          allServices.forEach((service) => {
            if (service.addons) {
              const serviceAddonIndex = service.addons.findIndex(
                (addon) => addon.addon_name === removedItem.type
              );
              if (serviceAddonIndex !== -1) {
                setQuantities((prevQuantities) => {
                  const newQuantities = [...prevQuantities];
                  newQuantities[serviceAddonIndex] = 0; // Reset to 0
                  return newQuantities;
                });
              }
            }
          });
        }
      }
  
      // Recalculate total time
      const newTotalTime = updatedBill.reduce(
        (time, item) => time + (item.qty || 0) * 60,
        0
      );
      setTotalTime(newTotalTime);
  
      return updatedBill;
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Log the value for the selected bedroom
    if (name === "bedroomCount") {
      console.log(`Selected Bedroom: ${value}`);
    }
  };
    const scrollRef = useRef(null);
    const scroll = (direction) => {
      const container = scrollRef.current;
      if (container) {
        const scrollAmount = container.offsetWidth * 0.8; // Scroll 80% of container width
        container.scrollBy({
          left: direction === 'next' ? scrollAmount : -scrollAmount,
          behavior: 'smooth',
        });
      }
    };

  const generateCalendar = (year, month) => {
    const date = new Date(year, month);
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const startDay = new Date(year, month, 1).getDay();
    const calendar = [];

    let currentDay = 1;

    for (let week = 0; week < 6; week++) {
      const weekDays = [];

      for (let day = 0; day < 7; day++) {
        if (week === 0 && day < startDay) {
          weekDays.push(null);
        } else if (currentDay <= daysInMonth) {
          weekDays.push(currentDay);
          currentDay++;
        } else {
          weekDays.push(null);
        }
      }
      calendar.push(weekDays);
    }
    return calendar;
  };
  const calendar = generateCalendar(
    currentDate.getFullYear(),
    currentDate.getMonth()
  );

  // Function to handle date selection
  const handleDateClick = (day) => {
    setDaySelected(day);
    if (day) {
      const selectedDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        day
      );

      // Compare only the date (year, month, day) without time, ensuring past dates are blocked
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time part to compare just the date

      if (selectedDay < today) {
        alert("Sorry, past date booking is not possible.");
        return;
      }

      // Format the date to MM/DD/YYYY
      const formattedDate = selectedDay.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });

      const key = formattedDate; // Use formattedDate as the key

      if (bookedSlots[key]?.length === timeSlots.length) {
        alert("Sorry, this date's time slots are fully booked.");
        return;
      }

      setSelectedDate(key);
      setSelectedTime(null);
      setShowForm(false); // Hide form initially
    }
  };

  // Function to handle time slot selection
  const handleTimeSelect = (time) => {
    setSelectedTime(time);
    setShowForm(true);
  };
  const toggleCalendarPanel = () => {
    setIsCalendarOpen((prev) => !prev); // Toggle this panel
    if (!isCalendarOpen) {
      // If opening this panel
      setIsServiceOpen(false); // Close others
      setIsFormOpen(false);
    }
  };

  const toggleFormPanel = () => {
    setIsFormOpen((prev) => !prev); // Toggle this panel
    if (!isFormOpen) {
      // If opening this panel
      setIsServiceOpen(false); // Close others
      setIsCalendarOpen(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isChecked) {
      alert("Please accept the Terms & Conditions before proceeding.");
      return;
    }

    if (!userId && !useriddata) {
      // Check only `userId` since it’s now the single source of truth
      alert("Please provide user details");
      return;
    }

    if (!selectedProvider?.id) {
      alert("Please select a provider");
      return;
    }

    if (!selectedDate || !selectedTime) {
      alert("Please select date and time for appointment");
      return;
    }

    if (!selectedService || selectedService.length === 0) {
      alert("Please select at least one service");
      return;
    }

    if (!paymentMethod) {
      alert("Please select a payment method");
      return;
    }

    const hasAtLeastOneUnit = bookingBill.some((item) => item.method_id);
    if (!hasAtLeastOneUnit) {
      alert("You must select at least one unit.");
      setLoading(false);
      return;
    }

    setLoading(true);

    const formattedData = {
      action: "book_appointment",
      api_key: "1",
      user_id: userId || useriddata, // Use `userId` directly
      staff_id: selectedProvider?.id || "",
      payment_method: paymentMethod,
      // sub_total: subtotale,
      sub_total: promoDiscount ? subtotale - promoDiscount : subtotale,
      discount: Disamount,
      order_duration: totalTime,
      tax: tax,
      booking_date_time: `${selectedDate} ${selectedTime}`,
      service_id: selectedService,
      method_id: selectedMethod?.method_id,
      cart_detail: bookingBill,
      net_amount: text,
      recurrence_id: selectedservices,
      freq_discount_amount: 1,
    };

    console.log("Formatted Booking Data:", formattedData);
    axios
      .post(`${BaseUrl}/backend/api/book_appointment.php`, formattedData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log(response.data.status);
        if (response.data.status === "true") {
          setSuccessMessage("Appointment Add successfully!");
          setIsModalVisible(true);



          if (idpromocode) {
            const promoData = {
              action: "increment_coupon_used",
              api_key: "1",
              coupon_id: idpromocode
            };

            axios
              .post("http://10.27.1.104/megaclean(20-03-2025)/megaclean/backend/api/promocode.php", promoData, {
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then((promoResponse) => {
                console.log("Promocode incremented successfully:", promoResponse.data);
              })
              .catch((promoError) => {
                console.error("Error incrementing promocode:", promoError);
                // Note: Not showing alert here to avoid disrupting user experience
              });
          }

          setTimeout(() => {
            setIsModalVisible(false);
            window.location.reload();
          }, 5000);
        } else {
          console.log(response.data.response);
        }

        handleClosebookingSummary();
        bookeddata();
      })
      .catch((error) => {
        console.error("Error occurred while submitting:", error);
        alert("There was an error submitting the form. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const hours = Array.from({ length: 24 }, (_, i) => `${i}:00`);

  // Function to navigate to next month or week
  const nextMonth = () => {
    if (activeView === "month") {
      setCurrentMonth(addMonths(currentMonth, 1)); // Navigate to the next month
    } else if (activeView === "week") {
      const nextWeekStart = addDays(endOfWeek(currentMonth), 1); // Go to the start of the next week
      setCurrentMonth(nextWeekStart);
    }
  };
  // Function to navigate to the next day
  const nextDay = () => {
    setCurrentMonth(addDays(currentMonth, 1)); // Navigate to the next day
  };
  // Function to navigate to the previous day
  const prevDay = () => {
    setCurrentMonth(subDays(currentMonth, 1)); // Navigate to the previous day
  };
  // Function to navigate to previous month or week
  const prevMonth = () => {
    if (activeView === "month") {
      setCurrentMonth(subMonths(currentMonth, 1)); // Navigate to the previous month
    } else if (activeView === "week") {
      const prevWeekStart = subDays(startOfWeek(currentMonth), 1); // Go to the start of the previous week
      setCurrentMonth(prevWeekStart);
    }
  };

  // Mock events data
  const events = [
    {
      id: 1,
      date: new Date(2024, 11, 10),
      hour: "2",
      bookingStatus: "Confirmed",
      bookingDate: "10-Dec-2024 01:00 PM",
      service: "House Cleaning",
      methods: "Property Based",
      units: "Bedroom(s)-3",
      addons: "Fridge Cleaning-5",
      price: "$65.00",
      duration: "4 Hours 0 Minutes",
      customer: {
        name: "John Doe",
        email: "johndoe@example.com",
        phone: "+10000000000",
        address: "Perrine, USA, Perrine, 90001, USA",
        payment: "Pay Locally",
        notes: "Happy Booking",
      },
    },
  ];
  const renderDaysInMonth = () => {
    const startDate = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth(),
      1
    );
    const endDate = new Date(
      currentMonth.getFullYear(),
      
      currentMonth.getMonth() + 1,
      0
    );
    const days = [];
    let dayIndex = startDate.getDay();
    let dayOfMonth = 1;

    const today = new Date();
    const todayDate = format(today, "yyyy-MM-dd");

    while (dayIndex > 0) {
      days.push(<div key={`empty-${dayIndex}`} className="p-4 border"></div>);
      dayIndex--;
    }

    while (dayOfMonth <= endDate.getDate()) {
      const date = new Date(
        currentMonth.getFullYear(),
        currentMonth.getMonth(),
        dayOfMonth
      );
      const eventsForDay = bookingappointment.filter(
        (event) =>
          format(event.booking_date_time, "yyyy-MM-dd") ===
          format(date, "yyyy-MM-dd")
      );

      const isToday = format(date, "yyyy-MM-dd") === todayDate;
      const isPastDate = format(date, "yyyy-MM-dd") < todayDate;
      const eventsToShow = eventsForDay.slice(0, 4);
      const remainingEvents = eventsForDay.length - 4;

      days.push(
        <div
          key={dayOfMonth}
          className={`p-1 border h-32 relative ${
            isToday ? "bg-blue-200" : ""
          } ${isPastDate ? "bg-gray-200" : ""}`}
          onClick={
            !isPastDate
              ? () => handleShowBookingSummary2(date)
              : () => alert("You can't select a past date")
          }
        >
          <p className={`text-right ${isToday ? "font-bold" : ""}`}>
            {dayOfMonth}
          </p>

          {eventsForDay.length > 0 && (
            <div className="absolute bottom-0 left-0 w-full px-2 py-1 space-y-1">
              {eventsToShow.map((event, index) => (
                <button
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleShowModal(event);
                    setDetailsiud(event.order_id);
                  }}
                  onMouseEnter={() => setHoveredEvent(event)}
                  onMouseLeave={() => setHoveredEvent(null)}
                  className="text-xs bg-customlightGreen text-black px-2 py-1 rounded mb-1 relative"
                >
                  Details
                  {hoveredEvent === event && (
                    <div className="absolute top-0 left-0 bg-white text-black p-4 rounded-lg shadow-lg z-20 border border-gray-200">
                      <p className="text-sm font-medium mb-1">
                        <strong>Title:</strong> {event.title}
                      </p>
                      <p className="text-sm mb-1">
                        <strong>Time:</strong> {event.booking_date_time}
                      </p>
                      <p className="text-sm mb-1">
                        <strong>Name:</strong> {detailsdata.client_name}
                      </p>
                      <p className="text-sm mb-1">
                        <strong>Email:</strong> {detailsdata.client_email}
                      </p>
                      <p className="text-sm">
                        <strong>Phone:</strong> {detailsdata.client_phone}
                      </p>
                    </div>
                  )}
                </button>
              ))}
              {remainingEvents > 0 && !showAllEvents && (
                <button
                  className="text-xs text-blue-500"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowAllEvents(true);
                  }}
                >
                  +{remainingEvents} More
                </button>
              )}
              {showAllEvents && (
                <div className="space-y-1">
                  {eventsForDay.slice(4).map((event, index) => (
                    <button
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleShowModal(event);
                        setDetailsiud(event.order_id);
                      }}
                      onMouseEnter={() => setHoveredEvent(event)}
                      onMouseLeave={() => setHoveredEvent(null)}
                      className="text-xs bg-customlightGreen text-black px-2 py-1 rounded mb-1 relative"
                    >
                      Details
                      {hoveredEvent === event && (
                        <div className="absolute top-0 left-0 bg-white text-black p-2 rounded shadow-md z-10">
                          <p className="text-xs">
                            <strong>Title:</strong> {event.title}
                          </p>
                          <p className="text-xs">
                            <strong>Time:</strong> {event.time}
                          </p>
                          <p className="text-xs">
                            <strong>Location:</strong> {event.location}
                          </p>
                        </div>
                      )}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      );

      dayOfMonth++;
    }
    return days;
  };
  const renderWeekView = () => {
    const weekStart = startOfWeek(currentMonth, { weekStartsOn: 0 });
    const weekEnd = endOfWeek(currentMonth, { weekStartsOn: 0 });
    const weekDays = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));
    const formattedRange = `${format(weekStart, "MMM d")} — ${format(
      weekEnd,
      "MMM d, yyyy"
    )}`;

    // Current date for highlighting
    const today = new Date();
    const todayDate = format(today, "yyyy-MM-dd");

    return (
      <div className="w-full mx-auto">
        {successMessage && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
            <span className="block sm:inline">{successMessage}</span>
          </div>
        )}

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
            <span className="block sm:inline">{error}</span>
          </div>
        )}
        <div className="grid grid-cols-8 border border-gray-300 text-center text-sm font-semibold bg-gray-50">
          <div className="col-span-1 border border-gray-200"></div>
          {weekDays.map((date, index) => {
            const isToday = format(date, "yyyy-MM-dd") === todayDate; // Check if it's today's date
            return (
              <div
                key={index}
                className={`py-2 border lg:text-base md:text-base border-gray-200 min-[320px]:text-[11px] max-[640px]:text-[11px] ${
                  isToday ? "bg-blue-100 font-bold" : ""
                }`}
              >
                {`${daysOfWeek[date.getDay()]} ${format(date, "MM/dd")}`}
              </div>
            );
          })}
        </div>

        <div className="grid grid-cols-8 divide-x border border-gray-300 text-sm">
          <div className="border-r border-gray-300">
            {hours.map((hour, index) => (
              <div
                key={index}
                className="h-16 flex items-center justify-end pr-2 border-b border-gray-300"
              >
                {hour}
              </div>
            ))}
          </div>

          {weekDays.map((date, dayIndex) => {
            const isToday = format(date, "yyyy-MM-dd") === todayDate; // Check if it's today's date
            const isPastDate = format(date, "yyyy-MM-dd") < todayDate; // Check if it's a past date

            return (
              <div
                key={dayIndex}
                className={`border-b border-gray-300 ${
                  isToday ? "bg-blue-50" : ""
                }`}
                onClick={
                  !isPastDate
                    ? () => handleShowBookingSummary2(date)
                    : () => alert("You can't select a past date")
                }
              >
                {hours.map((hour, hourIndex) => {
                  // Corrected hour calculation based on the `date`
                  const hourStart = format(addHours(date, hourIndex), "HH:00"); // Use `date` here instead of `new Date()`
                  const hourEnd = format(
                    addHours(date, hourIndex + 1),
                    "HH:00"
                  );

                  // Filter events for the current hour (for the given date and hour)
                  const eventsForHour = bookingappointment.filter((event) => {
                    const eventDateTime = format(
                      new Date(event.booking_date_time),
                      "yyyy-MM-dd HH:00"
                    ); // Full date and hour
                    const checkDateTime =
                      format(date, "yyyy-MM-dd") + " " + hourStart;
                    return eventDateTime === checkDateTime;
                  });

                  return (
                    <div
                      key={hourIndex}
                      className={`h-16 border-b border-gray-300 ${
                        isToday
                          ? "bg-blue-100"
                          : hourIndex % 2 === 0
                          ? "bg-gray-50"
                          : "bg-white"
                      }`}
                    >
                      {/* Render event buttons for this hour */}
                      {eventsForHour.length > 0 && (
                        <div className="space-y-1">
                          {eventsForHour.map((event, eventIndex) => (
                            <button
                              key={eventIndex}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleShowModal(event); // Show modal with event details
                                setDetailsiud(event.order_id); // Set the event's order_id
                              }}
                              className="text-xs bg-customlightGreen text-black px-2 py-1 rounded mb-1"
                            >
                              Details
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderDayView = () => {
    const day = currentMonth; // Assuming currentMonth is the date representing the current day view
    const formattedDay = format(day, "EEEE, MMM d, yyyy");

    const today = new Date();
    const todayDate = format(today, "yyyy-MM-dd");
    const isToday = format(day, "yyyy-MM-dd") === todayDate;
    const isFutureDate = format(day, "yyyy-MM-dd") > todayDate;

    return (
      <div className="w-full mx-auto">
        <div className="text-center text-lg font-medium">{formattedDay}</div>
        <div className="grid grid-cols-1 divide-y border border-gray-300 text-sm">
          {hours.map((hour, index) => {
            const hourStart = format(addHours(formattedDay, index), "HH:00"); // Calculate start time for each hour
            const hourEnd = format(addHours(formattedDay, index + 1), "HH:00"); // Calculate end time for each hour

            const eventsForHour = bookingappointment.filter((event) => {
              const eventDateTime = format(
                new Date(event.booking_date_time),
                "yyyy-MM-dd HH:00"
              );
              const checkDateTime =
                format(formattedDay, "yyyy-MM-dd") + " " + hourStart;
              return eventDateTime === checkDateTime;
            });

            return (
              <div
                key={index}
                onClick={
                  isToday || isFutureDate
                    ? () => handleShowBookingSummary2(day)
                    : () => alert("You can't select a past date")
                }
                className={`py-4 flex items-center px-2 text-base border-b border-gray-300 ${
                  isToday ? "bg-blue-100" : ""
                }`}
              >
                <div className="pr-20">{hour}</div>
                {eventsForHour.length > 0 && (
                  <div className="space-y-1">
                    {eventsForHour.map((event, eventIndex) => (
                      <button
                        key={eventIndex}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent event propagation
                          handleShowModal(event); // Show modal with event details
                          setDetailsiud(event.order_id); // Set the event's order_id
                        }}
                        className="text-xs bg-customlightGreen text-black px-2 py-1 rounded mb-1"
                      >
                        Details
                      </button>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const handleShowModal = (event) => {
    console.log(event);
    setSelectedEvent(event);
    setShowModal(true);
    setShowEditModal(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEvent(null);
  };
  const handleShowEditModal = () => {
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleShowBookingSummary = () => {
    setShowBookingSummary(true);
  };

  const handleShowBookingSummary2 = () => {
    setShowBookingSummary2(true);
  };
  const handleCloseBookingSummary = () => {
    setShowBookingSummary(false);
    setShowBookingSummary2(false);
  };
  const handleGoToToday = () => {
    setCurrentMonth(new Date()); // Set currentMonth to today's date
  };

  const handlePersonalDetailsChange = (e) => {
    const { name, value } = e.target;
    setPersonalDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // Handle same as above toggle
  const handleSameAsAbove = (e) => {
    setSameAsAbove(e.target.checked);
    if (e.target.checked) {
      setAppointmentDetails(personalDetails);
    }
  };
  // Handle change for appointment details
  const handleAppointmentDetailsChange = (e) => {
    const { name, value } = e.target;
    setAppointmentDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  
  const handleQuantityChange = (
    idx,
    increment,
    addon_name,
    addon_price,
    max_quantity
  ) => {
    // Update quantities array
    const newQuantities = [...quantities];
    console.log(increment)
    if (increment) {
      console.log(idx,newQuantities,Number([max_quantity]))
      
      if (newQuantities[idx] >= Number(max_quantity)) {
        alert(`Maximum quantity of ${max_quantity} reached for ${addon_name}`);
      } else {
        newQuantities[idx] += 1;
      }
    } else {
      newQuantities[idx] = Math.max(0, newQuantities[idx] - 1);
    }
    setQuantities(newQuantities);
  
    // Update bookingBill
    const quantity = newQuantities[idx];
    const totalPrice = quantity * addon_price;
  
    setBookingBill((prevBill) => {
      const existingItemIndex = prevBill.findIndex(
        (item) => item.type === addon_name
      );
  
      let updatedBill = [...prevBill];
  
      if (existingItemIndex !== -1) {
        if (quantity > 0) {
          updatedBill[existingItemIndex] = {
            ...updatedBill[existingItemIndex],
            qty: quantity,
            rate: totalPrice,
            service_id: idx, // Using index as a unique identifier for addon
          };
        } else {
          updatedBill.splice(existingItemIndex, 1);
        }
      } else if (quantity > 0) {
        updatedBill.push({
          type: addon_name,
          qty: quantity,
          rate: totalPrice,
          service_id: idx,
        });
      }
  
      // Update total time
      const newTotalTime = updatedBill.reduce(
        (time, item) => time + (item.qty || 0) * 60,
        0
      );
      setTotalTime(newTotalTime);
  
      return updatedBill;
    });
  };
  const getappointmentdetails = async () => {
    setLoading(true);
    try {
      // Define the request payload
      const payload = {
        action: "getbookingdetails", // Action to fetch all services
        order_id: Detailsiud, // API key for authentication
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data) {
        const services = response.data;

        setDetailsdata(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getappointmentdetails();
  }, [Detailsiud]);

  const deleteallbooking = async (id) => {
    setLoading(true);
    try {
      // Define the request payload
      const payload = {
        action: "delete_recurring_booking", // Action to fetch all services
        recurring_id: id,
        api_key: "1", // API key for authentication
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data) {
        const services = response.data;
        console.log(services);
        // setDetailsdata(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
    bookeddata();
    handleCloseModal();
  };

  useEffect(() => {
    deleteallbooking();
  }, []);

  const userIdta = sessionStorage.getItem("userId") || useriddata;

  const getuserdataa = crmgetdata?.find((user) => user.id === userIdta);
  console.log(getuserdataa);

  const getservicesdata = async () => {
    // setApiCallsPending((prev) => prev + 1);
    setLoading(true); // Set loading to true before fetching data
    try {
      const payload = {
        action: "all_services",
        api_key: "1",
      };

      const response = await axios.post(
        `${BaseUrl}/backend/api/services.php`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response.data);

      if (response.data && response.data.status === "true") {
        const services = response.data;
        setallServices(services.response);

        if (Array.isArray(services.response)) {
          console.log("Fetched Data:", services);
        } else {
          console.log("No valid array in response data:", response.data);
        }
      } else {
        console.log("API response indicates failure:", response.data);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      // setApiCallsPending((prev) => prev - 1); // Decrement pending API calls
      // if (apiCallsPending === 1) {
      setLoading(false); // Set loading to false when all API calls are done
      // } // Set loading to false after data is fetched
    }
  };
  const bookeddata = async () => {
    setLoading(true);
    try {
      const currentDate = new Date(); // Current date

      // Format the date in YYYY-MM-DD format
      const formattedDate = currentDate.toISOString().split("T")[0];

      // Convert formattedDate back to Date object to extract year and month
      const currentDateObj = new Date(formattedDate);

      // Get the first day of the current month
      const start_date = new Date(
        currentDateObj.getFullYear(),
        currentDateObj.getMonth(),
        1
      )
        .toISOString()
        .split("T")[0];

      // Get the last day of the month, 3 months from now
      const end_date = new Date(
        currentDateObj.getFullYear(),
        currentDateObj.getMonth() + 3 + 1,
        0
      )
        .toISOString()
        .split("T")[0];

      // Define the request payload
      const payload = {
        action: "getallbookings", // Action to fetch all services
        api_key: "1", // API key for authentication
        start_date: start_date,
        end_date: end_date,
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data && response.data.status === "true") {
        const services = response.data;
        console.log(services.response);

        if (Array.isArray(services.response)) {
          console.log("Fetched Data:", services); // Log the fetched data
          setbookingappointment(services.response);
          // setTableData(services); // Uncomment to update the table
        } else {
          console.log("No valid array in response data:", response.data);
        }
      } else {
        console.log("API response indicates failure:", response.data);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    bookeddata();
  }, []);

  useEffect(() => {
    getservicesdata();
  }, []);

  useEffect(() => {
    calculateDiscountedTotal(); // Calculate discounted total whenever discount or total changes
  }, [selectedDiscount]);

  const frequently_discount = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BaseUrl}/backend/api/services.php?action=frequently_discount`
      );

      console.log("Raw Response:", response.data);

      // Parse the response if necessary
      let responseData = response.data;
      if (typeof responseData === "string") {
        try {
          responseData = JSON.parse(responseData.trim()); // Remove extra whitespace and parse
        } catch (error) {
          console.log("Error parsing response data:", error);
          return;
        }
      }

      // Handle the parsed response
      if (responseData.status === "true") {
        const services = responseData.data;
        console.log("Fetched Data:", services);
        setServices_frequently_discount(services); // Update state
      } else {
        console.log("API response indicates failure:", responseData.message);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    frequently_discount();
  }, []);

  // const handleClick = () => {
  //   window.open("/login", "_blank"); // Opens in a new tab
  // };
  const [isAuthenticateddata, setIsAuthenticated] = useState(false);
  useEffect(() => {
    // Get values from localStorage
    const storedUserType = sessionStorage.getItem("userType");
    const isLoggedInData = sessionStorage.getItem("isLoggedIn");

    // Check if both values exist and isLoggedIn is 'true'
    if (storedUserType && isLoggedInData === "true") {
      setUserTypelocal(storedUserType);
      setIsAuthenticated(true);
    }
  }, []); // Empty dependency array means this runs once on mount

  const [authStatus, setAuthStatus] = useState(isAuthenticateddata);

  useEffect(() => {
    const interval = setInterval(() => {
      setAuthStatus(isAuthenticateddata);
    }, []);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [isAuthenticateddata]);

  const handleClick = () => {
    if (authStatus) {
      switch (UserTypelocal) {
        case "admin":
          navigate("/admin");
          break;
        case "staff":
          navigate("/staff");
          break;
        case "client":
          navigate("/user");
          break;
        default:
          navigate("/");
          break;
      }
    } else {
      navigate("/login");
    }
  };

  // useEffect(() => {
  //   handleClick();
  // }, []);

  const handleClosebookingSummary = () => {
    setShowBookingSummary(false);
    setShowBookingSummary2(false);
  };

  const toggleServicePanel = () => {
    setIsServiceOpen((prev) => !prev); // Toggle this panel
    if (!isServiceOpen) {
      // If opening this panel
      setIsCalendarOpen(false); // Close others
      setIsFormOpen(false);
    }
  };

  const handleMethodSelection = (method, id) => {
    switch ((method.method_title, id)) {
      case "Residential Services":
        setResidential(true);
        setCommercial(false);
        setofficeResidential(false);
        officesetCommercial(false);
        break;
      case "Commercial Services":
        setResidential(false);
        setCommercial(true);
        setofficeResidential(false);
        officesetCommercial(false);
        break;
      case "Property Based":
        setResidential(false);
        setCommercial(false);
        setofficeResidential(true);
        officesetCommercial(false);
        break;
      case "Area Based (Feet)":
        setResidential(false);
        setCommercial(false);
        setofficeResidential(false);
        officesetCommercial(true);
        break;
      default:
        // Reset all states if no match is found
        setResidential(false);
        setCommercial(false);
        setofficeResidential(false);
        officesetCommercial(false);
    }

    setSelectedMethod(method, id);
  };

  const handlePrevMonth = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() - 1);
    setCurrentDate(newDate);
  };

  // Function to handle next month button click
  const handleNextMonth = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() + 1);
    setCurrentDate(newDate);
  };

  const handleUserTypeChange = (value) => {
    setUserType(value); // Set the user type

    if (value === "new") {
      // Reset the form fields for a new user
      setUserDetails({
        id: "",
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        phone: "",
        streetAddress: "",
        zipCode: "",
        city: "",
        state: "",
        specialRequests: "",
      });
    } else if (value === "existing") {
      // Optionally, handle the reset when switching to "Existing User"
      setUserDetails({
        id: optiondata?.id || "",
        email: optiondata?.user_email || "",
        password: optiondata?.user_pwd || "",
        firstName: optiondata?.first_name || "",
        lastName: optiondata?.last_name || "",
        phone: optiondata?.phone || "",
        streetAddress: optiondata?.address || optiondata?.street_address || "",
        city: optiondata?.city || "",
        state: optiondata?.state || "",
        zipCode: optiondata?.zip || "",
        specialRequests: optiondata?.notes || "",
      });
    }
  };

  const handleConfirmClick = (id) => {
    console.log(`Confirming appointment with ID: ${id}`);
    // Add logic for confirming the appointment here
  };

  const handleChangedata = (event) => {
    const selectedId = event.target.value;
    setSelectedOption(selectedId); // Update the selected option

    const selectedUser = crmgetdata.find((user) => user.id === selectedId); // Find the selected user
    setoptiondata(selectedUser);

    if (selectedUser) {
      // Populate the form fields with the selected user's data
      setUserDetails({
        id: selectedUser.id || "",
        email: selectedUser.user_email || "",
        password: selectedUser.user_pwd || "",
        firstName: selectedUser.first_name || "",
        lastName: selectedUser.last_name || "",
        phone: selectedUser.phone || "",
        streetAddress:
          selectedUser.address || selectedUser.street_address || "",
        city: selectedUser.city || "",
        state: selectedUser.state || "",
        zipCode: selectedUser.zip || "",
        specialRequests: selectedUser.notes || "",
      });
    } else {
      // Reset the form if no user is selected
      setUserDetails({
        id: "",
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        phone: "",
        streetAddress: "",
        zipCode: "",
        city: "",
        state: "",
        specialRequests: "",
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!userDetails.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(userDetails.email)) {
      newErrors.email = "Email is invalid";
    }
    // Password Validation
    if (!userDetails.password) {
      newErrors.password = "Password is required";
    } else if (userDetails.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    }
    if (!userDetails.firstName) {
      newErrors.firstName = "First Name is required";
    }
    if (!userDetails.lastName) {
      newErrors.lastName = "Last Name is required";
    }
    if (!userDetails.phone) {
      newErrors.phone = "Phone is required";
    }
    if (!userDetails.streetAddress) {
      newErrors.streetAddress = "Street Address is required";
    }
    if (!userDetails.zipCode) {
      newErrors.zipCode = "Zip Code is required";
    }
    if (!userDetails.city) {
      newErrors.city = "City is required";
    }
    if (!userDetails.state) {
      newErrors.state = "State is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleUserDetailsChange = (event) => {
    const { name, value } = event.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  const handleSubmitdata = (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
  
    // Initialize errors object
    const newErrors = {};
  
    // Required fields validation
    if (!userDetails.email) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(userDetails.email)) {
      newErrors.email = "Please enter a valid email address.";
    }
  
    if (!userDetails.password) {
      newErrors.password = "Password is required.";
    } else if (userDetails.password.length !== 8) {
      newErrors.password = "Password must be exactly 8 characters.";
    }
  
    if (!userDetails.firstName) {
      newErrors.firstName = "First Name is required.";
    }
  
    if (!userDetails.lastName) {
      newErrors.lastName = "Last Name is required.";
    }
  
    if (!userDetails.phone) {
      newErrors.phone = "Phone number is required.";
    } else if (!/^\d{10}$/.test(userDetails.phone)) {
      newErrors.phone = "Phone number must be exactly 10 digits.";
    }
  
    if (!userDetails.streetAddress) {
      newErrors.streetAddress = "Street Address is required.";
    }
  
    if (!userDetails.zipCode) {
      newErrors.zipCode = "Zip Code is required.";
    } else if (!/^\d{6}$/.test(userDetails.zipCode)) {
      newErrors.zipCode = "Zip Code must be exactly 6 digits.";
    }
  
    if (!userDetails.city) {
      newErrors.city = "City is required.";
    }
  
    if (!userDetails.state) {
      newErrors.state = "State is required.";
    }
  
    // Update errors state
    setErrors(newErrors);
  
    // If there are errors, stop form submission
    if (Object.keys(newErrors).length > 0) {
      return;
    }
  
    // Proceed with form submission if no validation errors
    setLoading(true);
  
    const data = {
      action: "add_customerdata",
      api_key: "1",
      email: userDetails.email,
      password: userDetails.password,
      first_name: userDetails.firstName,
      last_name: userDetails.lastName,
      phone: userDetails.phone,
      address: userDetails.streetAddress,
      zipcode: userDetails.zipCode,
      city: userDetails.city,
      state: userDetails.state,
      notes: userDetails.specialRequests,
      vc_status: vacuum === "yes" ? "Y" : "N",
      p_status: parking === "yes" ? "Y" : "N",
      contact_status: access === "home" ? "Active" : access,
    };
  
    console.log(data);
  
    // Send the data using axios POST request
    axios
      .post(`${BaseUrl}/backend/api/add_customer.php`, data)
      .then((response) => {
        console.log(response.data);
  
        if (response.data.status === "true") {
          alert("Customer created successfully!");
          setSuccessMessage("Add Customer successfully!");
          getservicesdata();
          setuseriddata(response.data.customer_data.id);
        } else {
          getservicesdata();
        }
      })
      .catch((error) => {
        console.error("Error occurred while submitting:", error);
        alert("There was an error submitting the form. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const today = new Date();

  const handleLogout = () => {
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("userType");
    sessionStorage.removeItem("isLoggedIn");
    setIsLoggedIn(false);
  };
  // SVG icons array to map to features (same order as static content)
  const svgIcons = [
    {
      path: "M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z",
      bg: "blue",
    },
    {
      path: "M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z",
      bg: "purple",
    },
    {
      path: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z",
      bg: "green",
    },
    {
      path: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
      bg: "amber",
    },
    {
      path: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z",
      bg: "indigo",
    },
  ];

  return (
   <div className="relative min-h-screen">
       {/* Loading Indicator */}
      
          {loading && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
            <FadeLoader 
              height={15}
              width={5}
              color="#ffffff"
              ariaLabel="loading"
            />
            <h1 className="mt-1 text-lg text-white">Please wait...</h1>
          </div>
        </div>
      )}
      
        <div className="flex flex-col bg-gray-100 p-4 w-full">
          <div className="w-full max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Left Section - Booking Form */}
              <div className="col-span-2 bg-white p-5 rounded-lg shadow-lg">
                <button
                  onClick={handleClick}
                  className="px-4 py-2 mt-3 bg-blue-500 text-white flex items-end justify-end rounded-md hover:bg-blue-600 transition duration-200"
                >
                  My Booking
                </button>
                <h1 className="text-3xl font-medium text-center text-blue-800 mb-6">
                  Megaclean
                </h1>
                <p className="text-center text-gray-700 mb-4">Amroli Surat</p>

                <form onSubmit={handleSubmit} className="space-y-6">
                  {/* Service Location */}
                  <div>
                    <label
                      htmlFor="serviceLocation"
                      className="block text-lg font-medium text-gray-800"
                    >
                      Where would you like us to provide service?
                    </label>
                  </div>
                    {/* // Update your Zip Code input section in the JSX */}
                    <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6">
                      <div className="flex flex-col w-full">
                        <label
                          htmlFor="zipCode"
                          className="block text-lg font-medium text-gray-800"
                        >
                          Zip Code
                        </label>
                        <input
                          type="text"
                          id="zipCode"
                          name="zipCode"
                          value={formData.zipCode}
                          onChange={handleZipCodeChange} // Use new handler
                          className="mt-2 p-2 w-full border border-gray-400 rounded-md"
                          placeholder="Enter Zip Code"
                          onInput={(e) => {
                            if (e.target.value.length > 6) {
                              e.target.value = e.target.value.slice(0, 6); // Max 6 digits
                            }
                          }}
                        />
                        {/* Display error message if zip code is invalid */}
                        {zipCodeError && (
                          <p className="text-red-500 text-sm mt-1">{zipCodeError}</p>
                        )}
                        
                      </div>
                    </div>
                                      {/* Choose Service */}
                  <div>
                    <label
                      htmlFor="selectedService"
                      className="block text-lg font-medium text-gray-800"
                    >
                      Choose Service
                    </label>
                  </div>


                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-6 min-[320px]:grid-cols-2 max-[640px]:grid-cols-2">
                                  {allServices?.map((service) => (
                                    <div
                                      key={service.service_id}
                                      onClick={() => {
                                        if (service.service_id) {
                                          if (selectedService === service.service_id) {
                                            // If the same service is clicked again, unselect it
                                            setSelectedService(null);
                                          } else {
                                            // Select the new service
                                            setSelectedService(service.service_id);
                                          }
                                        } else {
                                          console.error("Service ID is missing", service);
                                        }
                                      }}
                                      className={`cursor-pointer border rounded-lg text-center transition-all duration-300 ${
                                        selectedService === service.service_id
                                          ? "bg-blue-400 text-white shadow-lg shadow-blue-500"
                                          : "bg-white hover:bg-blue-300"
                                      }`}
                                    >
                                      {service?.service_image ? (
                                        // If image exists, show image with title overlay
                                        <div className="relative">
                                          <img
                                            src={service.service_image}
                                            className="w-full h-52 object-cover rounded-md min-[320px]:h-36 max-[640px]:h-36"
                                          />
                                          <div className="absolute inset-0 flex items-center justify-center text-white font-bold bg-black bg-opacity-50 rounded-md">
                                            {service?.service_title}
                                          </div>
                                        </div>
                                      ) : (
                                        // If no image, show only title with a colored background
                                        <div className="flex items-center justify-center h-20 p-4 text-white font-bold bg-blue-500 rounded-md">
                                          {service?.service_title}
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </div>

                  {/* Conditionally render the selected service details */}
                  {selectedService && (
                    <div>
                      {/* Find the selected service */}
                      {allServices
                        .filter((s) => s.service_id === selectedService)
                        ?.map((service) => (
                          <>
                            <div>
                              {/* Dropdowns */}
                              {service.units && service.units.length > 0 && (
                                <div>
                                  {service.units?.map((unit) => (
                                    <div
                                      key={unit.unit_id}
                                      className="flex gap-4 mb-6"
                                    >
                                      <div>
                                        <div className="flex items-center space-x-2">
                                          {/* Display the unit title */}
                                          <label className="block font-medium mb-2">
                                            {unit.unit_title}
                                          </label>
                                          <img
                                            src={Bed}
                                            className="w-6 h-6"
                                            alt="Unit Icon"
                                          />
                                        </div>
                                        <select
                                          className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-400"
                                          value={
                                            bedroom[unit.unit_id] ||
                                            unit.unit_min
                                          } // Default to `unit_min`
                                          onChange={(e) =>
                                            handleBedroomChange(
                                              unit.unit_id,
                                              parseInt(e.target.value)
                                            )
                                          }
                                        >
                                          {Array.from(
                                            {
                                              length:
                                                unit.unit_max -
                                                unit.unit_min +
                                                1,
                                            },
                                            (_, i) => (
                                              <option
                                                key={i + unit.unit_min}
                                                value={i + unit.unit_min}
                                              >
                                                {i}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}

                              {/* Render methods */}
                              {service.methods &&
                                service.methods.length > 0 && (
                                  <div className="flex flex-col space-y-6 mb-5">
                                    {/* Upper part: Methods Buttons */}
                                    <div>
                                      <h3>Methods</h3>
                                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                                        {service.methods?.map((method) => (
                                          <button
                                            type="button"
                                            key={method.method_id}
                                            onClick={() =>
                                              handleMethodSelection(
                                                method,
                                                method.method_id
                                              )
                                            }
                                            className={`p-4 border rounded-lg text-center shadow-md transition-all ${
                                              selectedMethod &&
                                              selectedMethod.method_id ===
                                                method.method_id
                                                ? "bg-blue-400 text-white"
                                                : "bg-white hover:bg-gray-200"
                                            }`}
                                          >
                                            {method.method_title}
                                          </button>
                                        ))}
                                      </div>
                                    </div>

                                    {/* Bottom part: Submethods and Quantity Buttons */}
                                    {selectedMethod && (
                                      <div className="mt-6">
                                        {selectedMethod.submethods &&
                                        selectedMethod.submethods.length > 0 ? (
                                          <>
                                            {/* Mobile View - Dropdown */}
                                            <div className="block md:hidden">
                                              {selectedMethod.submethods.map(
                                                (submethod) => (
                                                  <div
                                                    key={submethod.unit_id}
                                                    className="mb-4"
                                                  >
                                                  <label className="block font-medium mb-2">
                                                  {submethod.unit_title} (₹{submethod.unit_price})
                                                </label>
                                                    <select
                                                      className="w-full p-2 border rounded-lg"
                                                      onChange={(e) => {
                                                        const selectedQuantity =
                                                          parseInt(
                                                            e.target.value,
                                                            10
                                                          );
                                                        addItemToBill(
                                                          submethod.unit_id,
                                                          submethod.unit_title,
                                                          selectedQuantity,
                                                          submethod.unit_price
                                                        );
                                                      }}
                                                    >
                                                      <option value="">
                                                        Select Quantity
                                                      </option>
                                                      {[
                                                        ...Array(
                                                          submethod.unit_max -
                                                            submethod.unit_min +
                                                            1
                                                        ).keys(),
                                                      ].map((qty) => {
                                                        const quantity =
                                                          1 + qty;
                                                        return (
                                                          <option
                                                            key={quantity}
                                                            value={quantity}
                                                          >
                                                            {quantity}
                                                          </option>
                                                        );
                                                      })}
                                                    </select>
                                                  </div>
                                                )
                                              )}
                                            </div>

                                            {/* Desktop & Tablet View - Buttons */}
                                            <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-2 gap-2">
                                              {selectedMethod.submethods.map(
                                                (submethod) => (
                                                  <div
                                                    key={submethod.unit_id}
                                                    className="mb-4"
                                                  >
                                                    <label className="block font-medium mb-2">
                                                      {submethod.unit_title}{" "}
                                                      &nbsp;(₹
                                                      {submethod.unit_price})
                                                    </label>
                                                    <select
                                                        className="w-full p-2 border rounded-lg"
                                                        onChange={(e) => {
                                                          const selectedQuantity = parseInt(e.target.value, 10);
                                                          addItemToBill(
                                                            submethod.unit_id,
                                                            submethod.unit_title,
                                                            selectedQuantity,
                                                            submethod.unit_price,
                                                            service.service_title
                                                          );
                                                        }}
                                                        value={
                                                          bookingBill.find((item) => item.unit_id === submethod.unit_id)?.qty || ""
                                                        }
                                                      >
                                                      <option value="">Select Quantity</option>
                                                                      {[...Array(submethod.unit_max - submethod.unit_min + 1).keys()].map((qty) => {
                                                                        const quantity = qty + 1;
                                                                        return (
                                                                          <option key={quantity} value={quantity}>
                                                                            {quantity}
                                                                          </option>
                                                                        );
                                                                      })}
                                                                    </select>
                                                                        </div>
                                                                      ))}
                                                                    </div>
                                                                    </>
                                                                  ) : (
                                                                    <p className="text-gray-600">No submethods available for this method.</p>
                                                                  )}
                                                                </div>
                                                              )}
                                                        </div>
                                                )}

                                            {selectedMethod && (
                                              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                                {service.addons?.map((addon, index) => (
                                                  <div
                                                    key={index}
                                                    className="p-4 border rounded-lg text-center bg-white shadow-md"
                                                  >
                                                    <p className="text-lg font-semibold mb-2">{addon.addon_name}</p>
                                                    <p className="text-lg mb-2">Price: ₹{addon.addon_price}</p>
                                                    {quantities[index] >= addon.addon_maxqty && (
                                                    <p className="text-xs text-red-500 mb-3">
                                                      {addon.addon_name} are Max {addon.addon_maxqty} reached
                                                    </p>
                                                  )}  

                                                    <div className="flex items-center justify-center gap-2">
                                                      <button
                                                        type="button"
                                                        onClick={() =>
                                                          handleQuantityChange(
                                                            index,
                                                            false,
                                                            addon.addon_name,
                                                            addon.addon_price,
                                                            addon.addon_maxqty
                                                          )
                                                        }
                                                        className="p-2 bg-red-400 text-white rounded-lg"
                                                      >
                                                        -
                                                      </button>
                                                      <span className="text-lg">{quantities[index] || 0}</span>
                                                      <button
                                                        type="button"
                                                        onClick={() =>
                                                          handleQuantityChange(
                                                            index,
                                                            true,
                                                            addon.addon_name,
                                                            addon.addon_price,
                                                            addon.addon_maxqty
                                                          )
                                                        }
                                                        className="p-2 bg-green-400 text-white rounded-lg"
                                                        disabled={quantities[index] >= addon.addon_maxqty}
                                                      >
                                                        +
                                                      </button>

                                                      
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            )}
                                        </div>
                                      </>
                                    ))}
                                </div>
                              )}

                                      <div className="p-4"> 
                                                <h2 className="text-lg font-semibold mb-4 text-center sm:text-left">
                                                  How often would you like us to provide service ? ( Four Month Booking schedule Manage ) 
                                                </h2>
                                                <div className="flex flex-wrap justify-center sm:justify-start gap-4">
                                                {Services_frequently_discount?.map((v) => {
                                                      const message =
                                                        v.discount_typename === "Once"
                                                          ? "One-time booking."
                                                          : `Service every ${v.days} days, ${v.booking_count} bookings counted annually.`;

                                                      const isSelected = selectedFrequency === v.discount_typename;

                                          return (
                                            <div key={v.id} className="flex flex-col items-center w-28 sm:w-auto">
                                              <button
                                                type="button"
                                                onClick={() => {
                                                  if (isSelected) {
                                                    setSelectedFrequency(null);
                                                    setSelectedDiscount(null);
                                                    setselectedservices(null);
                                                  } else {
                                                    setSelectedFrequency(v.discount_typename);
                                                    setSelectedDiscount(v.rates);
                                                    setselectedservices(v.id);
                                                  }
                                                }}
                                                className={`w-full px-4 py-2 border rounded-lg transition-colors duration-200 text-sm font-medium text-center
                                                  ${
                                                    isSelected
                                                      ? "border-teal-500 text-teal-600 bg-teal-50"
                                                      : "border-gray-300 text-gray-700 hover:border-teal-400 hover:text-teal-500"
                                                  }`}
                                              >
                                                {v.discount_typename}
                                              </button>
                                  {/* Display the original labels */}
                                  <p className="text-sm text-gray-500 mt-2">{v.labels}</p>
                                  {/* Display the dynamic message only for the selected frequency with bold and improved styling */}
                                  {selectedFrequency === v.discount_typename && (
                                    <p className="text-sm font-bold text-gray-700 mt-1 text-center">
                                      {message}
                                    </p>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>

                                    {/* Service Provider Section */}
                                    <div>
                                    <h2 className="text-lg font-semibold mb-4">
                                        Please select provider
                                      </h2>

                                      <div className="relative px-4 pb-4">
                                        {/* Previous Button */}
                                        <button
                                          type="button"
                                          onClick={() => scroll("prev")}
                                          className="absolute left-0 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full z-10 opacity-75 hover:opacity-100 transition-opacity"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-6 h-6"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth={2}
                                              d="M15 19l-7-7 7-7"
                                            />
                                          </svg>
                                        </button>

                                        {/* Scrollable Container */}
                                        <div
                                          ref={scrollRef}
                                          className="flex overflow-x-auto lg:flex lg:space-x-8 px-4 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
                                        >
                                          {adminData?.length > 0 ? (
                                            adminData.map((provider, index) => (
                                              <div
                                                key={index}
                                                className={`flex flex-col items-center cursor-pointer flex-shrink-0 ${
                                                  selectedProvider === provider
                                                    ? "border-teal-500"
                                                    : "border-gray-300"
                                                } border rounded-md p-4 m-2 sm:m-5 w-full sm:w-auto max-w-xs mx-auto`}
                                                onClick={() => {
                                                  if (selectedProvider === provider) {
                                                    // If the same provider is clicked again, unselect it
                                                    setSelectedProvider(null);
                                                    setgetidbyadmin(null); // Clear the staff ID
                                                  } else {
                                                    // Select the new provider
                                                    setSelectedProvider(provider);
                                                    setgetidbyadmin(provider.id); // Set the staff ID
                                                  }
                                                }}
                                              >
                                                <img
                                                  src={provider.image || "default-image.jpg"} // Fallback image if none provided
                                                  className="w-16 h-16 sm:w-24 sm:h-24 rounded-full mb-2 object-cover"
                                                />
                                                <p className="font-semibold text-gray-800 text-center text-sm sm:text-base">
                                                  {provider.fullname}
                                                </p>
                                                <p>{renderRatingStars(provider.rating)}</p>
                                              </div>
                                            ))
                                          ) : (
                                            <p className="text-gray-500 text-center w-full">
                                              No staff available for the selected service.
                                            </p>
                                          )}
                                        </div>

                                        {/* Next Button */}
                                        <button
                                          type="button"
                                          onClick={() => scroll("next")}
                                          className="absolute right-0 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full z-10 opacity-75 hover:opacity-100 transition-opacity"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-6 h-6"
                                            fill="none"
                                            viewBox="0 24 24"
                                            stroke="currentColor"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth={2}
                                              d="M9 5l7 7-7 7"
                                            />
                                          </svg>
                                        </button>
                                    </div>
                                    </div>

                                  <div>
                              {/* Left Column - Calendar */}
                              <div className="max-auto bg-white">
                                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                                  <div className="text-center mb-8">
                                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-800">
                                      Book Your Appointment
                                    </h2>
                                  </div>

                                  {/* Calendar */}
                                  <div>
                                    <div>
                                      <div className="flex flex-col items-center mb-6 px-2 py-2 overflow-hidden ">
                                        <div className="flex justify-between items-center w-full max-w-4xl px-4 mb-4">
                                          <button
                                            type="button"
                                            onClick={handlePrevMonth}
                                            className="bg-gray-200 text-gray-800 px-3 py-1 rounded-md shadow-md hover:bg-gray-300"
                                          >
                                            Previous
                                          </button>
                                          <h2 className="text-xl font-semibold text-gray-700">
                                            {currentDate.toLocaleString("default", {
                                              month: "long",
                                            })}{" "}
                                            {currentDate.getFullYear()}
                                          </h2>
                                          <button
                                            type="button"
                                            onClick={handleNextMonth}
                                            className="bg-gray-200 text-gray-800 px-3 py-1 rounded-md shadow-md hover:bg-gray-300"
                                          >
                                            Next
                                          </button>
                                        </div>

                                        <div className="grid grid-cols-4 sm:grid-cols-7 gap-4 p-4 bg-gray-100 rounded-2xl shadow-inner">
                                          {calendar?.map((week, index) => (
                                            <div key={index} className="contents">
                                              {week?.map((day, dayIndex) => {
                                                const currentDay = new Date(
                                                  currentDate.getFullYear(),
                                                  currentDate.getMonth(),
                                                  day
                                                );
                                                const isPastDate =
                                                  currentDay < new Date().setHours(0, 0, 0, 0);
                                                const isSelected = daySelected === day && !isPastDate;
                                                const isToday =
                                                  day === new Date().getDate() &&
                                                  currentDate.getMonth() === new Date().getMonth() &&
                                                  currentDate.getFullYear() === new Date().getFullYear();

                                                return (
                                                  <button
                                                    key={dayIndex}
                                                    type="button"
                                                    className={`w-12 h-12 sm:w-16 sm:h-12 flex items-center justify-center rounded-full transition-all duration-300 ease-in-out 
                                                      ${day ? "cursor-pointer" : "cursor-default"}
                                                      ${day ? "hover:bg-blue-200 hover:text-white hover:shadow-lg hover:scale-110" : "opacity-0"}
                                                      ${
                                                        isPastDate
                                                          ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                                          : isSelected
                                                          ? "!bg-blue-500 !text-white"
                                                          : isToday
                                                          ? "bg-red-500 text-gray-800"
                                                          : "bg-white text-gray-700 border border-gray-200"
                                                      }`}
                                                    onClick={() => handleDateClick(day)}
                                                    disabled={!day || isPastDate}
                                                  >
                                                    {day}
                                                  </button>
                                                );
                                              })}
                                            </div>
                                          ))}
                                        </div>
                                        {/* Today Button */}
                                      <div className="flex justify-center mt-4">
                                        <button
                                          type="button"
                                          onClick={() => {
                                            const today = new Date();
                                            setCurrentDate(today);
                                            handleDateClick(today.getDate());
                                            setSelectedDate(today);
                                          }}
                                          className="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-600 transition duration-200"
                                        >
                                          Today
                                        </button>
                                      </div>

                                      {selectedDate && (
                                      <div className="mt-4">
                                        <h3 className="text-lg font-semibold mb-4">
                                          Available Times for {format(selectedDate, "dd-MM-yyyy")}
                                        </h3>
                                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                                          {timeSlots?.map((slot, index) => {
                                            const [hours, minutes] = slot.split(":");
                                            const slotDate = new Date(selectedDate);
                                            slotDate.setHours(parseInt(hours), parseInt(minutes), 0);
                                            const isPast = slotDate < new Date();

                                            return (
                                              <button
                                                type="button"
                                                key={index}
                                                onClick={() => !isPast && handleTimeSelect(slot)}
                                                disabled={isPast}
                                                className={`
                                                  py-3 px-4 rounded-xl text-sm font-semibold transition-all duration-200
                                                  ${
                                                    isPast
                                                      ? "bg-gray-100 text-gray-400 cursor-not-allowed opacity-60"
                                                      : selectedTime === slot
                                                      ? "bg-blue-600 text-white shadow-md transform scale-105"
                                                      : "bg-white text-gray-800 hover:bg-blue-50 hover:text-blue-600 border border-gray-200"
                                                  }
                                                `}
                                              >
                                                <div className="flex flex-col items-center space-y-1">
                                                  <span>{slot}</span>
                                                  <span className="text-xs font-normal">
                                                    {isPast ? "Not Available" : "Available"}
                                                  </span>
                                                </div>
                                              </button>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                  <div className=" mx-auto p-6 border border-gray-300 ">
                    <h2 className="text-xl font-bold mb-4">
                      Your Personal Details
                    </h2>
                    <p className="text-sm text-gray-600 mb-4">
                      Please provide your address and contact details
                    </p>
                    <div className="w-full mx-auto bg-white rounded-lg p-8">
                      {/* Radio Buttons */}
                      <div className="flex items-center space-x-6 mb-6">
                        <label className="flex items-center">
                          <input
                            type="radio"
                            name="userType"
                            value="existing"
                            checked={userType === "existing"}
                            onChange={() => handleUserTypeChange("existing")}
                            className="mr-2"
                          />
                          Existing User
                        </label>
                        {/* Conditionally render New User radio button only if not logged in */}
                        {!isLoggedIn && (
                          <label className="flex items-center">
                            <input
                              type="radio"
                              name="userType"
                              value="new"
                              checked={userType === "new"}
                              onChange={() => handleUserTypeChange("new")}
                              className="mr-2"
                            />
                            New User
                          </label>
                        )}
                      </div>
                      {isLoggedIn ? (
                        <div className="max-w-lg mx-auto bg-white rounded-lg shadow-lg p-6 mt-6 transform transition-all ">
                          <div className="flex justify-between items-center mb-4">
                            <h2 className="text-xl font-semibold text-green-600">
                              You are logged innn!
                            </h2>
                            <button
                              onClick={handleLogout}
                              className="px-4 py-2 bg-red-500 text-white rounded-md shadow-md hover:bg-red-600 transition duration-200 text-sm"
                            >
                              Logout
                            </button>
                          </div>
                          {getuserdataa ? (
                            <div className="space-y-4">
                              <div className="flex items-center space-x-3">
                                <span className="font-medium text-gray-700 w-32">
                                  Name:
                                </span>
                                <p className="text-gray-800">{`${getuserdataa?.first_name} ${getuserdataa?.last_name}`}</p>
                              </div>
                              <div className="flex items-center space-x-3">
                                <span className="font-medium text-gray-700 w-32">
                                  Email:
                                </span>
                                <p className="text-gray-800">
                                  {getuserdataa?.user_email}
                                </p>
                              </div>
                              <div className="flex items-center space-x-3">
                                <span className="font-medium text-gray-700 w-32">
                                  Phone:
                                </span>
                                <p className="text-gray-800">
                                  {getuserdataa?.phone || "N/A"}
                                </p>
                              </div>
                              <div className="flex items-center space-x-3">
                                <span className="font-medium text-gray-700 w-32">
                                  Address:
                                </span>
                                <p className="text-gray-800">
                                  {getuserdataa?.address ||
                                    getuserdataa?.street_address ||
                                    "N/A"}
                                </p>
                              </div>
                              <div className="flex items-center space-x-3">
                                <span className="font-medium text-gray-700 w-32">
                                  Zip Code:
                                </span>
                                <p className="text-gray-800">
                                  {getuserdataa?.zip || "N/A"}
                                </p>
                              </div>
                              <div className="flex items-center space-x-3">
                                <span className="font-medium text-gray-700 w-32">
                                  City:
                                </span>
                                <p className="text-gray-800">
                                  {getuserdataa?.city || "N/A"}
                                </p>
                              </div>
                            </div>
                          ) : (
                            <div className="space-y-4">
                              <h1 className="text-lg"> But Only user Login </h1>
                            </div>
                            // <p className="text-gray-500 text-center">Loading user details...</p>
                          )}
                        </div>
                      ) : (
                        // Show this if user is NOT logged in
                        <>
                          {userType === "existing" ? (
                            <div>
                              <div className="space-y-5">
                                <div>
                                  <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-700 mb-1"
                                  >
                                    Email address
                                  </label>
                                  <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 transition"
                                    placeholder="Enter your email"
                                  />
                                </div>
                                <div className="relative">
                                  <label
                                    htmlFor="password"
                                    className="block text-sm font-medium text-gray-700 mb-1"
                                  >
                                    Password
                                  </label>
                                  <input
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    value={password}
                                    onChange={(e) =>
                                      setPassword(e.target.value)
                                    }
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 transition pr-10"
                                    placeholder="Enter your password"
                                  />
                                  <button
                                    type="button"
                                    className="absolute right-3 top-9 text-gray-500"
                                    onClick={() =>
                                      setShowPassword(!showPassword)
                                    }
                                  >
                                    {showPassword ? (
                                      <EyeOffIcon size={20} />
                                    ) : (
                                      <EyeIcon size={20} />
                                    )}
                                  </button>
                                </div>
                                <div className="flex justify-center">
                                  <button
                                    onClick={handleLogin}
                                    disabled={loading}
                                    className={`w-32 bg-blue-500 text-white py-2 rounded-lg shadow-md hover:bg-blue-600 transition text-sm flex justify-center items-center ${
                                      loading
                                        ? "opacity-50 cursor-not-allowed"
                                        : ""
                                    }`}
                                  >
                                    {loading ? (
                                      <FadeLoader
                                        height="15"
                                        width="5"
                                        color="#ffffff"
                                      />
                                    ) : (
                                      "Log in"
                                    )}
                                  </button>
                                </div>
                              </div>
                              {error && (
                                <p className="text-center text-sm mt-4 text-red-500">
                                  {error}
                                </p>
                              )}
                              {successMessage && (
                                <p className="text-center text-sm mt-4 text-green-500">
                                  {successMessage}
                                </p>
                              )}
                            </div>
                          ) : (
                          
                            <div className="grid grid-cols-1 gap-4 mb-6 p-6 bg-white shadow-lg rounded-lg max-w-lg mx-auto">
                            {/* Email */}
                          <div>
                          <input
                            type="email"
                            name="email"
                            placeholder="Preferred Email"
                            value={userDetails.email || ""}
                            onChange={handleUserDetailsChange}
                            className="border p-2 rounded-md w-full"
                          />
                          {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                        </div>

                        {/* Password */}
                        <div>
                          <input
                            type="password"
                            name="password"
                            placeholder="Preferred Password"
                            value={userDetails.password || ""}
                            onChange={handleUserDetailsChange}
                            className="border p-2 rounded-md w-full"
                          />
                          {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>}
                        </div>

                        {/* First Name and Last Name */}
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <input
                              type="text"
                              name="firstName"
                              placeholder="First Name"
                              value={userDetails.firstName || ""}
                              onChange={handleUserDetailsChange}
                              className="border p-2 rounded-md"
                            />
                            {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
                          </div>
                          <div>
                            <input
                              type="text"
                              name="lastName"
                              placeholder="Last Name"
                              value={userDetails.lastName || ""}
                              onChange={handleUserDetailsChange}
                              className="border p-2 rounded-md"
                            />
                            {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
                          </div>
                        </div>

                        {/* Phone and Street Address */}
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <input
                              type="text"
                              name="phone"
                              placeholder="Phone"
                              value={userDetails.phone || ""}
                              onChange={handleUserDetailsChange}
                              className="border p-2 rounded-md"
                            />
                            {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
                          </div>
                          <div>
                            <input
                              type="text"
                              name="streetAddress"
                              placeholder="Street Address"
                              value={userDetails.streetAddress || ""}
                              onChange={handleUserDetailsChange}
                              className="border p-2 rounded-md w-full"
                            />
                            {errors.streetAddress && <p className="text-red-500 text-sm mt-1">{errors.streetAddress}</p>}
                          </div>
                        </div>

                        {/* Zip Code, City, and State */}
                        <div className="grid grid-cols-3 gap-4">
                          <div>
                            <input
                              type="text"
                              name="zipCode"
                              placeholder="Zip Code"
                              value={userDetails.zipCode || ""}
                              onChange={handleUserDetailsChange}
                              className="border p-2 rounded-md"
                            />
                            {errors.zipCode && <p className="text-red-500 text-sm mt-1">{errors.zipCode}</p>}
                          </div>
                          <div>
                            <input
                              type="text"
                              name="city"
                              placeholder="City"
                              value={userDetails.city || ""}
                              onChange={handleUserDetailsChange}
                              className="border p-2 rounded-md"
                            />
                            {errors.city && <p className="text-red-500 text-sm mt-1">{errors.city}</p>}
                          </div>
                          <div>
                            <input
                              type="text"
                              name="state"
                              placeholder="State"
                              value={userDetails.state || ""}
                              onChange={handleUserDetailsChange}
                              className="border p-2 rounded-md"
                            />
                            {errors.state && <p className="text-red-500 text-sm mt-1">{errors.state}</p>}
                          </div>
                        </div>
                            {/* Special Requests */}
                            <textarea
                              name="specialRequests"
                              placeholder="Special Requests (Notes)"
                              value={userDetails.specialRequests || ""}
                              onChange={handleUserDetailsChange}
                              className="border p-2 rounded-md w-full"
                              rows="3"
                            ></textarea>
                          
                            {/* Vacuum Cleaner */}
                            <div className="flex justify-between items-center mb-4">
                              <span className="text-gray-700">Do you have a vacuum cleaner?</span>
                              <div className="flex space-x-4">
                                <label className="flex items-center space-x-1">
                                  <input
                                    type="radio"
                                    name="vacuum"
                                    value="yes"
                                    checked={vacuum === "yes"}
                                    onChange={() => setVacuum("yes")}
                                    className="accent-blue-500"
                                  />
                                  <span>Yes</span>
                                </label>
                                <label className="flex items-center space-x-1">
                                  <input
                                    type="radio"
                                    name="vacuum"
                                    value="no"
                                    checked={vacuum === "no"}
                                    onChange={() => setVacuum("no")}
                                    className="accent-gray-500"
                                  />
                                  <span>No</span>
                                </label>
                              </div>
                            </div>
                          
                            {/* Parking */}
                            <div className="flex justify-between items-center mb-4">
                              <span className="text-gray-700">Do you have parking?</span>
                              <div className="flex space-x-4">
                                <label className="flex items-center space-x-1">
                                  <input
                                    type="radio"
                                    name="parking"
                                    value="yes"
                                    checked={parking === "yes"}
                                    onChange={() => setParking("yes")}
                                    className="accent-blue-500"
                                  />
                                  <span>Yes</span>
                                </label>
                                <label className="flex items-center space-x-1">
                                  <input
                                    type="radio"
                                    name="parking"
                                    value="no"
                                    checked={parking === "no"}
                                    onChange={() => setParking("no")}
                                    className="accent-gray-500"
                                  />
                                  <span>No</span>
                                </label>
                              </div>
                            </div>
                          
                            {/* How will we get in? */}
                            <div className="mb-4">
                              <label className="block text-gray-700 mb-2">How will we get in?</label>
                              <select
                                value={access}
                                onChange={(e) => setAccess(e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded-lg"
                              >
                                <option value="home">I'll be at home</option>
                                <option value="please">Please call me</option>
                                <option value="doorman">The key is with the doorman</option>
                                <option value="other">Other</option>
                              </select>
                            </div>
                          
                            {/* Submit Button */}
                            <button
                              onClick={handleSubmitdata}
                              className="bg-blue-500 text-white p-2 rounded-md w-full"
                            >
                              Booked And New User Created
                            </button>
                          </div>
                          )}
                        </>
                      )}
                    </div>
                    <div className="max-w-md mx-auto border rounded-lg shadow-lg mt-5 p-5 bg-white">
                      <h3 className="text-lg font-semibold mb-3">
                        Apply Promo Code
                      </h3>
                      <div className="flex gap-2">
                        <input
                          type="text"
                          value={promoCode}
                          onChange={(e) => setPromoCode(e.target.value)}
                          placeholder="Enter promo code"
                          className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <button
                          type="button"
                          onClick={handleApplyPromoCode}
                          className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                        >
                          Apply
                        </button>
                      </div>

                      {/* Error Message */}
                      {error && <p className="text-red-600 mt-2">{error}</p>}

                      {/* Success Message & Cancel Button */}
                      {appliedPromoCode && (
                        <div className="flex justify-between items-center mt-2 p-2 bg-green-100 rounded-md">
                          <p className="text-green-700">
                            Promo code "{appliedPromoCode.coupon_code}" applied!
                            ({appliedPromoCode.coupon_value}
                            {appliedPromoCode.coupon_type === "P"
                              ? "%"
                              : "$"}{" "}
                            off)
                          </p>
                          <button
                            type="button"
                            onClick={handleCancelPromo}
                            className="text-red-600 font-semibold hover:underline"
                          >
                            Cancel
                          </button>
                        </div>
                      )}
                    </div>

                  

                    {/* Payment Method */}
                    <div className="mb-6">
                      <h3 className="font-bold mb-2">
                        Preferred Payment Method
                      </h3>

                      {/* Pay Locally option */}
                      <label className="flex items-center">
                        <input
                          type="radio"
                          name="paymentMethod"
                          value="payLocally"
                          checked={paymentMethod === "payLocally"}
                          onChange={handlePaymentChange}
                          className="mr-2"
                        />
                        Pay Locally
                      </label>

                      {/* Pay Online option */}
                      <label className="flex items-center ">
                        <input
                          type="radio"
                          name="paymentMethod"
                          value="payOnline"
                          checked={paymentMethod === "payOnline"}
                          onChange={handlePaymentChange}
                          className="mr-2"
                        />
                        Pay Online
                      </label>
                    </div>

                    {/* Terms & Conditions */}
                    <div className="mb-6">
                      <label className="items-center flex">
                        <input
                          type="checkbox"
                          className="mr-2"
                          checked={isChecked}
                          onChange={() => setIsChecked(!isChecked)}
                        />
                        I have read and accepted the{" "}
                        <a className="text-teal-600 underline" href="#terms">
                          Terms & Conditions
                        </a>
                        .
                      </label>
                    </div>

                    <div id="terms" className="mt-4 text-sm text-gray-700">
                      <h3 className="font-semibold">Terms & Conditions</h3>
                      <p>
                        By confirming your booking, you agree to the following
                        conditions:
                      </p>
                      <ul className="list-disc list-inside">
                        <li>
                          You must make any edits or reschedule your appointment
                          at least 15 days before the selected booking date.
                        </li>
                        <li>
                          If you attempt to edit, reschedule, or cancel your
                          appointment within 15 days of the booking date, you
                          will not be able to make any changes.
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="flex justify-center mt-6">
                    <button
                      type="submit"
                      className="bg-blue-800 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-600 transition duration-300"
                    >
                      Submit Booking
                    </button>
                  </div>
                </form>
              </div>

              {isModalVisible && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
                  <div className="bg-white p-6 rounded-lg shadow-lg text-center">
                    <h2 className="text-xl font-bold text-green-600">
                      Thank You!
                    </h2>
                    <p className="mt-2">{bookingSuccessMessage}</p>
                    <p>Great! Your appointment is booked successfully.</p>
                    <p>
                      Thank you for booking your appointment with MegaClean!
                    </p>
                  </div>
                </div>
              )}

              {/* Right Section - Privacy Policy */}

              <div>
              <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-all duration-300 z-40">
                {loading && <p>Loading...</p>}
                {error && <p className="text-red-500">{error}</p>}
                {features.length > 0 ? (
                  features.map((feature, index) => (
                    <div key={index}>
                      {/* Feature Section */}
                      <div className="flex justify-center my-4 group">
                        <div
                          className={`w-14 h-14 rounded-full bg-${svgIcons[index % svgIcons.length].bg}-100 flex items-center justify-center text-${svgIcons[index % svgIcons.length].bg}-600 group-hover:bg-${svgIcons[index % svgIcons.length].bg}-600 group-hover:text-white transition-all duration-300 transform group-hover:scale-110`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-8 h-8"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d={svgIcons[index % svgIcons.length].path}
                            />
                          </svg>
                        </div>
                      </div>
                      <h2 className="text-xl font-bold text-gray-800 text-center mb-2 relative group">
                        <span
                          className={`bg-gradient-to-r from-${svgIcons[index % svgIcons.length].bg}-500 to-${svgIcons[index % svgIcons.length].bg}-700 bg-[length:0%_2px] group-hover:bg-[length:100%_2px] bg-no-repeat bg-bottom transition-all duration-500`}
                        >
                          {feature.title.toUpperCase()}
                        </span>
                      </h2>
                      <p className="text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
                        {feature.text}
                      </p>
                      <div className="border border-t mt-4 group-hover:w-full transition-all duration-500 mx-auto" />
                    </div>
                  ))
                ) : (
                  !loading && <p>No features available.</p>
                )}
              </div>
                <div className="max-w-md mx-auto border rounded-lg shadow-lg mt-10 p-5 bg-white sticky top-10">
                  <h2 className="text-xl font-bold text-center border-b pb-3 mb-4">
                    Booking Summary
                  </h2>

                  <div className="flex items-center text-sm text-black-800 mb-4">
                    <div className="flex items-center space-x-2">
                      <span className="material-icons font-bold text-black-800">
                        Calendar Today :
                      </span>
                      {selectedDate && selectedTime && (
                        <p>
                          {selectedDate} @ {selectedTime}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="material-icons font-bold text-black-900">
                      Auto Renew :
                    </span>
                    <p>{selectedFrequency}</p>
                  </div>
                  <div className="flex items-center space-x-2  text-black-900">
                    <span className="material-icons font-bold text-black-900">
                      Time duration :
                    </span>
                    <p>
                      {Math.floor(totalTime / 60)} Hours {totalTime % 60}{" "}
                      Minutes
                    </p>

                  </div>
               <div className="flex items-center space-x-2 mb-4">
                    <span className="material-icons font-bold text-black-900">
                    Payment Method :-
                    </span>
                    <p>{paymentMethod}</p>
                  </div>
                  <div className="mb-6">
                      <h3 className="font-bold mb-2">Cart Items :</h3>
                      <ul>
                        {bookingBill.map((item, idx) => (
                          <li key={idx} className="flex justify-between mb-2">
                            <span>
                              {item.name}{item.type} (x{item.qty})
                            </span>
                            <div className="flex gap-4">
                              <span>₹{item.rate}</span>
                              <span
                                onClick={() => removeItem(idx)}
                                className="text-red-500 cursor-pointer"
                              >
                                X
                              </span>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>

                  <div className="border-t pt-4 text-black-800">
                    <div className="flex justify-between font-bold mb-2">
                      <p>Sub Total :</p>
                      <p>₹{isNaN(calculateTotal()) ? 0 : calculateTotal()}</p>
                    </div>
                    <div className="flex justify-between font-bold mb-2">
                      <p>Frequently Discount :</p>
                      <p>-₹{Disamount}</p>
                    </div>
                    {appliedPromoCode && (
                      <div className="flex justify-between font-bold mb-2">
                        <p>Promo Code ({appliedPromoCode.coupon_code}) :</p>
                        <p>-₹{promoDiscount}</p>
                      </div>
                    )}
                    <div className="flex font-bold justify-between mb-4">
                      <p>Tax :</p>
                      <p>₹{tax}</p>
                    </div>
                    <div className="flex justify-between font-bold text-lg">
                      <p>Total :</p>
                      <p>₹{parseFloat(text).toFixed(2)}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      
    </div>
  );
};

export default MyBookingPage;


//ye code abhi mene 11-04-2025 me abhi thoda changes ke code 

// import React, { useState, useEffect,useRef } from "react";
// import { addHours } from "date-fns";
// import { EyeIcon, EyeOffIcon } from "lucide-react";

// import { Link, useNavigate } from "react-router-dom";
// import {
//   format,
//   addMonths,
//   subMonths,
//   startOfWeek,
//   endOfWeek,
//   addDays,
//   subDays,
// } from "date-fns";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import image1 from "../assets/house.png";
// import fridgeCleaning from "../assets/fridge.png";
// import ovenCleaning from "../assets/oven.png";
// import windowCleaning from "../assets/windows.png";
// import Bed from "../assets/beds.png";
// import axios from "axios";
// import { BaseUrl } from "../App";
// 
// import { Circles } from "react-loader-spinner";

// import { useAuth } from "../components/AuthContext";

// const MyBookingPage = () => {
//   const { isAuthenticated } = useAuth();

//   const [email, setEmail] = useState(""); // State for email input
//   const [password, setPassword] = useState(""); // State for password input
//   const [UserTypelocal, setUserTypelocal] = useState(null);
//   const [currentMonth, setCurrentMonth] = useState(new Date());
//   const [activeView, setActiveView] = useState("month"); // Manage active view: 'month', 'week', or 'day'
//   const [showModal, setShowModal] = useState(false);
//   const [isChecked, setIsChecked] = useState(false);
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [getidbyadmin, setgetidbyadmin] = useState(null);
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [selectedOption, setSelectedOption] = useState("");
//   // const [crmgetdata, setCrmgetdata] = useState([]);
//   console.log(getidbyadmin);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showBookingSummary, setShowBookingSummary] = useState(false);
//   const [showBookingSummary2, setShowBookingSummary2] = useState(false);
//   const [isServiceOpen, setIsServiceOpen] = useState(false); // Toggle "Choose Services"
//   const [isCalendarOpen, setIsCalendarOpen] = useState(false); // Toggle Calendar panel
//   const [isFormOpen, setIsFormOpen] = useState(false);
//   // const [selectedOption, setSelectedOption] = useState("");
//   const [userId, setUserId] = useState(null);
//   const [bookingSuccessMessage, setBookingSuccessMessage] = useState("");
//   const [daySelected, setDaySelected] = useState(null); // Track selected day
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [loading, setLoading] = useState(false);
//   // const [apiCallsPending, setApiCallsPending] = useState(0)
//   const [successMessage, setSuccessMessage] = useState("");
//   const [error, setError] = useState("");
//   const [allServices, setallServices] = useState([]);
//   console.log(allServices);
//  // Add these state variables at the top with your existing states
// const [settings, setSettings] = useState({});
// const [zipCodeError, setZipCodeError] = useState("");
//   const [useriddata, setuseriddata] = useState(null);
//   console.log(useriddata);
//   const [idpromocode, setidpromocode] = useState(null);
//   const [optiondata, setoptiondata] = useState([]);
//   const [personalDetails, setPersonalDetails] = useState({
//     streetAddress: "",
//     zipCode: "",
//     city: "",
//     state: "",
//   });
//   const [appointmentDetails, setAppointmentDetails] = useState({
//     streetAddress: "",
//     zipCode: "",
//     city: "",
//     state: "",
//   });
//   const [hoveredEvent, setHoveredEvent] = useState(null);
//   const [userType, setUserType] = useState("new");
//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   useEffect(() => {
//     const user = sessionStorage.getItem("userId");
//     if (user) {
//       setuserid(user); // This sets `useridd`, not `useriddata`
//       setIsLoggedIn(true);
//     } else {
//       setIsLoggedIn(false);
//     }
//   }, []);

//   const [sameAsAbove, setSameAsAbove] = useState(false);
//   const [selectedFrequency, setSelectedFrequency] = useState("");
//   const [selectedDiscount, setSelectedDiscount] = useState(0);
//   const [Distext, setSelectedDistext] = useState(10);
//   const [text, setText] = useState();
//   const navigate = useNavigate();
//   const [selectedProvider, setSelectedProvider] = useState(null);
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [selectedTime, setSelectedTime] = useState(null);
//   const [selectedservices, setselectedservices] = useState(0);
//   const [showImageSection, setShowImageSection] = useState(false);
//   const [selectedService, setSelectedService] = useState(null);
//   const [residential, setResidential] = useState(false);
//   const [commercial, setCommercial] = useState(false);
//   const [bookingBill, setBookingBill] = useState([]);
//   console.log(bookingBill);
//   const [bedroom, setBedroom] = useState({});
//   const [bathroom, setBathroom] = useState(0);
//   const [quantities, setQuantities] = useState([0, 0, 0]);
//   const [officeresidential, setofficeResidential] = useState(false);
//   const [officecommercial, officesetCommercial] = useState(false);
//   const [showForm, setShowForm] = useState(false);
//   const [currentDate, setCurrentDate] = useState(new Date());
//   const [bookedSlots, setBookedSlots] = useState({});
//   const [selectedMethod, setSelectedMethod] = useState(null);
//   console.log(selectedMethod);
//   const [bookingappointment, setbookingappointment] = useState([]);
//   console.log(bookingappointment);
//   const [propertyQuantities, setPropertyQuantities] = useState({
//     Build_walls: 0,
//     Build_doors: 0,
//     Build_windows: 0,
//   });
//   const [officeQuantities, setOfficeQuantities] = useState({
//     desk: 0,
//     window: 0,
//   });
//   const [tax, settax] = useState(0);
//   const [damagedFloors, setDamagedFloors] = useState(0);
//   const [doorJams, setDoorJams] = useState(0);
//   const [packing, setPacking] = useState(0);
//   const [storeroom, setStoreroom] = useState(0);
//   const [area, setArea] = useState(0);
//   const [timeSlots, setTimeSlots] = useState([]);
//   console.log(timeSlots);
//   const [officearea, setOfficeArea] = useState(0);
//   const [extraDamagedFloors, setExtraDamagedFloors] = useState(0);
//   const [extraDoorJams, setExtraDoorJams] = useState(0);
//   const [Disamount, setDisamount] = useState(0);
//   const [officeextraDamagedFloors, setofficeExtraDamagedFloors] = useState(0);
//   const [officeextraDoorJams, setofficeExtraDoorJams] = useState(0);
//   const [adminData, setAdminData] = useState(null);
//   const [calenderdata, setcalenderdata] = useState([]);
//   const [Services_frequently_discount, setServices_frequently_discount] =
//     useState([]);
//   const [icon, setIcon] = useState("+"); // State to control the icon (either "+" or "-")
//   const [activeTab, setActiveTab] = useState("Residential");
//   const [formData, setFormData] = useState({
//     serviceLocation: "",
//     zipCode: "",
//     selectedService: "",
//     image: image1,
//     showHouseOptions: false,
//     showPlumbingOptions: false,
//     showCarpenterOptions: false,
//     showOfficeOptions: false,

//     bedroomCount: "",
//     bathroomCount: "",
//   });
//   const [crmgetdata, setcrmgetdata] = useState([]);
//   const [dayseleted, setdayseleted] = useState(null);
//   const [timeSelected, settimeSelected] = useState(null);
//   const [userDetails, setUserDetails] = useState({
//     id: "",
//     email: "",
//     password: "",
//     firstName: "",
//     lastName: "",
//     phone: "",
//     streetAddress: "",
//     city: "",
//     state: "",
//     zipCode: "",
//     postalCode: "",
//     specialRequests: "",
//   });
//   const [databooking, setdatabooking] = useState([]);
//   const [activeService, setActiveService] = useState(null);
//   const [serviceCounts, setServiceCounts] = useState({});
//   const extraServices = [
//     { image: fridgeCleaning, name: "Fridge Cleaning", price: "$50" },
//     { image: ovenCleaning, name: "Oven Cleaning", price: "$40" },
//     { image: windowCleaning, name: "Inside Window Cleaning", price: "$30" },
//   ];
//   const [paymentMethod, setPaymentMethod] = useState(""); // Set default to 'payLocally'
//   const [showAllEvents, setShowAllEvents] = useState(false);
//   const [totalTime, setTotalTime] = useState(0); // To track total time
//   const [detailsdata, setDetailsdata] = useState({});
//   console.log(detailsdata);
//   const [Detailsiud, setDetailsiud] = useState(null); // Set default to
//   // const [showForm, setShowForm] = useState(false);
//   const [rejectReason, setRejectReason] = useState("");
//   const [showRescheduleModal, setShowRescheduleModal] = useState(false);
//   const [amount, setAmount] = useState("");
//   const [notes, setNotes] = useState("");
//   const [rescheduleDate, setRescheduleDate] = useState(""); // Changed name here
//   const [rescheduledData, setRescheduledData] = useState(null);
//   const [subtotale, setsubtotale] = useState(0);
//   const [isBookingComplete, setIsBookingComplete] = useState(false);
//   const [useridd, setuserid] = useState(null);
//   const [promoCode, setPromoCode] = useState("");
//   const [appliedPromoCode, setAppliedPromoCode] = useState(null);
//   const [promoCodes, setPromoCodes] = useState([]);
//   const [promoDiscount, setPromoDiscount] = useState(0);
//   const [vacuum, setVacuum] = useState("no");
//   const [parking, setParking] = useState("no");
//   const [access, setAccess] = useState("home");
//   const handleRescheduleClick = () => {
//     setShowRescheduleModal(true);
//   };

//   const fetchSettings = async () => {
//     setLoading(true); // Use your existing loading state
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/settings.php`,
//         {
//           action: "get_all_settings",
//           api_key: "1",
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
  
//       if (response.data.status === "true" && response.data.statuscode === 200) {
//         const fetchedSettings = response.data.response.reduce((acc, item) => {
//           if (item.option_name === "ct_postal_code") {
//             acc[item.option_name] = item.postalcode; // Store postal codes as a comma-separated string
//           } else {
//             acc[item.option_name] = item.option_value;
//           }
//           return acc;
//         }, {});
  
//         setSettings((prevSettings) => ({
//           ...prevSettings,
//           ...fetchedSettings,
//         }));
//       } else {
//         throw new Error(response.data.response || "Failed to fetch settings");
//       }
//     } catch (error) {
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };
//   // Call fetchSettings on component mount
// useEffect(() => {
//   fetchSettings();
// }, []);
// const handleZipCodeChange = (e) => {
//   const value = e.target.value;
//   setFormData({
//     ...formData,
//     zipCode: value,
//   });

//   // Split postal codes into an array for comparison
//   const validZipCodes = settings["ct_postal_code"]?.split(",") || [];

//   // Check if the entered zip code matches any valid postal code
//   if (value.length > 0 && !validZipCodes.includes(value)) {
//     setZipCodeError("Our service is not available at your location");
//   } else {
//     setZipCodeError(""); // Clear error if valid or empty
//   }
// };
//   const fetchTimeSlots = async (date) => {
//     // Pehle check karo ke staff_id (getidbyadmin) available hai ya nahi
//     if (!getidbyadmin) {
//       alert("Staff ID missing! Please select a provider.");
//       return;
//     }

//     if (!date) {
//       alert("Please select a date.");
//       return;
//     }

//     const formattedDate = format(date, "dd-MM-yyyy");

//     const payload = {
//       action: "get_slots",
//       api_key: "1",
//       selected_date: formattedDate,
//       staff_id: getidbyadmin, // Ensure ID is present
//     };
//     setLoading(true);
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/slots.php`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       console.log(response.data.response);
//       setTimeSlots(response.data.response);
//     } catch (error) {
//       console.error("Error fetching time slots:", error);
//       setTimeSlots([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // useEffect only depends on selectedDate now
//   useEffect(() => {
//     if (selectedDate) {
//       fetchTimeSlots(selectedDate);
//     }
//   }, [selectedDate]);

//   // Close modal
//   const closeRescheduleModal = () => {
//     // Changed name here
//     setShowRescheduleModal(false);
//   };

//   const handleUpdate = (e, rescheduleDate) => {
//     e.preventDefault();

//     // Validate the rescheduleDate
//     if (!rescheduleDate || isNaN(new Date(rescheduleDate).getTime())) {
//       alert("Invalid date. Please provide a valid date.");
//       return;
//     }

//     // Format the reschedule date into a readable format
//     const formattedDate = new Date(rescheduleDate)
//       .toISOString()
//       .slice(0, 19)
//       .replace("T", " ");

//     // Data to save
//     const dataToSave = {
//       rescheduleDate: formattedDate,
//     };

//     // Log data to the console (optional)
//     console.log("Rescheduled Data: ", dataToSave);

//     // Save the data into state (without displaying it on the page)
//     setRescheduledData(dataToSave);

//     // Optionally, handle additional actions (like resetting the form or other states)
//     closeRescheduleModal();
//   };

//   const handleRejectClick = () => {
//     setShowForm(!showForm); // Toggle form visibility
//   };

//   const handleReject = async (id, e) => {
//     setLoading(true);

//     e.preventDefault();
//     console.log("Reject Reason:", rejectReason, id);
//     // Add your logic here to handle the reject reason
//     try {
//       // Define the request payload
//       const payload = {
//         action: "reject_appointment", // Action to fetch all services
//         api_key: 1,
//         order_id: id,
//         reject_reason: rejectReason,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_reject.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         setSuccessMessage("Reject Appointment Successfully!");
//         const services = response.data;
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }

//     setShowForm(false); // Close the form after submission
//   };

//   const handlePaymentChange = (e) => {
//     setPaymentMethod(e.target.value);
//   };
//   const handleImageSectionToggle = () => {
//     setShowImageSection((prevState) => !prevState); // Toggle the visibility of the image section
//     setIcon((prevIcon) => (prevIcon === "+" ? "-" : "+")); // Toggle the icon between "+" and "-"
//   };
//   const editNavigate = () => {
//     navigate("editcustomer");
//   };

//   const handleBedroomChange = (unitId, value) => {
//     setBedroom((prevSelections) => ({
//       ...prevSelections,
//       [unitId]: value,
//     }));
//   };

//   // const addItemToBill = (
//   //   id,
//   //   itemName,
//   //   quantity,
//   //   pricePerItem,
//   //   serviceTitle
//   // ) => {
//   //   setBookingBill((prevBill) => {
//   //     const existingItemIndex = prevBill.findIndex(
//   //       (item) => item.name === itemName
//   //     );

//   //     let updatedBill;

//   //     if (existingItemIndex !== -1) {
//   //       updatedBill = [...prevBill];
//   //       updatedBill[existingItemIndex].quantity += quantity;
//   //       updatedBill[existingItemIndex].price += quantity * pricePerItem;
//   //     } else {
//   //       updatedBill = [
//   //         ...prevBill,
//   //         {
//   //           method_id: selectedMethod.method_id,
//   //           service_id: selectedService,
//   //           unit_id: id,
//   //           type: "unit",
//   //           name: itemName,
//   //           service_title: serviceTitle, // Add this for frontend display
//   //           qty: quantity,
//   //           rate: quantity * pricePerItem,
//   //         },
//   //       ];
//   //     }

//   //     // Calculate the new total time (add 60 minutes for each new unit added)
//   //     const newTotalTime =
//   //       prevBill.reduce(
//   //         (time, item) => time + (item.qty ? item.qty : 0) * 60,
//   //         0
//   //       ) +
//   //       quantity * 60;

//   //     // Update the state for both the bill and total time
//   //     setTotalTime(newTotalTime);
//   //     return updatedBill;
//   //   });
//   // };
//   const addItemToBill = (id, itemName, quantity, pricePerItem, serviceTitle) => {
//     setBookingBill((prevBill) => {
//       // Find if the item already exists in the bill
//       const existingItemIndex = prevBill.findIndex(
//         (item) => item.unit_id === id && item.name === itemName
//       );
  
//       let updatedBill;
  
//       if (existingItemIndex !== -1) {
//         // If the item exists, replace it with the new quantity
//         updatedBill = [...prevBill];
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             method_id: selectedMethod.method_id,
//             service_id: selectedService,
//             unit_id: id,
//             type: "unit",
//             name: itemName,
//             service_title: serviceTitle,
//             qty: quantity, // Replace the old quantity with the new one
//             rate: quantity * pricePerItem, // Recalculate the price
//           };
//         } else {
//           // If quantity is 0, remove the item
//           updatedBill.splice(existingItemIndex, 1);
//         }
//       } else if (quantity > 0) {
//         // If the item doesn’t exist and quantity > 0, add it as a new entry
//         updatedBill = [
//           ...prevBill,
//           {
//             method_id: selectedMethod.method_id,
//             service_id: selectedService,
//             unit_id: id,
//             type: "unit",
//             name: itemName,
//             service_title: serviceTitle,
//             qty: quantity,
//             rate: quantity * pricePerItem,
//           },
//         ];
//       } else {
//         // If quantity is 0 and item doesn’t exist, return the bill unchanged
//         updatedBill = [...prevBill];
//       }
  
//       // Recalculate total time based on the updated bill
//       const newTotalTime = updatedBill.reduce(
//         (time, item) => time + (item.qty || 0) * 60,
//         0
//       );
//       setTotalTime(newTotalTime);
  
//       return updatedBill;
//     });
//   };
//   const calculateTotal = () => {
//     // Existing calculation for first two services
//     const existingTotal = bookingBill.reduce(
//       (total, item) => total + item.rate,
//       0
//     );

//     // Calculation for third service
//     if (selectedService === 3) {
//       const propertyTotal =
//         propertyQuantities.walls * 10 +
//         propertyQuantities.doors * 10 +
//         propertyQuantities.windows * 10 +
//         damagedFloors * 10 +
//         doorJams * 10;
//       const areaTotal = area * 2 + extraDamagedFloors * 10 + extraDoorJams * 10;
//       return existingTotal + propertyTotal + areaTotal;
//     }
//     if (selectedService === 4) {
//       const officeTotal =
//         (officeQuantities.rooms || 0) * 10 +
//         (officeQuantities.bathrooms || 0) * 10 +
//         (officeQuantities.kitchens || 0) * 10 +
//         (packing || 0) * 10 +
//         (storeroom || 0) * 10;

//       const areaTotal =
//         (officearea || 0) * 2 +
//         (officeextraDamagedFloors || 0) * 10 +
//         (officeextraDoorJams || 0) * 10;

//       return existingTotal + officeTotal + areaTotal;
//     }
//     return existingTotal;
//   };

//   // const calculateDiscountedTotal = () => {
//   //   const total = calculateTotal(); // Get the total price
//   //   setsubtotale(total);
//   //   if (isNaN(total)) {
//   //     console.error("Total calculation resulted in NaN:", total);
//   //     return 0; // Return 0 if the total is invalid
//   //   }
//   //   const discountPercentage = selectedDiscount; // Get the discount based on the frequency
//   //   const discountAmount = (total * discountPercentage) / 100; // Calculate the discount
//   //   const totalAfterDiscount = total - discountAmount; // Subtract the discount from the total
//   //   // const text = totalAfterDiscount + 10 ;
//   //   const taxsum = total === 0 ? 0 : 10;

//   //   const finalTotal = totalAfterDiscount;
//   //   setDisamount(discountAmount);
//   //   settax(taxsum);
//   //   setText(finalTotal);

//   //   return totalAfterDiscount;
//   // };

//   const fetchPromoCodes = async () => {
//     try {
//       const payload = {
//         action: "get_all_coupons",
//         api_key: "1",
//       };

//       const response = await axios.post(
//         `${BaseUrl}/backend/api/promocode.php`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.data.status === "true") {
//         setPromoCodes(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching promo codes:", error);
//     }
//   };

//   // Add this useEffect to fetch promocodes on component mount
//   useEffect(() => {
//     fetchPromoCodes();
//   }, []);

//   // Add this function to apply promocode (place it near your other handler functions)
//   const handleApplyPromoCode = () => {
//     if (!selectedService || selectedService.length === 0) {
//       alert("Please select at least one service");
//       return;
//     }

//     const today = new Date();
//     const foundPromo = promoCodes.find(
//       (promo) =>
//         promo.coupon_code === promoCode &&
//         promo.status === "on" &&
//         new Date(promo.coupon_expiry) >= today &&
//         parseInt(promo.coupon_used) < parseInt(promo.coupon_limit)
      
//     );

//     if (foundPromo) {
//       setidpromocode(foundPromo.id)
//       setAppliedPromoCode(foundPromo);
//       const discountValue =
//         foundPromo.coupon_type === "P"
//           ? (calculateTotal() * parseFloat(foundPromo.coupon_value)) / 100
//           : parseFloat(foundPromo.coupon_value);
//       setPromoDiscount(discountValue);
//       setSuccessMessage("Promo code applied successfully!");
//       setError("");
//     } else {
//       setAppliedPromoCode(null);
//       setPromoDiscount(0);
//       setError("Invalid or expired promo code");
//     }
//   };

//   const handleCancelPromo = () => {
//     setPromoDiscount(0);
//     setAppliedPromoCode(null);
//     setPromoCode(""); // Reset input field
//     setError(""); // Clear error messages
//   };

//   // Modified calculateDiscountedTotal function
//   const calculateDiscountedTotal = () => {
//     const total = calculateTotal();
//     setsubtotale(total);

//     if (isNaN(total)) {
//       console.error("Total calculation resulted in NaN:", total);
//       return 0;
//     }

//     const frequencyDiscountPercentage = selectedDiscount;
//     const frequencyDiscountAmount = (total * frequencyDiscountPercentage) / 100;
//     const totalAfterFrequencyDiscount = total - frequencyDiscountAmount;

//     const taxsum = total === 0 ? 0 : 10;
//     const finalTotal = totalAfterFrequencyDiscount - promoDiscount + taxsum;

//     setDisamount(frequencyDiscountAmount);
//     settax(taxsum);
//     setText(finalTotal);

//     return finalTotal;
//   };

//   // Add useEffect to recalculate when promoDiscount changes
//   useEffect(() => {
//     calculateDiscountedTotal();
//   }, [
//     promoDiscount,
//     selectedDiscount,
//     bookingBill,
//     propertyQuantities,
//     area,
//     damagedFloors,
//     doorJams,
//     officeQuantities,
//     officearea,
//     packing,
//     storeroom,
//   ]);
//   const handleLogin = async (e) => {
//     e.preventDefault();

//     if (!email || !password) {
//       setError("Please fill in both email and password.");
//       return;
//     }

//     setLoading(true);
//     setError("");

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/check_login.php`,
//         {
//           action: "check_login",
//           api_key: 1,
//           email: email,
//           password: password,
//         }
//       );

//       if (response.data.status === "true") {
//         setError("");
//         const userType = response.data?.usertype;
//         const userIdFromResponse = response.data?.userId;

//         console.log(userIdFromResponse);

//         if (userType && userIdFromResponse) {
//           setUserType(userType);
//           setUserId(userIdFromResponse); // Set userId in state
//           setIsLoggedIn(true);
//           sessionStorage.setItem("userId", userIdFromResponse);
//           sessionStorage.setItem("userType", userType);
//           sessionStorage.setItem("isLoggedIn", "true");
//         } else {
//           setError("User type or user ID not found in the response.");
//         }
//       } else {
//         setError(response.data.response || "Invalid email or password.");
//       }
//     } catch (error) {
//       setError("An error occurred. Please try again later.");
//       console.error("Login error:", error.response || error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handaldeleted = async (id) => {
//     setLoading(true);

//     try {
//       // Define the request payload
//       const payload = {
//         action: "delete_booking", // Action to fetch all services
//         api_key: 1,
//         order_id: id,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         setSuccessMessage("Delete Booking Successfully!");
//         const services = response.data;
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }

//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handalconfirm_appointment = async (id) => {
//     setLoading(true);

//     console.log(id, "DADSA");
//     try {
//       // Define the request payload
//       const payload = {
//         action: "confirm_appointment", // Action to fetch all services
//         api_key: "1",
//         order_id: id,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_confirm.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         setSuccessMessage("Confirm Booking Successfully!");
//         const services = response.data;
//         console.log(services);
//         setIsBookingComplete(true);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }

//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const crmget = () => {
//     setLoading(true);

//     axios
//       .get(`${BaseUrl}/backend/api/add_customer.php?action=getuser`)
//       .then((response) => {
//         console.log(response);
//         if (response.data.status === "true") {
//           setcrmgetdata(response.data.data);
//         } else {
//           console.log(response.data.message);
//         }
//       })
//       .catch((err) => {
//         console.log("An error occurred while fetching data");
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   const calendardata = () => {
//     setLoading(true);

//     axios
//       .get(`${BaseUrl}/backend/api/services.php?action=week_days_available`)
//       .then((response) => {
//         console.log(response);
//         if (response.data.status === "true") {
//           setcalenderdata(response.data.data);
//         } else {
//           console.log(response.data.message);
//         }
//       })
//       .catch((err) => {
//         console.log("An error occurred while fetching data");
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     const generateTimeSlots = async () => {
//       const today = new Date();
//       const currentWeek = Math.ceil(today.getDate() / 7); // Week of the month (1st, 2nd, etc.)
//       const currentDayOfWeek = today.getDay(); // Sunday = 0, Monday = 1, etc.
//       console.log(currentWeek, currentDayOfWeek);

//       // Filter schedule for the current week and weekday
//       const selectedSchedule = calenderdata.find(
//         (schedule) => schedule.provider_schedule_type === "weekly"
//         // schedule.week_id === currentWeek &&
//         // schedule.weekday_id === currentDayOfWeek &&
//         // schedule.off_day === "N"
//       );

//       console.log(selectedSchedule);

//       if (!selectedSchedule) {
//         setTimeSlots([]); // If no schedule for the day, return empty slots
//         return;
//       }

//       const dayStartTime = selectedSchedule.day_start_time;
//       const dayEndTime = selectedSchedule.day_end_time;
//       const slotDurationMinutes = 30;

//       const startTime = new Date(`1970-01-01T${dayStartTime}Z`);
//       const endTime = new Date(`1970-01-01T${dayEndTime}Z`);
//       const slots = [];
//       let currentTime = new Date(startTime);
//       let slotId = 1;

//       while (currentTime < endTime) {
//         const slotStart = new Date(currentTime);
//         const slotEnd = new Date(
//           currentTime.getTime() + slotDurationMinutes * 60000
//         );

//         const formatTime = (time) => {
//           let hours = time.getUTCHours();
//           let minutes = time.getUTCMinutes().toString().padStart(2, "0");
//           let period = hours >= 12 ? "PM" : "AM";
//           hours = hours % 12 || 12;
//           return `${hours}:${minutes} ${period}`;
//         };

//         const isToday =
//           today.toDateString() === new Date(selectedDate).toDateString();
//         const isPastSlot =
//           isToday &&
//           (today.getHours() > slotEnd.getUTCHours() ||
//             (today.getHours() === slotEnd.getUTCHours() &&
//               today.getMinutes() > slotEnd.getUTCMinutes()));

//         slots.push({
//           slot_id: slotId,
//           slot_start: formatTime(slotStart),
//           slot_end: formatTime(slotEnd),
//           disabled: isPastSlot,
//         });

//         currentTime = slotEnd;
//         slotId += 1;
//       }

//       setTimeSlots(slots);
//     };

//     generateTimeSlots();
//     const interval = setInterval(generateTimeSlots, 60000);
//     return () => clearInterval(interval);
//   }, [selectedDate, calenderdata]); // Re-run when selectedDate changes

//   useEffect(() => {
//     calendardata();
//   }, []);

//   useEffect(() => {
//     crmget();
//   }, []);

//   useEffect(() => {
//     calculateDiscountedTotal(); // Calculate discounted total whenever discount or total changes
//   }, [
//     selectedService,
//     bookingBill,
//     propertyQuantities,
//     area,
//     damagedFloors,
//     doorJams,
//     officeQuantities,
//     officearea,
//     packing,
//     storeroom,
//   ]);

//   // useEffect(() => {
//   //   const fetchAdminData = async () => {
//   //     setLoading(true);
//   //     try {
//   //       const response = await axios.get(
//   //         `${BaseUrl}/backend/api/services.php?action=getadmin`
//   //       );
//   //       console.log(response);

//   //       if (response.data.status === "true") {
//   //         setAdminData(response.data.data);
//   //       } else {
//   //         console.log(response.data.message);
//   //       }
//   //     } catch (err) {
//   //       console.error("An error occurred while fetching data:", err);
//   //       setError("Failed to fetch admin data. Please try again later.");
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   fetchAdminData();
//   // }, []);

//   useEffect(() => {
//     const fetchAdminData = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(
//           `${BaseUrl}/backend/api/services.php?action=getadmin`
//         );
//         console.log(response);
  
//         if (response.data.status === "true") {
//           // Filter admin data based on selectedService
//           const filteredAdminData = response.data.data.filter((provider) => {
//             const serviceIdsArray = provider.service_ids
//               .split(",")
//               .map((id) => id.trim()); // Split and trim the service_ids string into an array
//             return selectedService
//               ? serviceIdsArray.includes(selectedService.toString())
//               : true; // If no service selected, show all staff
//           });
//           setAdminData(filteredAdminData); // Set filtered data
//         } else {
//           console.log(response.data.message);
//         }
//       } catch (err) {
//         console.error("An error occurred while fetching data:", err);
//         setError("Failed to fetch admin data. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };
  
//     fetchAdminData();
//   }, [selectedService]); // Add selectedService as a dependency so it refetches/filters when service changes

//   useEffect(() => {
//     // Update bedrooms and bathrooms directly in the bill
//     const updateOrAddToBill = (itemName, quantity, pricePerItem) => {
//       const existingItemIndex = bookingBill.findIndex(
//         (item) => item.name === itemName
//       );

//       if (existingItemIndex !== -1) {
//         const updatedBill = [...bookingBill];
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             ...updatedBill[existingItemIndex],
//             quantity,
//             price: quantity * pricePerItem,
//           };
//         } else {
//           updatedBill.splice(existingItemIndex, 1); // Remove the item if quantity is zero
//         }
//         setBookingBill(updatedBill);
//       } else if (quantity > 0) {
//         setBookingBill([
//           ...bookingBill,
//           { type: itemName, qty: quantity, rate: quantity * pricePerItem },
//         ]);
//       }
//     };

//     updateOrAddToBill("Bedrooms", bedroom, 5);
//     updateOrAddToBill("Bathrooms", bathroom, 5);
//   }, [bedroom, bathroom]);

//   useEffect(() => {
//     if (selectedService === 3) {
//       // Initialize or reset variables related to Service 3
//       setPropertyQuantities({
//         walls: 0,
//         doors: 0,
//         windows: 0,
//       });
//       setDamagedFloors(0);
//       setDoorJams(0);
//       setArea(0);
//       setExtraDamagedFloors(0);
//       setExtraDoorJams(0);
//     }
//   }, [selectedService]); // Whenever `selectedService` changes handaldeleted  deleteallbooking

//   useEffect(() => {
//     if (selectedService === 4) {
//       // Initialize or reset variables related to Service 4
//       setOfficeQuantities({
//         rooms: 0,
//         bathrooms: 0,
//         kitchens: 0,
//       });
//       setPacking(0);
//       setStoreroom(0);
//       setOfficeArea(0);
//       setofficeExtraDamagedFloors(0);
//       setofficeExtraDoorJams(0);
//     }
//   }, [selectedService]); // Whenever `selectedService` changes

//   // const removeItem = (idx) => {
//   //   setBookingBill((prevBill) => prevBill.filter((_, index) => index !== idx));
//   // };

//   useEffect(() => {
//     const maxAddons = Math.max(
//       ...allServices.map((s) => (s.addons ? s.addons.length : 0)),
//       extraServices.length
//     );
//     setQuantities(Array(maxAddons).fill(0));
//   }, [allServices]);
  
//   const removeItem = (idx) => {
//     setBookingBill((prevBill) => {
//       const updatedBill = prevBill.filter((_, index) => index !== idx);
//       const removedItem = prevBill[idx];
  
//       // Reset the quantity in the quantities array if the removed item is an addon
//       if (removedItem.type) {
//         const addonIndex = extraServices.findIndex(
//           (addon) => addon.name === removedItem.type
//         );
//         if (addonIndex !== -1) {
//           setQuantities((prevQuantities) => {
//             const newQuantities = [...prevQuantities];
//             newQuantities[addonIndex] = 0; // Reset to 0 when removed
//             return newQuantities;
//           });
//         } else {
//           // If the addon is from a service's addons (not extraServices), find it dynamically
//           allServices.forEach((service) => {
//             if (service.addons) {
//               const serviceAddonIndex = service.addons.findIndex(
//                 (addon) => addon.addon_name === removedItem.type
//               );
//               if (serviceAddonIndex !== -1) {
//                 setQuantities((prevQuantities) => {
//                   const newQuantities = [...prevQuantities];
//                   newQuantities[serviceAddonIndex] = 0; // Reset to 0
//                   return newQuantities;
//                 });
//               }
//             }
//           });
//         }
//       }
  
//       // Recalculate total time
//       const newTotalTime = updatedBill.reduce(
//         (time, item) => time + (item.qty || 0) * 60,
//         0
//       );
//       setTotalTime(newTotalTime);
  
//       return updatedBill;
//     });
//   };
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });

//     // Log the value for the selected bedroom
//     if (name === "bedroomCount") {
//       console.log(`Selected Bedroom: ${value}`);
//     }
//   };


//     const scrollRef = useRef(null);
  
  
//     const scroll = (direction) => {
  
  
//       const container = scrollRef.current;
//       if (container) {
//         const scrollAmount = container.offsetWidth * 0.8; // Scroll 80% of container width
//         container.scrollBy({
//           left: direction === 'next' ? scrollAmount : -scrollAmount,
//           behavior: 'smooth',
//         });
//       }
//     };

//   const generateCalendar = (year, month) => {
//     const date = new Date(year, month);
//     const daysInMonth = new Date(year, month + 1, 0).getDate();
//     const startDay = new Date(year, month, 1).getDay();
//     const calendar = [];

//     let currentDay = 1;

//     for (let week = 0; week < 6; week++) {
//       const weekDays = [];

//       for (let day = 0; day < 7; day++) {
//         if (week === 0 && day < startDay) {
//           weekDays.push(null);
//         } else if (currentDay <= daysInMonth) {
//           weekDays.push(currentDay);
//           currentDay++;
//         } else {
//           weekDays.push(null);
//         }
//       }

//       calendar.push(weekDays);
//     }

//     return calendar;
//   };

//   const calendar = generateCalendar(
//     currentDate.getFullYear(),
//     currentDate.getMonth()
//   );

//   // Function to handle date selection
//   const handleDateClick = (day) => {
//     setDaySelected(day);
//     if (day) {
//       const selectedDay = new Date(
//         currentDate.getFullYear(),
//         currentDate.getMonth(),
//         day
//       );

//       // Compare only the date (year, month, day) without time, ensuring past dates are blocked
//       const today = new Date();
//       today.setHours(0, 0, 0, 0); // Reset time part to compare just the date

//       if (selectedDay < today) {
//         alert("Sorry, past date booking is not possible.");
//         return;
//       }

//       // Format the date to MM/DD/YYYY
//       const formattedDate = selectedDay.toLocaleDateString("en-US", {
//         month: "2-digit",
//         day: "2-digit",
//         year: "numeric",
//       });

//       const key = formattedDate; // Use formattedDate as the key

//       if (bookedSlots[key]?.length === timeSlots.length) {
//         alert("Sorry, this date's time slots are fully booked.");
//         return;
//       }

//       setSelectedDate(key);
//       setSelectedTime(null);
//       setShowForm(false); // Hide form initially
//     }
//   };

//   // Function to handle time slot selection
//   const handleTimeSelect = (time) => {
//     setSelectedTime(time);
//     setShowForm(true);
//   };
//   const toggleCalendarPanel = () => {
//     setIsCalendarOpen((prev) => !prev); // Toggle this panel
//     if (!isCalendarOpen) {
//       // If opening this panel
//       setIsServiceOpen(false); // Close others
//       setIsFormOpen(false);
//     }
//   };

//   const toggleFormPanel = () => {
//     setIsFormOpen((prev) => !prev); // Toggle this panel
//     if (!isFormOpen) {
//       // If opening this panel
//       setIsServiceOpen(false); // Close others
//       setIsCalendarOpen(false);
//     }
//   };
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!isChecked) {
//       alert("Please accept the Terms & Conditions before proceeding.");
//       return;
//     }

//     if (!userId && !useriddata) {
//       // Check only `userId` since it’s now the single source of truth
//       alert("Please provide user details");
//       return;
//     }

//     if (!selectedProvider?.id) {
//       alert("Please select a provider");
//       return;
//     }

//     if (!selectedDate || !selectedTime) {
//       alert("Please select date and time for appointment");
//       return;
//     }

//     if (!selectedService || selectedService.length === 0) {
//       alert("Please select at least one service");
//       return;
//     }

//     if (!paymentMethod) {
//       alert("Please select a payment method");
//       return;
//     }

//     const hasAtLeastOneUnit = bookingBill.some((item) => item.method_id);
//     if (!hasAtLeastOneUnit) {
//       alert("You must select at least one unit.");
//       setLoading(false);
//       return;
//     }

//     setLoading(true);

//     const formattedData = {
//       action: "book_appointment",
//       api_key: "1",
//       user_id: userId || useriddata, // Use `userId` directly
//       staff_id: selectedProvider?.id || "",
//       payment_method: paymentMethod,
//       // sub_total: subtotale,
//       sub_total: promoDiscount ? subtotale - promoDiscount : subtotale,
//       discount: Disamount,
//       order_duration: totalTime,
//       tax: tax,
//       booking_date_time: `${selectedDate} ${selectedTime}`,
//       service_id: selectedService,
//       method_id: selectedMethod?.method_id,
//       cart_detail: bookingBill,
//       net_amount: text,
//       recurrence_id: selectedservices,
//       freq_discount_amount: 1,
//     };

//     console.log("Formatted Booking Data:", formattedData);
//     axios
//       .post(`${BaseUrl}/backend/api/book_appointment.php`, formattedData, {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       })
//       .then((response) => {
//         console.log(response.data.status);
//         if (response.data.status === "true") {
//           setSuccessMessage("Appointment Add successfully!");
//           setIsModalVisible(true);



//           if (idpromocode) {
//             const promoData = {
//               action: "increment_coupon_used",
//               api_key: "1",
//               coupon_id: idpromocode
//             };

//             axios
//               .post("http://10.27.1.104/megaclean(20-03-2025)/megaclean/backend/api/promocode.php", promoData, {
//                 headers: {
//                   "Content-Type": "application/json",
//                 },
//               })
//               .then((promoResponse) => {
//                 console.log("Promocode incremented successfully:", promoResponse.data);
//               })
//               .catch((promoError) => {
//                 console.error("Error incrementing promocode:", promoError);
//                 // Note: Not showing alert here to avoid disrupting user experience
//               });
//           }

//           setTimeout(() => {
//             setIsModalVisible(false);
//             window.location.reload();
//           }, 5000);
//         } else {
//           console.log(response.data.response);
//         }

//         handleClosebookingSummary();
//         bookeddata();
//       })
//       .catch((error) => {
//         console.error("Error occurred while submitting:", error);
//         alert("There was an error submitting the form. Please try again.");
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };




//   const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
//   const hours = Array.from({ length: 24 }, (_, i) => `${i}:00`);

//   // Function to navigate to next month or week
//   const nextMonth = () => {
//     if (activeView === "month") {
//       setCurrentMonth(addMonths(currentMonth, 1)); // Navigate to the next month
//     } else if (activeView === "week") {
//       const nextWeekStart = addDays(endOfWeek(currentMonth), 1); // Go to the start of the next week
//       setCurrentMonth(nextWeekStart);
//     }
//   };

//   // Function to navigate to the next day
//   const nextDay = () => {
//     setCurrentMonth(addDays(currentMonth, 1)); // Navigate to the next day
//   };

//   // Function to navigate to the previous day
//   const prevDay = () => {
//     setCurrentMonth(subDays(currentMonth, 1)); // Navigate to the previous day
//   };
//   // Function to navigate to previous month or week
//   const prevMonth = () => {
//     if (activeView === "month") {
//       setCurrentMonth(subMonths(currentMonth, 1)); // Navigate to the previous month
//     } else if (activeView === "week") {
//       const prevWeekStart = subDays(startOfWeek(currentMonth), 1); // Go to the start of the previous week
//       setCurrentMonth(prevWeekStart);
//     }
//   };

//   // Mock events data
//   const events = [
//     {
//       id: 1,
//       date: new Date(2024, 11, 10),
//       hour: "2",
//       bookingStatus: "Confirmed",
//       bookingDate: "10-Dec-2024 01:00 PM",
//       service: "House Cleaning",
//       methods: "Property Based",
//       units: "Bedroom(s)-3",
//       addons: "Fridge Cleaning-5",
//       price: "$65.00",
//       duration: "4 Hours 0 Minutes",
//       customer: {
//         name: "John Doe",
//         email: "johndoe@example.com",
//         phone: "+10000000000",
//         address: "Perrine, USA, Perrine, 90001, USA",
//         payment: "Pay Locally",
//         notes: "Happy Booking",
//       },
//     },
//   ];

//   //   // Render month view

//   const renderDaysInMonth = () => {
//     const startDate = new Date(
//       currentMonth.getFullYear(),
//       currentMonth.getMonth(),
//       1
//     );
//     const endDate = new Date(
//       currentMonth.getFullYear(),
//       currentMonth.getMonth() + 1,
//       0
//     );
//     const days = [];
//     let dayIndex = startDate.getDay();
//     let dayOfMonth = 1;

//     const today = new Date();
//     const todayDate = format(today, "yyyy-MM-dd");

//     while (dayIndex > 0) {
//       days.push(<div key={`empty-${dayIndex}`} className="p-4 border"></div>);
//       dayIndex--;
//     }

//     while (dayOfMonth <= endDate.getDate()) {
//       const date = new Date(
//         currentMonth.getFullYear(),
//         currentMonth.getMonth(),
//         dayOfMonth
//       );
//       const eventsForDay = bookingappointment.filter(
//         (event) =>
//           format(event.booking_date_time, "yyyy-MM-dd") ===
//           format(date, "yyyy-MM-dd")
//       );

//       const isToday = format(date, "yyyy-MM-dd") === todayDate;
//       const isPastDate = format(date, "yyyy-MM-dd") < todayDate;
//       const eventsToShow = eventsForDay.slice(0, 4);
//       const remainingEvents = eventsForDay.length - 4;

//       days.push(
//         <div
//           key={dayOfMonth}
//           className={`p-1 border h-32 relative ${
//             isToday ? "bg-blue-200" : ""
//           } ${isPastDate ? "bg-gray-200" : ""}`}
//           onClick={
//             !isPastDate
//               ? () => handleShowBookingSummary2(date)
//               : () => alert("You can't select a past date")
//           }
//         >
//           <p className={`text-right ${isToday ? "font-bold" : ""}`}>
//             {dayOfMonth}
//           </p>

//           {eventsForDay.length > 0 && (
//             <div className="absolute bottom-0 left-0 w-full px-2 py-1 space-y-1">
//               {eventsToShow.map((event, index) => (
//                 <button
//                   key={index}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleShowModal(event);
//                     setDetailsiud(event.order_id);
//                   }}
//                   onMouseEnter={() => setHoveredEvent(event)}
//                   onMouseLeave={() => setHoveredEvent(null)}
//                   className="text-xs bg-customlightGreen text-black px-2 py-1 rounded mb-1 relative"
//                 >
//                   Details
//                   {hoveredEvent === event && (
//                     <div className="absolute top-0 left-0 bg-white text-black p-4 rounded-lg shadow-lg z-20 border border-gray-200">
//                       <p className="text-sm font-medium mb-1">
//                         <strong>Title:</strong> {event.title}
//                       </p>
//                       <p className="text-sm mb-1">
//                         <strong>Time:</strong> {event.booking_date_time}
//                       </p>
//                       <p className="text-sm mb-1">
//                         <strong>Name:</strong> {detailsdata.client_name}
//                       </p>
//                       <p className="text-sm mb-1">
//                         <strong>Email:</strong> {detailsdata.client_email}
//                       </p>
//                       <p className="text-sm">
//                         <strong>Phone:</strong> {detailsdata.client_phone}
//                       </p>
//                     </div>
//                   )}
//                 </button>
//               ))}
//               {remainingEvents > 0 && !showAllEvents && (
//                 <button
//                   className="text-xs text-blue-500"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     setShowAllEvents(true);
//                   }}
//                 >
//                   +{remainingEvents} More
//                 </button>
//               )}
//               {showAllEvents && (
//                 <div className="space-y-1">
//                   {eventsForDay.slice(4).map((event, index) => (
//                     <button
//                       key={index}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleShowModal(event);
//                         setDetailsiud(event.order_id);
//                       }}
//                       onMouseEnter={() => setHoveredEvent(event)}
//                       onMouseLeave={() => setHoveredEvent(null)}
//                       className="text-xs bg-customlightGreen text-black px-2 py-1 rounded mb-1 relative"
//                     >
//                       Details
//                       {hoveredEvent === event && (
//                         <div className="absolute top-0 left-0 bg-white text-black p-2 rounded shadow-md z-10">
//                           <p className="text-xs">
//                             <strong>Title:</strong> {event.title}
//                           </p>
//                           <p className="text-xs">
//                             <strong>Time:</strong> {event.time}
//                           </p>
//                           <p className="text-xs">
//                             <strong>Location:</strong> {event.location}
//                           </p>
//                         </div>
//                       )}
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       );

//       dayOfMonth++;
//     }

//     return days;
//   };

//   const renderWeekView = () => {
//     const weekStart = startOfWeek(currentMonth, { weekStartsOn: 0 });
//     const weekEnd = endOfWeek(currentMonth, { weekStartsOn: 0 });
//     const weekDays = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));
//     const formattedRange = `${format(weekStart, "MMM d")} — ${format(
//       weekEnd,
//       "MMM d, yyyy"
//     )}`;

//     // Current date for highlighting
//     const today = new Date();
//     const todayDate = format(today, "yyyy-MM-dd");

//     return (
//       <div className="w-full mx-auto">
//         {successMessage && (
//           <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
//             <span className="block sm:inline">{successMessage}</span>
//           </div>
//         )}

//         {error && (
//           <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
//             <span className="block sm:inline">{error}</span>
//           </div>
//         )}
//         <div className="grid grid-cols-8 border border-gray-300 text-center text-sm font-semibold bg-gray-50">
//           <div className="col-span-1 border border-gray-200"></div>
//           {weekDays.map((date, index) => {
//             const isToday = format(date, "yyyy-MM-dd") === todayDate; // Check if it's today's date
//             return (
//               <div
//                 key={index}
//                 className={`py-2 border lg:text-base md:text-base border-gray-200 min-[320px]:text-[11px] max-[640px]:text-[11px] ${
//                   isToday ? "bg-blue-100 font-bold" : ""
//                 }`}
//               >
//                 {`${daysOfWeek[date.getDay()]} ${format(date, "MM/dd")}`}
//               </div>
//             );
//           })}
//         </div>

//         <div className="grid grid-cols-8 divide-x border border-gray-300 text-sm">
//           <div className="border-r border-gray-300">
//             {hours.map((hour, index) => (
//               <div
//                 key={index}
//                 className="h-16 flex items-center justify-end pr-2 border-b border-gray-300"
//               >
//                 {hour}
//               </div>
//             ))}
//           </div>

//           {weekDays.map((date, dayIndex) => {
//             const isToday = format(date, "yyyy-MM-dd") === todayDate; // Check if it's today's date
//             const isPastDate = format(date, "yyyy-MM-dd") < todayDate; // Check if it's a past date

//             return (
//               <div
//                 key={dayIndex}
//                 className={`border-b border-gray-300 ${
//                   isToday ? "bg-blue-50" : ""
//                 }`}
//                 onClick={
//                   !isPastDate
//                     ? () => handleShowBookingSummary2(date)
//                     : () => alert("You can't select a past date")
//                 }
//               >
//                 {hours.map((hour, hourIndex) => {
//                   // Corrected hour calculation based on the `date`
//                   const hourStart = format(addHours(date, hourIndex), "HH:00"); // Use `date` here instead of `new Date()`
//                   const hourEnd = format(
//                     addHours(date, hourIndex + 1),
//                     "HH:00"
//                   );

//                   // Filter events for the current hour (for the given date and hour)
//                   const eventsForHour = bookingappointment.filter((event) => {
//                     const eventDateTime = format(
//                       new Date(event.booking_date_time),
//                       "yyyy-MM-dd HH:00"
//                     ); // Full date and hour
//                     const checkDateTime =
//                       format(date, "yyyy-MM-dd") + " " + hourStart;
//                     return eventDateTime === checkDateTime;
//                   });

//                   return (
//                     <div
//                       key={hourIndex}
//                       className={`h-16 border-b border-gray-300 ${
//                         isToday
//                           ? "bg-blue-100"
//                           : hourIndex % 2 === 0
//                           ? "bg-gray-50"
//                           : "bg-white"
//                       }`}
//                     >
//                       {/* Render event buttons for this hour */}
//                       {eventsForHour.length > 0 && (
//                         <div className="space-y-1">
//                           {eventsForHour.map((event, eventIndex) => (
//                             <button
//                               key={eventIndex}
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleShowModal(event); // Show modal with event details
//                                 setDetailsiud(event.order_id); // Set the event's order_id
//                               }}
//                               className="text-xs bg-customlightGreen text-black px-2 py-1 rounded mb-1"
//                             >
//                               Details
//                             </button>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   const renderDayView = () => {
//     const day = currentMonth; // Assuming currentMonth is the date representing the current day view
//     const formattedDay = format(day, "EEEE, MMM d, yyyy");

//     const today = new Date();
//     const todayDate = format(today, "yyyy-MM-dd");
//     const isToday = format(day, "yyyy-MM-dd") === todayDate;
//     const isFutureDate = format(day, "yyyy-MM-dd") > todayDate;

//     return (
//       <div className="w-full mx-auto">
//         <div className="text-center text-lg font-medium">{formattedDay}</div>
//         <div className="grid grid-cols-1 divide-y border border-gray-300 text-sm">
//           {hours.map((hour, index) => {
//             const hourStart = format(addHours(formattedDay, index), "HH:00"); // Calculate start time for each hour
//             const hourEnd = format(addHours(formattedDay, index + 1), "HH:00"); // Calculate end time for each hour

//             const eventsForHour = bookingappointment.filter((event) => {
//               const eventDateTime = format(
//                 new Date(event.booking_date_time),
//                 "yyyy-MM-dd HH:00"
//               );
//               const checkDateTime =
//                 format(formattedDay, "yyyy-MM-dd") + " " + hourStart;
//               return eventDateTime === checkDateTime;
//             });

//             return (
//               <div
//                 key={index}
//                 onClick={
//                   isToday || isFutureDate
//                     ? () => handleShowBookingSummary2(day)
//                     : () => alert("You can't select a past date")
//                 }
//                 className={`py-4 flex items-center px-2 text-base border-b border-gray-300 ${
//                   isToday ? "bg-blue-100" : ""
//                 }`}
//               >
//                 <div className="pr-20">{hour}</div>
//                 {eventsForHour.length > 0 && (
//                   <div className="space-y-1">
//                     {eventsForHour.map((event, eventIndex) => (
//                       <button
//                         key={eventIndex}
//                         onClick={(e) => {
//                           e.stopPropagation(); // Prevent event propagation
//                           handleShowModal(event); // Show modal with event details
//                           setDetailsiud(event.order_id); // Set the event's order_id
//                         }}
//                         className="text-xs bg-customlightGreen text-black px-2 py-1 rounded mb-1"
//                       >
//                         Details
//                       </button>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   const handleShowModal = (event) => {
//     console.log(event);
//     setSelectedEvent(event);
//     setShowModal(true);
//     setShowEditModal(false);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedEvent(null);
//   };
//   const handleShowEditModal = () => {
//     setShowEditModal(true);
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//   };

//   const handleShowBookingSummary = () => {
//     setShowBookingSummary(true);
//   };

//   const handleShowBookingSummary2 = () => {
//     setShowBookingSummary2(true);
//   };
//   const handleCloseBookingSummary = () => {
//     setShowBookingSummary(false);
//     setShowBookingSummary2(false);
//   };
//   const handleGoToToday = () => {
//     setCurrentMonth(new Date()); // Set currentMonth to today's date
//   };

//   const handlePersonalDetailsChange = (e) => {
//     const { name, value } = e.target;
//     setPersonalDetails((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };
//   // Handle same as above toggle
//   const handleSameAsAbove = (e) => {
//     setSameAsAbove(e.target.checked);
//     if (e.target.checked) {
//       setAppointmentDetails(personalDetails);
//     }
//   };
//   // Handle change for appointment details
//   const handleAppointmentDetailsChange = (e) => {
//     const { name, value } = e.target;
//     setAppointmentDetails((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };
//   // const handleQuantityChange = (
//   //   idx,
//   //   increment,
//   //   addon_name,
//   //   addon_price,
//   //   max_quantity
//   // ) => {
//   //   console.log(`Addon Name: ${addon_name}`);

//   //   // Update quantities array
//   //   const newQuantities = [...quantities];
//   //   if (increment) {
//   //     if (newQuantities[idx] >= max_quantity) {
//   //       alert(`Maximum quantity of ${max_quantity} reached for ${addon_name}`);
//   //     } else {
//   //       newQuantities[idx] += 1;
//   //     }
//   //   } else {
//   //     newQuantities[idx] = Math.max(0, newQuantities[idx] - 1); // Prevent negative quantities
//   //   }
//   //   setQuantities(newQuantities);

//   //   // Extract quantity and calculate price
//   //   const quantity = newQuantities[idx];
//   //   const totalPrice = quantity * addon_price;

//   //   // Log for debugging
//   //   console.log(`Quantity: ${quantity}, Price: ${totalPrice}`);

//   //   // Update bookingBill
//   //   const updatedBill = [...bookingBill];
//   //   const existingItemIndex = updatedBill.findIndex(
//   //     (item) => item.type === addon_name
//   //   );

//   //   if (existingItemIndex !== -1) {
//   //     if (quantity > 0) {
//   //       // Update existing item
//   //       updatedBill[existingItemIndex] = {
//   //         ...updatedBill[existingItemIndex],
//   //         qty: quantity,
//   //         rate: totalPrice,
//   //         service_id: idx, // Include service_id here if needed
//   //       };
//   //     } else {
//   //       // Remove item if quantity is zero
//   //       updatedBill.splice(existingItemIndex, 1);
//   //     }
//   //   } else if (quantity > 0) {
//   //     // Add new item to bookingBill
//   //     updatedBill.push({
//   //       type: addon_name,
//   //       qty: quantity,
//   //       rate: totalPrice,
//   //       service_id: idx,
//   //     });
//   //   }

//   //   // Update the bookingBill state
//   //   setBookingBill(updatedBill);

//   //   // Update total time by adding 60 minutes for each selected addon
//   //   if (quantity > 0) {
//   //     setTotalTime((prevTime) => prevTime + 60); // Add 60 minutes for each addon
//   //   } else {
//   //     setTotalTime((prevTime) => prevTime - 60); // Subtract 60 minutes when addon is removed
//   //   }

//   //   // Log for debugging
//   //   console.log("Updated Booking Bill:", updatedBill);
//   //   console.log("Total Time:", totalTime);
//   // };


//   const handleQuantityChange = (
//     idx,
//     increment,
//     addon_name,
//     addon_price,
//     max_quantity
//   ) => {
//     // Update quantities array
//     const newQuantities = [...quantities];
//     if (increment) {
//       if (newQuantities[idx] >= max_quantity) {
//         alert(`Maximum quantity of ${max_quantity} reached for ${addon_name}`);
//       } else {
//         newQuantities[idx] += 1;
//       }
//     } else {
//       newQuantities[idx] = Math.max(0, newQuantities[idx] - 1);
//     }
//     setQuantities(newQuantities);
  
//     // Update bookingBill
//     const quantity = newQuantities[idx];
//     const totalPrice = quantity * addon_price;
  
//     setBookingBill((prevBill) => {
//       const existingItemIndex = prevBill.findIndex(
//         (item) => item.type === addon_name
//       );
  
//       let updatedBill = [...prevBill];
  
//       if (existingItemIndex !== -1) {
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             ...updatedBill[existingItemIndex],
//             qty: quantity,
//             rate: totalPrice,
//             service_id: idx, // Using index as a unique identifier for addon
//           };
//         } else {
//           updatedBill.splice(existingItemIndex, 1);
//         }
//       } else if (quantity > 0) {
//         updatedBill.push({
//           type: addon_name,
//           qty: quantity,
//           rate: totalPrice,
//           service_id: idx,
//         });
//       }
  
//       // Update total time
//       const newTotalTime = updatedBill.reduce(
//         (time, item) => time + (item.qty || 0) * 60,
//         0
//       );
//       setTotalTime(newTotalTime);
  
//       return updatedBill;
//     });
//   };
//   const getappointmentdetails = async () => {
//     setLoading(true);
//     try {
//       // Define the request payload
//       const payload = {
//         action: "getbookingdetails", // Action to fetch all services
//         order_id: Detailsiud, // API key for authentication
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;

//         setDetailsdata(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getappointmentdetails();
//   }, [Detailsiud]);

//   const deleteallbooking = async (id) => {
//     setLoading(true);
//     try {
//       // Define the request payload
//       const payload = {
//         action: "delete_recurring_booking", // Action to fetch all services
//         recurring_id: id,
//         api_key: "1", // API key for authentication
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;
//         console.log(services);
//         // setDetailsdata(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//     bookeddata();
//     handleCloseModal();
//   };

//   useEffect(() => {
//     deleteallbooking();
//   }, []);

//   const userIdta = sessionStorage.getItem("userId") || useriddata;

//   const getuserdataa = crmgetdata?.find((user) => user.id === userIdta);
//   console.log(getuserdataa);

//   const getservicesdata = async () => {
//     // setApiCallsPending((prev) => prev + 1);
//     setLoading(true); // Set loading to true before fetching data
//     try {
//       const payload = {
//         action: "all_services",
//         api_key: "1",
//       };

//       const response = await axios.post(
//         `${BaseUrl}/backend/api/services.php`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       console.log(response.data);

//       if (response.data && response.data.status === "true") {
//         const services = response.data;
//         setallServices(services.response);

//         if (Array.isArray(services.response)) {
//           console.log("Fetched Data:", services);
//         } else {
//           console.log("No valid array in response data:", response.data);
//         }
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       // setApiCallsPending((prev) => prev - 1); // Decrement pending API calls
//       // if (apiCallsPending === 1) {
//       setLoading(false); // Set loading to false when all API calls are done
//       // } // Set loading to false after data is fetched
//     }
//   };
//   const bookeddata = async () => {
//     setLoading(true);
//     try {
//       const currentDate = new Date(); // Current date

//       // Format the date in YYYY-MM-DD format
//       const formattedDate = currentDate.toISOString().split("T")[0];

//       // Convert formattedDate back to Date object to extract year and month
//       const currentDateObj = new Date(formattedDate);

//       // Get the first day of the current month
//       const start_date = new Date(
//         currentDateObj.getFullYear(),
//         currentDateObj.getMonth(),
//         1
//       )
//         .toISOString()
//         .split("T")[0];

//       // Get the last day of the month, 3 months from now
//       const end_date = new Date(
//         currentDateObj.getFullYear(),
//         currentDateObj.getMonth() + 3 + 1,
//         0
//       )
//         .toISOString()
//         .split("T")[0];

//       // Define the request payload
//       const payload = {
//         action: "getallbookings", // Action to fetch all services
//         api_key: "1", // API key for authentication
//         start_date: start_date,
//         end_date: end_date,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data && response.data.status === "true") {
//         const services = response.data;
//         console.log(services.response);

//         if (Array.isArray(services.response)) {
//           console.log("Fetched Data:", services); // Log the fetched data
//           setbookingappointment(services.response);
//           // setTableData(services); // Uncomment to update the table
//         } else {
//           console.log("No valid array in response data:", response.data);
//         }
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     bookeddata();
//   }, []);

//   useEffect(() => {
//     getservicesdata();
//   }, []);

//   useEffect(() => {
//     calculateDiscountedTotal(); // Calculate discounted total whenever discount or total changes
//   }, [selectedDiscount]);

//   const frequently_discount = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(
//         `${BaseUrl}/backend/api/services.php?action=frequently_discount`
//       );

//       console.log("Raw Response:", response.data);

//       // Parse the response if necessary
//       let responseData = response.data;
//       if (typeof responseData === "string") {
//         try {
//           responseData = JSON.parse(responseData.trim()); // Remove extra whitespace and parse
//         } catch (error) {
//           console.log("Error parsing response data:", error);
//           return;
//         }
//       }

//       // Handle the parsed response
//       if (responseData.status === "true") {
//         const services = responseData.data;
//         console.log("Fetched Data:", services);
//         setServices_frequently_discount(services); // Update state
//       } else {
//         console.log("API response indicates failure:", responseData.message);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     frequently_discount();
//   }, []);

//   // const handleClick = () => {
//   //   window.open("/login", "_blank"); // Opens in a new tab
//   // };
//   const [isAuthenticateddata, setIsAuthenticated] = useState(false);
//   useEffect(() => {
//     // Get values from localStorage
//     const storedUserType = sessionStorage.getItem("userType");
//     const isLoggedInData = sessionStorage.getItem("isLoggedIn");

//     // Check if both values exist and isLoggedIn is 'true'
//     if (storedUserType && isLoggedInData === "true") {
//       setUserTypelocal(storedUserType);
//       setIsAuthenticated(true);
//     }
//   }, []); // Empty dependency array means this runs once on mount

//   const [authStatus, setAuthStatus] = useState(isAuthenticateddata);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setAuthStatus(isAuthenticateddata);
//     }, []);

//     return () => clearInterval(interval); // Cleanup interval on unmount
//   }, [isAuthenticateddata]);

//   const handleClick = () => {
//     if (authStatus) {
//       switch (UserTypelocal) {
//         case "admin":
//           navigate("/admin");
//           break;
//         case "staff":
//           navigate("/staff");
//           break;
//         case "client":
//           navigate("/user");
//           break;
//         default:
//           navigate("/");
//           break;
//       }
//     } else {
//       navigate("/login");
//     }
//   };

//   // useEffect(() => {
//   //   handleClick();
//   // }, []);

//   const handleClosebookingSummary = () => {
//     setShowBookingSummary(false);
//     setShowBookingSummary2(false);
//   };

//   const toggleServicePanel = () => {
//     setIsServiceOpen((prev) => !prev); // Toggle this panel
//     if (!isServiceOpen) {
//       // If opening this panel
//       setIsCalendarOpen(false); // Close others
//       setIsFormOpen(false);
//     }
//   };

//   const handleMethodSelection = (method, id) => {
//     switch ((method.method_title, id)) {
//       case "Residential Services":
//         setResidential(true);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Commercial Services":
//         setResidential(false);
//         setCommercial(true);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Property Based":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(true);
//         officesetCommercial(false);
//         break;
//       case "Area Based (Feet)":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(true);
//         break;
//       default:
//         // Reset all states if no match is found
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//     }

//     setSelectedMethod(method, id);
//   };

//   const handlePrevMonth = () => {
//     const newDate = new Date(currentDate);
//     newDate.setMonth(newDate.getMonth() - 1);
//     setCurrentDate(newDate);
//   };

//   // Function to handle next month button click
//   const handleNextMonth = () => {
//     const newDate = new Date(currentDate);
//     newDate.setMonth(newDate.getMonth() + 1);
//     setCurrentDate(newDate);
//   };

//   const handleUserTypeChange = (value) => {
//     setUserType(value); // Set the user type

//     if (value === "new") {
//       // Reset the form fields for a new user
//       setUserDetails({
//         id: "",
//         email: "",
//         password: "",
//         firstName: "",
//         lastName: "",
//         phone: "",
//         streetAddress: "",
//         zipCode: "",
//         city: "",
//         state: "",
//         specialRequests: "",
//       });
//     } else if (value === "existing") {
//       // Optionally, handle the reset when switching to "Existing User"
//       setUserDetails({
//         id: optiondata?.id || "",
//         email: optiondata?.user_email || "",
//         password: optiondata?.user_pwd || "",
//         firstName: optiondata?.first_name || "",
//         lastName: optiondata?.last_name || "",
//         phone: optiondata?.phone || "",
//         streetAddress: optiondata?.address || optiondata?.street_address || "",
//         city: optiondata?.city || "",
//         state: optiondata?.state || "",
//         zipCode: optiondata?.zip || "",
//         specialRequests: optiondata?.notes || "",
//       });
//     }
//   };

//   const handleConfirmClick = (id) => {
//     console.log(`Confirming appointment with ID: ${id}`);
//     // Add logic for confirming the appointment here
//   };

//   const handleChangedata = (event) => {
//     const selectedId = event.target.value;
//     setSelectedOption(selectedId); // Update the selected option

//     const selectedUser = crmgetdata.find((user) => user.id === selectedId); // Find the selected user
//     setoptiondata(selectedUser);

//     if (selectedUser) {
//       // Populate the form fields with the selected user's data
//       setUserDetails({
//         id: selectedUser.id || "",
//         email: selectedUser.user_email || "",
//         password: selectedUser.user_pwd || "",
//         firstName: selectedUser.first_name || "",
//         lastName: selectedUser.last_name || "",
//         phone: selectedUser.phone || "",
//         streetAddress:
//           selectedUser.address || selectedUser.street_address || "",
//         city: selectedUser.city || "",
//         state: selectedUser.state || "",
//         zipCode: selectedUser.zip || "",
//         specialRequests: selectedUser.notes || "",
//       });
//     } else {
//       // Reset the form if no user is selected
//       setUserDetails({
//         id: "",
//         email: "",
//         password: "",
//         firstName: "",
//         lastName: "",
//         phone: "",
//         streetAddress: "",
//         zipCode: "",
//         city: "",
//         state: "",
//         specialRequests: "",
//       });
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!userDetails.email) {
//       newErrors.email = "Email is required";
//     } else if (!/\S+@\S+\.\S+/.test(userDetails.email)) {
//       newErrors.email = "Email is invalid";
//     }
//     // Password Validation
//     if (!userDetails.password) {
//       newErrors.password = "Password is required";
//     } else if (userDetails.password.length < 8) {
//       newErrors.password = "Password must be at least 8 characters";
//     }
//     if (!userDetails.firstName) {
//       newErrors.firstName = "First Name is required";
//     }
//     if (!userDetails.lastName) {
//       newErrors.lastName = "Last Name is required";
//     }
//     if (!userDetails.phone) {
//       newErrors.phone = "Phone is required";
//     }
//     if (!userDetails.streetAddress) {
//       newErrors.streetAddress = "Street Address is required";
//     }
//     if (!userDetails.zipCode) {
//       newErrors.zipCode = "Zip Code is required";
//     }
//     if (!userDetails.city) {
//       newErrors.city = "City is required";
//     }
//     if (!userDetails.state) {
//       newErrors.state = "State is required";
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };
//   const handleUserDetailsChange = (event) => {
//     const { name, value } = event.target;
//     setUserDetails({ ...userDetails, [name]: value });
//   };

//   // const handleSubmitdata = (e) => {
//   //   e.preventDefault(); // Prevent the default form submission behavior

//   //   // Clear existing errors
//   //   const newErrors = {};

//   //   // Validate password length
//   //   if (userDetails.password && userDetails.password.length > 8) {
//   //     newErrors.password = "Password must be at most 8 characters.";
//   //   }

//   //   // If errors exist, update the error state and prevent form submission
//   //   if (Object.keys(newErrors).length > 0) {
//   //     setErrors(newErrors);
//   //     return;
//   //   }

//   //   // Proceed with form submission if no validation errors
//   //   if (validateForm()) {
//   //     setLoading(true);

//   //     const data = {
//   //       action: "add_customerdata",
//   //       api_key: "1", // Use the actual API key for authentication
//   //       email: userDetails.email,
//   //       password: userDetails.password,
//   //       first_name: userDetails.firstName,
//   //       last_name: userDetails.lastName,
//   //       phone: userDetails.phone,
//   //       address: userDetails.streetAddress,
//   //       zipcode: userDetails.zipCode,
//   //       city: userDetails.city,
//   //       state: userDetails.state,
//   //       notes: userDetails.specialRequests,
//   //     };

//   //     // Send the data using axios POST request
//   //     axios
//   //       .post(`${BaseUrl}/backend/api/add_customer.php`, data)
//   //       .then((response) => {
//   //         console.log(response.data);

//   //         if (response.data.status === "true") {
//   //           // Handle success (e.g., show success message or redirect)
//   //           alert("Customer created successfully!");
//   //           setSuccessMessage("Add Customer successfully!");
//   //           getservicesdata();
//   //           setuseriddata(response.data.customer_data.id);
//   //         } else {
//   //           // Handle failure (e.g., show error message)
//   //           alert(response.data.response);

//   //           getservicesdata();
//   //         }
//   //       })
//   //       .catch((error) => {
//   //         // Handle any errors during the request
//   //         console.error("Error occurred while submitting:", error);
//   //         alert("There was an error submitting the form. Please try again.");
//   //       })
//   //       .finally(() => {
//   //         setLoading(false);
//   //       });
//   //   }
//   // };

// const handleSubmitdata = (e) => {
//     e.preventDefault(); // Prevent the default form submission behavior
  
//     // Clear existing errors
//     const newErrors = {};
  
//     // Validate password length
//     if (userDetails.password && userDetails.password.length > 8) {
//       newErrors.password = "Password must be at most 8 characters.";
//     }
  
//     // If errors exist, update the error state and prevent form submission
//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       return;
//     }
  
//     // Proceed with form submission if no validation errors
//     if (validateForm()) {
//       setLoading(true);
  
//       const data = {
//         action: "add_customerdata", // Keeping your original action name
//         api_key: "1", // Use the actual API key for authentication
//         email: userDetails.email,
//         password: userDetails.password,
//         first_name: userDetails.firstName,
//         last_name: userDetails.lastName,
//         phone: userDetails.phone,
//         address: userDetails.streetAddress,
//         zipcode: userDetails.zipCode,
//         city: userDetails.city,
//         state: userDetails.state,
//         notes: userDetails.specialRequests,
//         vc_status: vacuum === "yes" ? "Y" : "N", // Map vacuum cleaner status
//         p_status: parking === "yes" ? "Y" : "N", // Map parking status
//         contact_status: access === "home" ? "Active" : access, // Map access method
//       };

//       console.log(data)
  
//       // Send the data using axios POST request
//       axios
//         .post(`${BaseUrl}/backend/api/add_customer.php`, data)
//         .then((response) => {
//           console.log(response.data);
  
//           if (response.data.status === "true") {
//             // Handle success (e.g., show success message or redirect)
//             alert("Customer created successfully!");
//             setSuccessMessage("Add Customer successfully!");
//             getservicesdata();
//             setuseriddata(response.data.customer_data.id);
//           } else {
//             // Handle failure (e.g., show error message)
//             getservicesdata();
//           }
//         })
//         .catch((error) => {
//           // Handle any errors during the request
//           console.error("Error occurred while submitting:", error);
//           alert("There was an error submitting the form. Please try again.");
//         })
//         .finally(() => {
//           setLoading(false);
//         });
//     }
//   };

//   const today = new Date();

//   const handleLogout = () => {
//     sessionStorage.removeItem("userId");
//     sessionStorage.removeItem("userType");
//     sessionStorage.removeItem("isLoggedIn");
//     setIsLoggedIn(false);
//   };

//   return (
//     <div className="flex items-center justify-center min-h-screen ">
//       {loading ? (
//         <>
//           <Circles height="80" width="80" color="grey" ariaLabel="loading" />
//           <br></br>
//           <h1>Please wait...</h1>
//         </>
//       ) : (
//         <div className="flex flex-col bg-gray-100 p-4 w-full">
//           <div className="w-full max-w-6xl mx-auto">
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//               {/* Left Section - Booking Form */}
//               <div className="col-span-2 bg-white p-6 rounded-lg shadow-lg">
//                 <button
//                   onClick={handleClick}
//                   className="px-4 py-2 mt-3 bg-blue-500 text-white flex items-end justify-end rounded-md hover:bg-blue-600 transition duration-200"
//                 >
//                   My Booking
//                 </button>
//                 <h1 className="text-3xl font-medium text-center text-blue-800 mb-6">
//                   Megaclean
//                 </h1>
//                 <p className="text-center text-gray-700 mb-4">Amroli Surat</p>

//                 <form onSubmit={handleSubmit} className="space-y-6">
//                   {/* Service Location */}
//                   <div>
//                     <label
//                       htmlFor="serviceLocation"
//                       className="block text-lg font-medium text-gray-800"
//                     >
//                       Where would you like us to provide service?
//                     </label>
//                   </div>

//                   {/* Zip Code Input */}
//                   {/* <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6">
//                     <div className="flex flex-col w-full">
//                       <label
//                         htmlFor="zipCode"
//                         className="block text-lg font-medium text-gray-800"
//                       >
//                         Zip Code
//                       </label>
//                       <input
//                         type="number"
//                         id="zipCode"
//                         name="zipCode"
//                         value={formData.zipCode}
//                         onChange={handleChange}
//                         className="mt-2 p-2 w-full border border-gray-400 rounded-md"
//                         placeholder="Zip Code"
//                         onInput={(e) => {
//                           if (e.target.value.length > 6) {
//                             e.target.value = e.target.value.slice(0, 6); // Max 6 digits
//                           }
//                         }}
//                       />
//                     </div>
//                   </div> */}
//                     {/* // Update your Zip Code input section in the JSX */}
//                     <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6">
//                       <div className="flex flex-col w-full">
//                         <label
//                           htmlFor="zipCode"
//                           className="block text-lg font-medium text-gray-800"
//                         >
//                           Zip Code
//                         </label>
//                         <input
//                           type="number"
//                           id="zipCode"
//                           name="zipCode"
//                           value={formData.zipCode}
//                           onChange={handleZipCodeChange} // Use new handler
//                           className="mt-2 p-2 w-full border border-gray-400 rounded-md"
//                           placeholder="Enter Zip Code"
//                           onInput={(e) => {
//                             if (e.target.value.length > 6) {
//                               e.target.value = e.target.value.slice(0, 6); // Max 6 digits
//                             }
//                           }}
//                         />
//                         {/* Display error message if zip code is invalid */}
//                         {zipCodeError && (
//                           <p className="text-red-500 text-sm mt-1">{zipCodeError}</p>
//                         )}
                        
//                       </div>
//                     </div>
//                                       {/* Choose Service */}
//                   <div>
//                     <label
//                       htmlFor="selectedService"
//                       className="block text-lg font-medium text-gray-800"
//                     >
//                       Choose Service
//                     </label>
//                   </div>


//                   <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-6 min-[320px]:grid-cols-2 max-[640px]:grid-cols-2">
//                     {allServices?.map((service) => (
//                       <div
//                         key={service.service_id}
//                         onClick={() => {
//                           if (service.service_id) {
//                             setSelectedService(service.service_id);
//                           } else {
//                             console.error("Service ID is missing", service);
//                           }
//                         }}
//                         className={`cursor-pointer border rounded-lg text-center shadow-md ${
//                           selectedService === service.service_id
//                             ? "bg-blue-400 text-white"
//                             : "bg-white"
//                         } hover:bg-blue-300`}
//                       >
//                         {service?.service_image ? (
//                           // If image exists, show image with title overlay
//                           <div className="relative">
//                             <img
//                               src={service.service_image}
//                               className="w-full h-52 object-cover rounded-md min-[320px]:h-36 max-[640px]:h-36"
//                             />
//                             <div className="absolute inset-0 flex items-center justify-center text-white font-bold bg-black bg-opacity-50 rounded-md">
//                               {service?.service_title}
//                             </div>
//                           </div>
//                         ) : (
//                           // If no image, show only title with a colored background
//                           <div className="flex items-center justify-center h-20 p-4 text-white font-bold bg-gray-500 rounded-md">
//                             {service?.service_title}
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>

//                   {/* Conditionally render the selected service details */}
//                   {selectedService && (
//                     <div>
//                       {/* Find the selected service */}
//                       {allServices
//                         .filter((s) => s.service_id === selectedService)
//                         ?.map((service) => (
//                           <>
//                             <div>
//                               {/* Dropdowns */}
//                               {service.units && service.units.length > 0 && (
//                                 <div>
//                                   {service.units?.map((unit) => (
//                                     <div
//                                       key={unit.unit_id}
//                                       className="flex gap-4 mb-6"
//                                     >
//                                       <div>
//                                         <div className="flex items-center space-x-2">
//                                           {/* Display the unit title */}
//                                           <label className="block font-medium mb-2">
//                                             {unit.unit_title}
//                                           </label>
//                                           <img
//                                             src={Bed}
//                                             className="w-6 h-6"
//                                             alt="Unit Icon"
//                                           />
//                                         </div>
//                                         <select
//                                           className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-400"
//                                           value={
//                                             bedroom[unit.unit_id] ||
//                                             unit.unit_min
//                                           } // Default to `unit_min`
//                                           onChange={(e) =>
//                                             handleBedroomChange(
//                                               unit.unit_id,
//                                               parseInt(e.target.value)
//                                             )
//                                           }
//                                         >
//                                           {Array.from(
//                                             {
//                                               length:
//                                                 unit.unit_max -
//                                                 unit.unit_min +
//                                                 1,
//                                             },
//                                             (_, i) => (
//                                               <option
//                                                 key={i + unit.unit_min}
//                                                 value={i + unit.unit_min}
//                                               >
//                                                 {i}
//                                               </option>
//                                             )
//                                           )}
//                                         </select>
//                                       </div>
//                                     </div>
//                                   ))}
//                                 </div>
//                               )}

//                               {/* Render methods */}
//                               {service.methods &&
//                                 service.methods.length > 0 && (
//                                   <div className="flex flex-col space-y-6 mb-5">
//                                     {/* Upper part: Methods Buttons */}
//                                     <div>
//                                       <h3>Methods</h3>
//                                       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//                                         {service.methods?.map((method) => (
//                                           <button
//                                             type="button"
//                                             key={method.method_id}
//                                             onClick={() =>
//                                               handleMethodSelection(
//                                                 method,
//                                                 method.method_id
//                                               )
//                                             }
//                                             className={`p-4 border rounded-lg text-center shadow-md transition-all ${
//                                               selectedMethod &&
//                                               selectedMethod.method_id ===
//                                                 method.method_id
//                                                 ? "bg-blue-400 text-white"
//                                                 : "bg-white hover:bg-gray-200"
//                                             }`}
//                                           >
//                                             {method.method_title}
//                                           </button>
//                                         ))}
//                                       </div>
//                                     </div>

//                                     {/* Bottom part: Submethods and Quantity Buttons */}
//                                     {selectedMethod && (
//                                       <div className="mt-6">
//                                         {selectedMethod.submethods &&
//                                         selectedMethod.submethods.length > 0 ? (
//                                           <>
//                                             {/* Mobile View - Dropdown */}
//                                             <div className="block md:hidden">
//                                               {selectedMethod.submethods.map(
//                                                 (submethod) => (
//                                                   <div
//                                                     key={submethod.unit_id}
//                                                     className="mb-4"
//                                                   >
//                                                   <label className="block font-medium mb-2">
//                                                   {submethod.unit_title} (₹{submethod.unit_price})
//                                                 </label>
//                                                     <select
//                                                       className="w-full p-2 border rounded-lg"
//                                                       onChange={(e) => {
//                                                         const selectedQuantity =
//                                                           parseInt(
//                                                             e.target.value,
//                                                             10
//                                                           );
//                                                         addItemToBill(
//                                                           submethod.unit_id,
//                                                           submethod.unit_title,
//                                                           selectedQuantity,
//                                                           submethod.unit_price
//                                                         );
//                                                       }}
//                                                     >
//                                                       <option value="">
//                                                         Select Quantity
//                                                       </option>
//                                                       {[
//                                                         ...Array(
//                                                           submethod.unit_max -
//                                                             submethod.unit_min +
//                                                             1
//                                                         ).keys(),
//                                                       ].map((qty) => {
//                                                         const quantity =
//                                                           1 + qty;
//                                                         return (
//                                                           <option
//                                                             key={quantity}
//                                                             value={quantity}
//                                                           >
//                                                             {quantity}
//                                                           </option>
//                                                         );
//                                                       })}
//                                                     </select>
//                                                   </div>
//                                                 )
//                                               )}
//                                             </div>

//                                             {/* Desktop & Tablet View - Buttons */}
//                                             <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-2 gap-2">
//                                               {selectedMethod.submethods.map(
//                                                 (submethod) => (
//                                                   <div
//                                                     key={submethod.unit_id}
//                                                     className="mb-4"
//                                                   >
//                                                     <label className="block font-medium mb-2">
//                                                       {submethod.unit_title}{" "}
//                                                       &nbsp;(₹
//                                                       {submethod.unit_price})
//                                                     </label>
//                                                     <select
//                                                         className="w-full p-2 border rounded-lg"
//                                                         onChange={(e) => {
//                                                           const selectedQuantity = parseInt(e.target.value, 10);
//                                                           addItemToBill(
//                                                             submethod.unit_id,
//                                                             submethod.unit_title,
//                                                             selectedQuantity,
//                                                             submethod.unit_price,
//                                                             service.service_title
//                                                           );
//                                                         }}
//                                                         value={
//                                                           bookingBill.find((item) => item.unit_id === submethod.unit_id)?.qty || ""
//                                                         }
//                                                       >
//                                                       <option value="">Select Quantity</option>
//                                                                       {[...Array(submethod.unit_max - submethod.unit_min + 1).keys()].map((qty) => {
//                                                                         const quantity = qty + 1;
//                                                                         return (
//                                                                           <option key={quantity} value={quantity}>
//                                                                             {quantity}
//                                                                           </option>
//                                                                         );
//                                                                       })}
//                                                                     </select>
//                                                                         </div>
//                                                                       ))}
//                                                                     </div>
//                                                                     </>
//                                                                   ) : (
//                                                                     <p className="text-gray-600">No submethods available for this method.</p>
//                                                                   )}
//                                                                 </div>
//                                                               )}
//                                                         </div>
//                                                 )}

//                                             {selectedMethod && (
//                                               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//                                                 {service.addons?.map((addon, index) => (
//                                                   <div
//                                                     key={index}
//                                                     className="p-4 border rounded-lg text-center bg-white shadow-md"
//                                                   >
//                                                     <p className="text-lg font-semibold mb-2">{addon.addon_name}</p>
//                                                     <p className="text-lg mb-4">Price: ₹{addon.addon_price}</p>
//                                                     <div className="flex items-center justify-center gap-2">
//                                                       <button
//                                                         type="button"
//                                                         onClick={() =>
//                                                           handleQuantityChange(
//                                                             index,
//                                                             false,
//                                                             addon.addon_name,
//                                                             addon.addon_price,
//                                                             addon.addon_maxqty
//                                                           )
//                                                         }
//                                                         className="p-2 bg-red-400 text-white rounded-lg"
//                                                       >
//                                                         -
//                                                       </button>
//                                                       <span className="text-lg">{quantities[index] || 0}</span>
//                                                       <button
//                                                         type="button"
//                                                         onClick={() =>
//                                                           handleQuantityChange(
//                                                             index,
//                                                             true,
//                                                             addon.addon_name,
//                                                             addon.addon_price,
//                                                             addon.addon_maxqty
//                                                           )
//                                                         }
//                                                         className="p-2 bg-green-400 text-white rounded-lg"
//                                                         disabled={quantities[index] >= addon.addon_maxqty}
//                                                       >
//                                                         +
//                                                       </button>
//                                                     </div>
//                                                   </div>
//                                                 ))}
//                                               </div>
//                                             )}
//                             </div>
//                           </>
//                         ))}
//                     </div>
//                   )}

//                   <div className="p-4">
//                     <h2 className="text-lg font-semibold mb-4 text-center sm:text-left">
//                       How often would you like us to provide service?
//                     </h2>
//                     <div className="flex flex-wrap justify-center sm:justify-start gap-4">
//                       {Services_frequently_discount?.map((v) => (
//                         <div className="flex flex-col items-center w-28 sm:w-auto">
//                           <button
//                             type="button"
//                             className={`px-6 py-2 w-full sm:w-auto border rounded-md ${
//                               selectedFrequency === v.discount_typename
//                                 ? "border-teal-500 text-teal-500"
//                                 : "border-gray-300"
//                             }`}
//                             onClick={() => {
//                               setSelectedFrequency(v?.discount_typename);
//                               setSelectedDiscount(v?.rates);
//                               setselectedservices(v?.id);
//                             }}
//                           >
//                             {v.discount_typename}
//                           </button>
//                           <p className="text-sm text-gray-500 mt-2">
//                             {v.labels}
//                           </p>
//                         </div>
//                       ))}
//                     </div>
//                   </div>

//                   {/* Service Provider Section */}
//                   <div>
//                     <h2 className="text-lg font-semibold mb-4">
//                       Please select provider
//                     </h2>
                   
//                     <div className="relative px-4 pb-4">
//                       {/* Previous Button */}
//                       <button
//                         type="button"
//                         onClick={() => scroll("prev")}
//                         className="absolute left-0 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full z-10 opacity-75 hover:opacity-100 transition-opacity"
//                       >
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           className="w-6 h-6"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M15 19l-7-7 7-7"
//                           />
//                         </svg>
//                       </button>

//                       {/* Scrollable Container */}
//                       <div
//                         ref={scrollRef}
//                         className="flex overflow-x-auto lg:flex lg:space-x-8 px-4 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
//                       >
//                         {adminData?.length > 0 ? (
//                           adminData.map((provider, index) => (
//                             <div
//                               key={index}
//                               className={`flex flex-col items-center cursor-pointer flex-shrink-0 ${
//                                 selectedProvider === provider
//                                   ? "border-teal-500"
//                                   : "border-gray-300"
//                               } border rounded-md p-4 m-2 sm:m-5 w-full sm:w-auto max-w-xs mx-auto`}
//                               onClick={() => {
//                                 setSelectedProvider(provider);
//                                 setgetidbyadmin(provider.id); // Assuming you want to set staff ID here
//                               }}
//                             >
//                               <img
//                                 src={provider.image || "default-image.jpg"} // Fallback image if none provided
//                                 className="w-16 h-16 sm:w-24 sm:h-24 rounded-full mb-2 object-cover"
//                               />
//                               <p className="font-semibold text-gray-800 text-center text-sm sm:text-base">
//                                 {provider.fullname}
//                               </p>
//                               {/* Rating */}
//                               <div className="flex space-x-1 mt-2">
//                                 {[...Array(5)].map((_, i) => (
//                                   <svg
//                                     key={i}
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     fill={i < 4 ? "currentColor" : "none"}
//                                     viewBox="0 0 24 24"
//                                     stroke="currentColor"
//                                     className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400"
//                                   >
//                                     <path
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                       strokeWidth={2}
//                                       d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
//                                     />
//                                   </svg>
//                                 ))}
//                               </div>
//                             </div>
//                           ))
//                         ) : (
//                           <p className="text-gray-500 text-center w-full">
//                             No staff available for the selected service.
//                           </p>
//                         )}
//                       </div>

//                       {/* Next Button */}
//                       <button
//                         type="button"
//                         onClick={() => scroll("next")}
//                         className="absolute right-0 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full z-10 opacity-75 hover:opacity-100 transition-opacity"
//                       >
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           className="w-6 h-6"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M9 5l7 7-7 7"
//                           />
//                         </svg>
//                       </button>
//                     </div>
//                               </div>

//                   <div>
//                     {/* Left Column - Calendar */}
//                     <div className="max-auto bg-white">
//                       <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
//                         <div className="text-center mb-8">
//                           <h2 className="text-3xl sm:text-4xl font-bold text-gray-800">
//                             Book Your Appointment
//                           </h2>
//                         </div>

//                         {/* Calendar */}
//                         <div>
//                           <div>
//                             <div className="flex flex-col items-center mb-6 px-2 py-2 overflow-hidden ">
//                               <div className="flex justify-between items-center w-full max-w-4xl px-4 mb-4">
//                                 <button
//                                   type="button"
//                                   onClick={handlePrevMonth}
//                                   className="bg-gray-200 text-gray-800 px-3 py-1 rounded-md shadow-md hover:bg-gray-300"
//                                 >
//                                   Previous
//                                 </button>
//                                 <h2 className="text-xl font-semibold text-gray-700">
//                                   {currentDate.toLocaleString("default", {
//                                     month: "long",
//                                   })}{" "}
//                                   {currentDate.getFullYear()}
//                                 </h2>
//                                 <button
//                                   type="button"
//                                   onClick={handleNextMonth}
//                                   className="bg-gray-200 text-gray-800 px-3 py-1 rounded-md shadow-md hover:bg-gray-300"
//                                 >
//                                   Next
//                                 </button>
//                               </div>

//                               <div className="grid grid-cols-4 sm:grid-cols-7 gap-4 p-4 bg-gray-100 rounded-2xl shadow-inner">
//                                 {calendar?.map((week, index) => (
//                                   <div key={index} className="contents">
//                                     {week?.map((day, dayIndex) => {
//                                       const currentDay = new Date(
//                                         currentDate.getFullYear(),
//                                         currentDate.getMonth(),
//                                         day
//                                       );
//                                       const isPastDate =
//                                         currentDay <
//                                         new Date().setHours(0, 0, 0, 0);
//                                       const isSelected =
//                                         daySelected === day && !isPastDate; // Check if this day is selected

//                                       return (
//                                         <button
//                                           key={dayIndex}
//                                           type="button"
//                                           className={`w-12 h-12 sm:w-16 sm:h-12 flex items-center justify-center rounded-full transition-all duration-300 ease-in-out 
//                                         ${
//                                           day
//                                             ? "cursor-pointer"
//                                             : "cursor-default"
//                                         }
//                                         ${
//                                           day
//                                             ? "hover:bg-blue-200 hover:text-white hover:shadow-lg hover:scale-110"
//                                             : "opacity-0"
//                                         }
//                                         ${
//                                           isPastDate
//                                             ? "bg-gray-300 text-gray-500 cursor-not-allowed"
//                                             : "bg-white text-gray-700 border border-gray-200"
//                                         }
//                                         ${
//                                           day === daySelected
//                                             ? " !bg-blue-500 !text-white"
//                                             : ""
//                                         }`} // Red background for selected date
//                                           onClick={() => handleDateClick(day)}
//                                           disabled={!day || isPastDate}
//                                         >
//                                           {day}
//                                         </button>
//                                       );
//                                     })}
//                                   </div>
//                                 ))}
//                               </div>

//                               {selectedDate && (
//                                 <div className="mt-4">
//                                   <h3 className="text-lg font-semibold mb-4">
//                                     Available Times for{" "}
//                                     {format(selectedDate, "dd-MM-yyyy")}
//                                   </h3>
//                                   <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
//                                     {timeSlots?.map((slot, index) => {
//                                       // Convert slot time to Date object for comparison
//                                       const [hours, minutes] = slot.split(":");
//                                       const slotDate = new Date(selectedDate);
//                                       slotDate.setHours(
//                                         parseInt(hours),
//                                         parseInt(minutes),
//                                         0
//                                       );

//                                       // Check if slot is in the past
//                                       const isPast = slotDate < new Date();

//                                       return (
//                                         <button
//                                           type="button"
//                                           key={index}
//                                           onClick={() =>
//                                             !isPast && handleTimeSelect(slot)
//                                           }
//                                           disabled={isPast}
//                                           className={`
//                                                       py-3 px-4 rounded-xl text-sm font-semibold transition-all duration-200
//                                                       ${
//                                                         isPast
//                                                           ? "bg-gray-100 text-gray-400 cursor-not-allowed opacity-60"
//                                                           : selectedTime ===
//                                                             slot
//                                                           ? "bg-blue-600 text-white shadow-md transform scale-105"
//                                                           : "bg-white text-gray-800 hover:bg-blue-50 hover:text-blue-600 border border-gray-200"
//                                                       }
//                                                     `}
//                                         >
//                                           <div className="flex flex-col items-center space-y-1">
//                                             <span>{slot}</span>
//                                             <span className="text-xs font-normal">
//                                               {isPast
//                                                 ? "Not Available"
//                                                 : "Available"}
//                                             </span>
//                                           </div>
//                                         </button>
//                                       );
//                                     })}
//                                   </div>
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className=" mx-auto p-6 border border-gray-300 ">
//                     <h2 className="text-xl font-bold mb-4">
//                       Your Personal Details
//                     </h2>
//                     <p className="text-sm text-gray-600 mb-4">
//                       Please provide your address and contact details
//                     </p>
//                     <div className="w-full mx-auto bg-white rounded-lg p-8">
//                       {/* Radio Buttons */}
//                       <div className="flex items-center space-x-6 mb-6">
//                         <label className="flex items-center">
//                           <input
//                             type="radio"
//                             name="userType"
//                             value="existing"
//                             checked={userType === "existing"}
//                             onChange={() => handleUserTypeChange("existing")}
//                             className="mr-2"
//                           />
//                           Existing User
//                         </label>
//                         {/* Conditionally render New User radio button only if not logged in */}
//                         {!isLoggedIn && (
//                           <label className="flex items-center">
//                             <input
//                               type="radio"
//                               name="userType"
//                               value="new"
//                               checked={userType === "new"}
//                               onChange={() => handleUserTypeChange("new")}
//                               className="mr-2"
//                             />
//                             New User
//                           </label>
//                         )}
//                       </div>
//                       {isLoggedIn ? (
//                         <div className="max-w-lg mx-auto bg-white rounded-lg shadow-lg p-6 mt-6 transform transition-all ">
//                           <div className="flex justify-between items-center mb-4">
//                             <h2 className="text-xl font-semibold text-green-600">
//                               You are logged innn!
//                             </h2>
//                             <button
//                               onClick={handleLogout}
//                               className="px-4 py-2 bg-red-500 text-white rounded-md shadow-md hover:bg-red-600 transition duration-200 text-sm"
//                             >
//                               Logout
//                             </button>
//                           </div>
//                           {getuserdataa ? (
//                             <div className="space-y-4">
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Name:
//                                 </span>
//                                 <p className="text-gray-800">{`${getuserdataa?.first_name} ${getuserdataa?.last_name}`}</p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Email:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.user_email}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Phone:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.phone || "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Address:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.address ||
//                                     getuserdataa?.street_address ||
//                                     "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Zip Code:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.zip || "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   City:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.city || "N/A"}
//                                 </p>
//                               </div>
//                               {/* <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   State:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.state || "N/A"}
//                                 </p>
//                               </div> */}
//                             </div>
//                           ) : (
//                             <div className="space-y-4">
//                               {/* <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Name:
//                                 </span>
//                                 <p className="text-gray-800">{`${getuserdataa?.first_name} ${getuserdataa?.last_name}`}</p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Email:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.user_email || "n/a"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Phone:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.phone || "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Address:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.address ||
//                                     getuserdataa?.street_address ||
//                                     "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Zip Code:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.zip || "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   City:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.city || "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   State:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.state || "N/A"}
//                                 </p>
//                               </div> */}
//                               <h1 classN > But Only user Login </h1>
//                             </div>
//                             // <p className="text-gray-500 text-center">Loading user details...</p>
//                           )}
//                         </div>
//                       ) : (
//                         // Show this if user is NOT logged in
//                         <>
//                           {userType === "existing" ? (
//                             <div>
//                               <div className="space-y-5">
//                                 <div>
//                                   <label
//                                     htmlFor="email"
//                                     className="block text-sm font-medium text-gray-700 mb-1"
//                                   >
//                                     Email address
//                                   </label>
//                                   <input
//                                     type="email"
//                                     id="email"
//                                     value={email}
//                                     onChange={(e) => setEmail(e.target.value)}
//                                     className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 transition"
//                                     placeholder="Enter your email"
//                                   />
//                                 </div>
//                                 <div className="relative">
//                                   <label
//                                     htmlFor="password"
//                                     className="block text-sm font-medium text-gray-700 mb-1"
//                                   >
//                                     Password
//                                   </label>
//                                   <input
//                                     type={showPassword ? "text" : "password"}
//                                     id="password"
//                                     value={password}
//                                     onChange={(e) =>
//                                       setPassword(e.target.value)
//                                     }
//                                     className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 transition pr-10"
//                                     placeholder="Enter your password"
//                                   />
//                                   <button
//                                     type="button"
//                                     className="absolute right-3 top-9 text-gray-500"
//                                     onClick={() =>
//                                       setShowPassword(!showPassword)
//                                     }
//                                   >
//                                     {showPassword ? (
//                                       <EyeOffIcon size={20} />
//                                     ) : (
//                                       <EyeIcon size={20} />
//                                     )}
//                                   </button>
//                                 </div>
//                                 <div className="flex justify-center">
//                                   <button
//                                     onClick={handleLogin}
//                                     disabled={loading}
//                                     className={`w-32 bg-blue-500 text-white py-2 rounded-lg shadow-md hover:bg-blue-600 transition text-sm flex justify-center items-center ${
//                                       loading
//                                         ? "opacity-50 cursor-not-allowed"
//                                         : ""
//                                     }`}
//                                   >
//                                     {loading ? (
//                                       <Circles
//                                         height="20"
//                                         width="20"
//                                         color="#fff"
//                                       />
//                                     ) : (
//                                       "Log in"
//                                     )}
//                                   </button>
//                                 </div>
//                               </div>
//                               {error && (
//                                 <p className="text-center text-sm mt-4 text-red-500">
//                                   {error}
//                                 </p>
//                               )}
//                               {successMessage && (
//                                 <p className="text-center text-sm mt-4 text-green-500">
//                                   {successMessage}
//                                 </p>
//                               )}
//                             </div>
//                           ) : (
                          
//                             <div className="grid grid-cols-1 gap-4 mb-6 p-6 bg-white shadow-lg rounded-lg max-w-lg mx-auto">
//                             {/* Email */}
//                             <input
//                               type="email"
//                               name="email"
//                               placeholder="Preferred Email"
//                               value={userDetails.email || ""}
//                               onChange={handleUserDetailsChange}
//                               className="border p-2 rounded-md w-full"
//                             />
                          
//                             {/* Password */}
//                             <input
//                               type="password"
//                               name="password"
//                               placeholder="Preferred Password"
//                               value={userDetails.password || ""}
//                               onChange={handleUserDetailsChange}
//                               className="border p-2 rounded-md w-full"
//                             />
                          
//                             {/* First Name and Last Name */}
//                             <div className="grid grid-cols-2 gap-4">
//                               <input
//                                 type="text"
//                                 name="firstName"
//                                 placeholder="First Name"
//                                 value={userDetails.firstName || ""}
//                                 onChange={handleUserDetailsChange}
//                                 className="border p-2 rounded-md"
//                               />
//                               <input
//                                 type="text"
//                                 name="lastName"
//                                 placeholder="Last Name"
//                                 value={userDetails.lastName || ""}
//                                 onChange={handleUserDetailsChange}
//                                 className="border p-2 rounded-md"
//                               />
//                             </div>
                          
//                             {/* Phone and Street Address */}
//                             <div className="grid grid-cols-2 gap-4">
//                               <input
//                                 type="text"
//                                 name="phone"
//                                 placeholder="Phone"
//                                 value={userDetails.phone || ""}
//                                 onChange={handleUserDetailsChange}
//                                 className="border p-2 rounded-md"
//                               />
//                               <input
//                                 type="text"
//                                 name="streetAddress"
//                                 placeholder="Street Address"
//                                 value={userDetails.streetAddress || ""}
//                                 onChange={handleUserDetailsChange}
//                                 className="border p-2 rounded-md w-full"
//                               />
//                             </div>
                          
//                             {/* Zip Code, City, and State */}
//                             <div className="grid grid-cols-3 gap-4">
//                               <input
//                                 type="text"
//                                 name="zipCode"
//                                 placeholder="Zip Code"
//                                 value={userDetails.zipCode || ""}
//                                 onChange={handleUserDetailsChange}
//                                 className="border p-2 rounded-md"
//                               />
//                               <input
//                                 type="text"
//                                 name="city"
//                                 placeholder="City"
//                                 value={userDetails.city || ""}
//                                 onChange={handleUserDetailsChange}
//                                 className="border p-2 rounded-md"
//                               />
//                               <input
//                                 type="text"
//                                 name="state"
//                                 placeholder="State"
//                                 value={userDetails.state || ""}
//                                 onChange={handleUserDetailsChange}
//                                 className="border p-2 rounded-md"
//                               />
//                             </div>
                          
//                             {/* Special Requests */}
//                             <textarea
//                               name="specialRequests"
//                               placeholder="Special Requests (Notes)"
//                               value={userDetails.specialRequests || ""}
//                               onChange={handleUserDetailsChange}
//                               className="border p-2 rounded-md w-full"
//                               rows="3"
//                             ></textarea>
                          
//                             {/* Vacuum Cleaner */}
//                             <div className="flex justify-between items-center mb-4">
//                               <span className="text-gray-700">Do you have a vacuum cleaner?</span>
//                               <div className="flex space-x-4">
//                                 <label className="flex items-center space-x-1">
//                                   <input
//                                     type="radio"
//                                     name="vacuum"
//                                     value="yes"
//                                     checked={vacuum === "yes"}
//                                     onChange={() => setVacuum("yes")}
//                                     className="accent-blue-500"
//                                   />
//                                   <span>Yes</span>
//                                 </label>
//                                 <label className="flex items-center space-x-1">
//                                   <input
//                                     type="radio"
//                                     name="vacuum"
//                                     value="no"
//                                     checked={vacuum === "no"}
//                                     onChange={() => setVacuum("no")}
//                                     className="accent-gray-500"
//                                   />
//                                   <span>No</span>
//                                 </label>
//                               </div>
//                             </div>
                          
//                             {/* Parking */}
//                             <div className="flex justify-between items-center mb-4">
//                               <span className="text-gray-700">Do you have parking?</span>
//                               <div className="flex space-x-4">
//                                 <label className="flex items-center space-x-1">
//                                   <input
//                                     type="radio"
//                                     name="parking"
//                                     value="yes"
//                                     checked={parking === "yes"}
//                                     onChange={() => setParking("yes")}
//                                     className="accent-blue-500"
//                                   />
//                                   <span>Yes</span>
//                                 </label>
//                                 <label className="flex items-center space-x-1">
//                                   <input
//                                     type="radio"
//                                     name="parking"
//                                     value="no"
//                                     checked={parking === "no"}
//                                     onChange={() => setParking("no")}
//                                     className="accent-gray-500"
//                                   />
//                                   <span>No</span>
//                                 </label>
//                               </div>
//                             </div>
                          
//                             {/* How will we get in? */}
//                             <div className="mb-4">
//                               <label className="block text-gray-700 mb-2">How will we get in?</label>
//                               <select
//                                 value={access}
//                                 onChange={(e) => setAccess(e.target.value)}
//                                 className="w-full p-2 border border-gray-300 rounded-lg"
//                               >
//                                 <option value="home">I'll be at home</option>
//                                 <option value="please">Please call me</option>
//                                 <option value="doorman">The key is with the doorman</option>
//                                 <option value="other">Other</option>
//                               </select>
//                             </div>
                          
//                             {/* Submit Button */}
//                             <button
//                               onClick={handleSubmitdata}
//                               className="bg-blue-500 text-white p-2 rounded-md w-full"
//                             >
//                               Booked And New User Created
//                             </button>
//                           </div>
//                           )}
//                         </>
//                       )}
//                     </div>
//                     <div className="max-w-md mx-auto border rounded-lg shadow-lg mt-5 p-5 bg-white">
//                       <h3 className="text-lg font-semibold mb-3">
//                         Apply Promo Code
//                       </h3>
//                       <div className="flex gap-2">
//                         <input
//                           type="text"
//                           value={promoCode}
//                           onChange={(e) => setPromoCode(e.target.value)}
//                           placeholder="Enter promo code"
//                           className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         />
//                         <button
//                           type="button"
//                           onClick={handleApplyPromoCode}
//                           className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
//                         >
//                           Apply
//                         </button>
//                       </div>

//                       {/* Error Message */}
//                       {error && <p className="text-red-600 mt-2">{error}</p>}

//                       {/* Success Message & Cancel Button */}
//                       {appliedPromoCode && (
//                         <div className="flex justify-between items-center mt-2 p-2 bg-green-100 rounded-md">
//                           <p className="text-green-700">
//                             Promo code "{appliedPromoCode.coupon_code}" applied!
//                             ({appliedPromoCode.coupon_value}
//                             {appliedPromoCode.coupon_type === "P"
//                               ? "%"
//                               : "$"}{" "}
//                             off)
//                           </p>
//                           <button
//                             type="button"
//                             onClick={handleCancelPromo}
//                             className="text-red-600 font-semibold hover:underline"
//                           >
//                             Cancel
//                           </button>
//                         </div>
//                       )}
//                     </div>

                  

//                     {/* Payment Method */}
//                     <div className="mb-6">
//                       <h3 className="font-bold mb-2">
//                         Preferred Payment Method
//                       </h3>

//                       {/* Pay Locally option */}
//                       <label className="flex items-center">
//                         <input
//                           type="radio"
//                           name="paymentMethod"
//                           value="payLocally"
//                           checked={paymentMethod === "payLocally"}
//                           onChange={handlePaymentChange}
//                           className="mr-2"
//                         />
//                         Pay Locally
//                       </label>

//                       {/* Pay Online option */}
//                       <label className="flex items-center ">
//                         <input
//                           type="radio"
//                           name="paymentMethod"
//                           value="payOnline"
//                           checked={paymentMethod === "payOnline"}
//                           onChange={handlePaymentChange}
//                           className="mr-2"
//                         />
//                         Pay Online
//                       </label>
//                     </div>

//                     {/* Terms & Conditions */}
//                     <div className="mb-6">
//                       <label className="items-center flex">
//                         <input
//                           type="checkbox"
//                           className="mr-2"
//                           checked={isChecked}
//                           onChange={() => setIsChecked(!isChecked)}
//                         />
//                         I have read and accepted the{" "}
//                         <a className="text-teal-600 underline" href="#terms">
//                           Terms & Conditions
//                         </a>
//                         .
//                       </label>
//                     </div>

//                     <div id="terms" className="mt-4 text-sm text-gray-700">
//                       <h3 className="font-semibold">Terms & Conditions</h3>
//                       <p>
//                         By confirming your booking, you agree to the following
//                         conditions:
//                       </p>
//                       <ul className="list-disc list-inside">
//                         <li>
//                           You must make any edits or reschedule your appointment
//                           at least 15 days before the selected booking date.
//                         </li>
//                         <li>
//                           If you attempt to edit, reschedule, or cancel your
//                           appointment within 15 days of the booking date, you
//                           will not be able to make any changes.
//                         </li>
//                       </ul>
//                     </div>
//                   </div>

//                   {/* Submit Button */}
//                   <div className="flex justify-center mt-6">
//                     <button
//                       type="submit"
//                       className="bg-blue-800 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-600 transition duration-300"
//                     >
//                       Submit Booking
//                     </button>
//                   </div>
//                 </form>
//               </div>

//               {isModalVisible && (
//                 <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
//                   <div className="bg-white p-6 rounded-lg shadow-lg text-center">
//                     <h2 className="text-xl font-bold text-green-600">
//                       Thank You!
//                     </h2>
//                     <p className="mt-2">{bookingSuccessMessage}</p>
//                     <p>Great! Your appointment is booked successfully.</p>
//                     <p>
//                       Thank you for booking your appointment with MegaClean!
//                     </p>
//                   </div>
//                 </div>
//               )}

//               {/* Right Section - Privacy Policy */}

//               <div>
//                 <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-all duration-300 z-40">
//                   {/* SAFETY Section */}
//                   <div className="flex justify-center my-4 group">
//                     <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300 transform group-hover:scale-110">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="w-8 h-8"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
//                         />
//                       </svg>
//                     </div>
//                   </div>
//                   <h2 className="text-xl font-bold text-gray-800 text-center mb-2 relative group">
//                     <span className="bg-gradient-to-r from-blue-500 to-blue-700 bg-[length:0%_2px] group-hover:bg-[length:100%_2px] bg-no-repeat bg-bottom transition-all duration-500">
//                       SAFETY
//                     </span>
//                   </h2>
//                   <p className="text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
//                     Safety is a top priority in cleaning services to protect
//                     both clients and staff. This includes using non-toxic
//                     cleaning products, following proper sanitation protocols,
//                     and ensuring staff are trained in safe handling of
//                     equipment. Additionally, background checks and insurance
//                     coverage provide extra security for clients.
//                   </p>
//                   <div className="border border-t mt-4  group-hover:w-full transition-all duration-500 mx-auto" />

//                   {/* Best in Quality Section */}
//                   <div className="flex justify-center my-4 group">
//                     <div className="w-14 h-14 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 group-hover:bg-purple-600 group-hover:text-white transition-all duration-300 transform group-hover:scale-110">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="w-8 h-8"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
//                         />
//                       </svg>
//                     </div>
//                   </div>
//                   <h2 className="text-xl font-bold text-gray-800 text-center mb-2 relative group">
//                     <span className="bg-gradient-to-r from-purple-500 to-purple-700 bg-[length:0%_2px] group-hover:bg-[length:100%_2px] bg-no-repeat bg-bottom transition-all duration-500">
//                       Best in Quality
//                     </span>
//                   </h2>
//                   <p className="text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
//                     Providing the best quality cleaning means using top-grade
//                     cleaning products, advanced equipment, and skilled
//                     professionals. Attention to detail, thorough sanitization,
//                     and consistent service ensure a spotless and hygienic
//                     environment. Customer satisfaction is the key measure of
//                     quality excellence.
//                   </p>
//                   <div className="border border-t mt-4  group-hover:w-full transition-all duration-500 mx-auto" />

//                   {/* Communication Section */}
//                   <div className="flex justify-center my-4 group">
//                     <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center text-green-600 group-hover:bg-green-600 group-hover:text-white transition-all duration-300 transform group-hover:scale-110">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="w-8 h-8"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
//                         />
//                       </svg>
//                     </div>
//                   </div>
//                   <h2 className="text-xl font-bold text-gray-800 text-center mb-2 relative group">
//                     <span className="bg-gradient-to-r from-green-500 to-green-700 bg-[length:0%_2px] group-hover:bg-[length:100%_2px] bg-no-repeat bg-bottom transition-all duration-500">
//                       Communication
//                     </span>
//                   </h2>
//                   <p className="text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
//                     Effective communication ensures clarity between clients and
//                     the cleaning service provider. This includes promptly
//                     responding to inquiries, understanding customer needs, and
//                     providing clear service details. Regular updates and
//                     feedback channels help build trust and improve service
//                     quality.
//                   </p>
//                   <div className="border border-t mt-4  group-hover:w-full transition-all duration-500 mx-auto" />

//                   {/* Saves You Time Section */}
//                   <div className="flex justify-center my-4 group">
//                     <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center text-amber-600 group-hover:bg-amber-600 group-hover:text-white transition-all duration-300 transform group-hover:scale-110">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="w-8 h-8"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                         />
//                       </svg>
//                     </div>
//                   </div>
//                   <h2 className="text-xl font-bold text-gray-800 text-center mb-2 relative group">
//                     <span className="bg-gradient-to-r from-amber-500 to-amber-700 bg-[length:0%_2px] group-hover:bg-[length:100%_2px] bg-no-repeat bg-bottom transition-all duration-500">
//                       Saves You Time
//                     </span>
//                   </h2>
//                   <p className="text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
//                     Professional cleaning services save you time by handling all
//                     the cleaning tasks efficiently, allowing you to focus on
//                     work, family, or personal activities. With trained experts
//                     and the right tools, cleaning is done faster and more
//                     effectively than DIY efforts. This convenience enhances
//                     productivity and reduces stress.
//                   </p>
//                   <div className="border border-t mt-4  group-hover:w-full transition-all duration-500 mx-auto" />

//                   {/* Card Payment Section */}
//                   <div className="flex justify-center my-4 group">
//                     <div className="w-14 h-14 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300 transform group-hover:scale-110">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="w-8 h-8"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
//                         />
//                       </svg>
//                     </div>
//                   </div>
//                   <h2 className="text-xl font-bold text-gray-800 text-center mb-2 relative group">
//                     <span className="bg-gradient-to-r from-indigo-500 to-indigo-700 bg-[length:0%_2px] group-hover:bg-[length:100%_2px] bg-no-repeat bg-bottom transition-all duration-500">
//                       Card Payment
//                     </span>
//                   </h2>
//                   <p className="text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
//                     Offering card payment options provides a convenient and
//                     secure way for customers to pay for services. It eliminates
//                     the hassle of cash transactions, ensures quick processing,
//                     and enhances customer trust. Secure payment gateways also
//                     protect customer data and prevent fraud.
//                   </p>
//                 </div>

//                 <div className="max-w-md mx-auto border rounded-lg shadow-lg mt-10 p-5 bg-white sticky top-10">
//                   <h2 className="text-xl font-bold text-center border-b pb-3 mb-4">
//                     Booking Summary
//                   </h2>

//                   <div className="flex items-center text-sm text-black-800 mb-4">
//                     <div className="flex items-center space-x-2">
//                       <span className="material-icons font-bold text-black-800">
//                         Calendar Today :
//                       </span>
//                       {selectedDate && selectedTime && (
//                         <p>
//                           {selectedDate} @ {selectedTime}
//                         </p>
//                       )}
//                     </div>
//                   </div>
//                   <div className="flex items-center space-x-2">
//                     <span className="material-icons font-bold text-black-900">
//                       Auto Renew :
//                     </span>
//                     <p>{selectedFrequency}</p>
//                   </div>
//                   <div className="flex items-center space-x-2  text-black-900">
//                     <span className="material-icons font-bold text-black-900">
//                       Time duration :
//                     </span>
//                     <p>
//                       {Math.floor(totalTime / 60)} Hours {totalTime % 60}{" "}
//                       Minutes
//                     </p>

//                   </div>
//  <div className="flex items-center space-x-2 mb-4">
//                     <span className="material-icons font-bold text-black-900">
//                     Payment Method :-
//                     </span>
//                     <p>{paymentMethod}</p>
//                   </div>
//                   <div className="mb-6">
//                       <h3 className="font-bold mb-2">Cart Items :</h3>
//                       <ul>
//                         {bookingBill.map((item, idx) => (
//                           <li key={idx} className="flex justify-between mb-2">
//                             <span>
//                               {item.name}{item.type} (x{item.qty})
//                             </span>
//                             <div className="flex gap-4">
//                               <span>₹{item.rate}</span>
//                               <span
//                                 onClick={() => removeItem(idx)}
//                                 className="text-red-500 cursor-pointer"
//                               >
//                                 X
//                               </span>
//                             </div>
//                           </li>
//                         ))}
//                       </ul>
//                     </div>

//                   <div className="border-t pt-4 text-black-800">
//                     <div className="flex justify-between font-bold mb-2">
//                       <p>Sub Total :</p>
//                       <p>₹{isNaN(calculateTotal()) ? 0 : calculateTotal()}</p>
//                     </div>
//                     <div className="flex justify-between font-bold mb-2">
//                       <p>Frequently Discount :</p>
//                       <p>-₹{Disamount}</p>
//                     </div>
//                     {appliedPromoCode && (
//                       <div className="flex justify-between font-bold mb-2">
//                         <p>Promo Code ({appliedPromoCode.coupon_code}) :</p>
//                         <p>-₹{promoDiscount}</p>
//                       </div>
//                     )}
//                     <div className="flex font-bold justify-between mb-4">
//                       <p>Tax :</p>
//                       <p>₹{tax}</p>
//                     </div>
//                     <div className="flex justify-between font-bold text-lg">
//                       <p>Total :</p>
//                       <p>₹{parseFloat(text).toFixed(2)}</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default MyBookingPage;











// import React, { useState, useEffect, useRef } from "react";
// import { addHours } from "date-fns";
// import { EyeIcon, EyeOffIcon } from "lucide-react";

// import { Link, useNavigate } from "react-router-dom";
// import {
//   format,
//   addMonths,
//   subMonths,
//   startOfWeek,
//   endOfWeek,
//   addDays,
//   subDays,
// } from "date-fns";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import image1 from "../assets/house.png";
// import fridgeCleaning from "../assets/fridge.png";
// import ovenCleaning from "../assets/oven.png";
// import windowCleaning from "../assets/windows.png";
// import Bed from "../assets/beds.png";
// import axios from "axios";
// import { BaseUrl } from "../App";
// 
// import { Circles } from "react-loader-spinner";

// import { useAuth } from "../components/AuthContext";

// const MyBookingPage = () => {
//   const { isAuthenticated } = useAuth();

//   const [email, setEmail] = useState(""); // State for email input
//   const [password, setPassword] = useState(""); // State for password input
//   const [UserTypelocal, setUserTypelocal] = useState(null);
//   const [currentMonth, setCurrentMonth] = useState(new Date());
//   const [activeView, setActiveView] = useState("month"); // Manage active view: 'month', 'week', or 'day'
//   const [showModal, setShowModal] = useState(false);
//   const [isChecked, setIsChecked] = useState(false);
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [getidbyadmin, setgetidbyadmin] = useState(null);
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [selectedOption, setSelectedOption] = useState("");
//   // const [crmgetdata, setCrmgetdata] = useState([]);
//   console.log(getidbyadmin);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showBookingSummary, setShowBookingSummary] = useState(false);
//   const [showBookingSummary2, setShowBookingSummary2] = useState(false);
//   const [isServiceOpen, setIsServiceOpen] = useState(false); // Toggle "Choose Services"
//   const [isCalendarOpen, setIsCalendarOpen] = useState(false); // Toggle Calendar panel
//   const [isFormOpen, setIsFormOpen] = useState(false);
//   // const [selectedOption, setSelectedOption] = useState("");
//   const [userId, setUserId] = useState(null);
//   const [bookingSuccessMessage, setBookingSuccessMessage] = useState("");
//   const [daySelected, setDaySelected] = useState(null); // Track selected day
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [loading, setLoading] = useState(false);
//   // const [apiCallsPending, setApiCallsPending] = useState(0)
//   const [successMessage, setSuccessMessage] = useState("");
//   const [error, setError] = useState("");
//   const [allServices, setallServices] = useState([]);
//   console.log(allServices);
//   // Add these state variables at the top with your existing states
//   const [settings, setSettings] = useState({});
//   const [zipCodeError, setZipCodeError] = useState("");
//   const [useriddata, setuseriddata] = useState(null);
//   console.log(useriddata);
//   const [idpromocode, setidpromocode] = useState(null);
//   const [optiondata, setoptiondata] = useState([]);
//   const [personalDetails, setPersonalDetails] = useState({
//     streetAddress: "",
//     zipCode: "",
//     city: "",
//     state: "",
//   });
//   const [appointmentDetails, setAppointmentDetails] = useState({
//     streetAddress: "",
//     zipCode: "",
//     city: "",
//     state: "",
//   });
//   const [hoveredEvent, setHoveredEvent] = useState(null);
//   const [userType, setUserType] = useState("new");
//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   useEffect(() => {
//     const user = sessionStorage.getItem("userId");
//     if (user) {
//       setuserid(user); // This sets `useridd`, not `useriddata`
//       setIsLoggedIn(true);
//     } else {
//       setIsLoggedIn(false);
//     }
//   }, []);

//   const [sameAsAbove, setSameAsAbove] = useState(false);
//   const [selectedFrequency, setSelectedFrequency] = useState("");
//   const [selectedDiscount, setSelectedDiscount] = useState(0);
//   const [Distext, setSelectedDistext] = useState(10);
//   const [text, setText] = useState();
//   const navigate = useNavigate();
//   const [selectedProvider, setSelectedProvider] = useState(null);
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [selectedTime, setSelectedTime] = useState(null);
//   const [selectedservices, setselectedservices] = useState(0);
//   const [showImageSection, setShowImageSection] = useState(false);
//   const [selectedService, setSelectedService] = useState(null);
//   const [residential, setResidential] = useState(false);
//   const [commercial, setCommercial] = useState(false);
//   const [bookingBill, setBookingBill] = useState([]);
//   console.log(bookingBill);
//   const [bedroom, setBedroom] = useState({});
//   const [bathroom, setBathroom] = useState(0);
//   const [quantities, setQuantities] = useState([0, 0, 0]);
//   const [officeresidential, setofficeResidential] = useState(false);
//   const [officecommercial, officesetCommercial] = useState(false);
//   const [showForm, setShowForm] = useState(false);
//   const [currentDate, setCurrentDate] = useState(new Date());
//   const [bookedSlots, setBookedSlots] = useState({});
//   const [selectedMethod, setSelectedMethod] = useState(null);
//   const [featuresContent, setFeaturesContent] = useState([]);

//   console.log(selectedMethod);
//   const [bookingappointment, setbookingappointment] = useState([]);
//   console.log(bookingappointment);
//   const [propertyQuantities, setPropertyQuantities] = useState({
//     Build_walls: 0,
//     Build_doors: 0,
//     Build_windows: 0,
//   });
//   const [officeQuantities, setOfficeQuantities] = useState({
//     desk: 0,
//     window: 0,
//   });
//   const [tax, settax] = useState(0);
//   const [damagedFloors, setDamagedFloors] = useState(0);
//   const [doorJams, setDoorJams] = useState(0);
//   const [packing, setPacking] = useState(0);
//   const [storeroom, setStoreroom] = useState(0);
//   const [area, setArea] = useState(0);
//   const [timeSlots, setTimeSlots] = useState([]);
//   console.log(timeSlots);
//   const [officearea, setOfficeArea] = useState(0);
//   const [extraDamagedFloors, setExtraDamagedFloors] = useState(0);
//   const [extraDoorJams, setExtraDoorJams] = useState(0);
//   const [Disamount, setDisamount] = useState(0);
//   const [officeextraDamagedFloors, setofficeExtraDamagedFloors] = useState(0);
//   const [officeextraDoorJams, setofficeExtraDoorJams] = useState(0);
//   const [adminData, setAdminData] = useState(null);
//   const [calenderdata, setcalenderdata] = useState([]);
//   const [Services_frequently_discount, setServices_frequently_discount] =
//     useState([]);
//   const [icon, setIcon] = useState("+"); // State to control the icon (either "+" or "-")
//   const [activeTab, setActiveTab] = useState("Residential");
//   const [formData, setFormData] = useState({
//     serviceLocation: "",
//     zipCode: "",
//     selectedService: "",
//     image: image1,
//     showHouseOptions: false,
//     showPlumbingOptions: false,
//     showCarpenterOptions: false,
//     showOfficeOptions: false,

//     bedroomCount: "",
//     bathroomCount: "",
//   });
//   const [crmgetdata, setcrmgetdata] = useState([]);
//   const [dayseleted, setdayseleted] = useState(null);
//   const [timeSelected, settimeSelected] = useState(null);
//   const [userDetails, setUserDetails] = useState({
//     id: "",
//     email: "",
//     password: "",
//     firstName: "",
//     lastName: "",
//     phone: "",
//     streetAddress: "",
//     city: "",
//     state: "",
//     zipCode: "",
//     postalCode: "",
//     specialRequests: "",
//   });
//   const [databooking, setdatabooking] = useState([]);
//   const [activeService, setActiveService] = useState(null);
//   const [serviceCounts, setServiceCounts] = useState({});
//   const extraServices = [
//     { image: fridgeCleaning, name: "Fridge Cleaning", price: "$50" },
//     { image: ovenCleaning, name: "Oven Cleaning", price: "$40" },
//     { image: windowCleaning, name: "Inside Window Cleaning", price: "$30" },
//   ];
//   const [paymentMethod, setPaymentMethod] = useState(""); // Set default to 'payLocally'
//   const [showAllEvents, setShowAllEvents] = useState(false);
//   const [totalTime, setTotalTime] = useState(0); // To track total time
//   const [detailsdata, setDetailsdata] = useState({});
//   console.log(detailsdata);
//   const [Detailsiud, setDetailsiud] = useState(null); // Set default to
//   // const [showForm, setShowForm] = useState(false);
//   const [rejectReason, setRejectReason] = useState("");
//   const [showRescheduleModal, setShowRescheduleModal] = useState(false);
//   const [amount, setAmount] = useState("");
//   const [notes, setNotes] = useState("");
//   const [rescheduleDate, setRescheduleDate] = useState(""); // Changed name here
//   const [rescheduledData, setRescheduledData] = useState(null);
//   const [subtotale, setsubtotale] = useState(0);
//   const [isBookingComplete, setIsBookingComplete] = useState(false);
//   const [useridd, setuserid] = useState(null);
//   const [promoCode, setPromoCode] = useState("");
//   const [appliedPromoCode, setAppliedPromoCode] = useState(null);
//   const [promoCodes, setPromoCodes] = useState([]);
//   const [promoDiscount, setPromoDiscount] = useState(0);
//   const [vacuum, setVacuum] = useState("no");
//   const [parking, setParking] = useState("no");
//   const [access, setAccess] = useState("home");
//   const handleRescheduleClick = () => {
//     setShowRescheduleModal(true);
//   };

//   //   const fetchSettings = async () => {
//   //     setLoading(true); // Use your existing loading state
//   //     try {
//   //       const response = await axios.post(
//   //         `${BaseUrl}/backend/api/settings.php`,
//   //         {
//   //           action: "get_all_settings",
//   //           api_key: "1",
//   //         },
//   //         {
//   //           headers: {
//   //             "Content-Type": "application/json",
//   //           },
//   //         }
//   //       );

//   //       if (response.data.status === "true" && response.data.statuscode === 200) {
//   //         const fetchedSettings = response.data.response.reduce((acc, item) => {
//   //           if (item.option_name === "ct_postal_code") {
//   //             acc[item.option_name] = item.postalcode; // Store postal codes as a comma-separated string
//   //           } else {
//   //             acc[item.option_name] = item.option_value;
//   //           }
//   //           return acc;
//   //         }, {});

//   //         setSettings((prevSettings) => ({
//   //           ...prevSettings,
//   //           ...fetchedSettings,
//   //         }));
//   //       } else {
//   //         throw new Error(response.data.response || "Failed to fetch settings");
//   //       }
//   //     } catch (error) {
//   //       setError(error.message);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };
//   //   // Call fetchSettings on component mount
//   // useEffect(() => {
//   //   fetchSettings();
//   // }, []);

//   const fetchSettings = async () => {
//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/settings.php`,

//         {
//           action: "get_all_settings",

//           api_key: "1",
//         },

//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.data.status === "true" && response.data.statuscode === 200) {
//         const fetchedSettings = response.data.response.reduce((acc, item) => {
//           if (item.option_name === "ct_postal_code") {
//             acc[item.option_name] = item.postalcode;
//           } else {
//             acc[item.option_name] = item.option_value;
//           }

//           return acc;
//         }, {});

//         setSettings((prevSettings) => ({
//           ...prevSettings,

//           ...fetchedSettings,
//         }));

//         // Extract and parse the ct_front_desc content

//         const parser = new DOMParser();

//         const doc = parser.parseFromString(
//           fetchedSettings.ct_front_desc,
//           "text/html"
//         );

//         const features = doc.querySelectorAll(".features");

//         const featuresContent = Array.from(features).map((feature) => {
//           const title = feature.querySelector("h4").textContent;

//           const description = feature.querySelector("p").textContent;

//           return { title, description };
//         });

//         setFeaturesContent(featuresContent);
//       } else {
//         throw new Error(response.data.response || "Failed to fetch settings");
//       }
//     } catch (error) {
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchSettings();
//   }, []);
//   const handleZipCodeChange = (e) => {
//     const value = e.target.value;
//     setFormData({
//       ...formData,
//       zipCode: value,
//     });

//     // Split postal codes into an array for comparison
//     const validZipCodes = settings["ct_postal_code"]?.split(",") || [];

//     // Check if the entered zip code matches any valid postal code
//     if (value.length > 0 && !validZipCodes.includes(value)) {
//       setZipCodeError("Our service is not available at your location");
//     } else {
//       setZipCodeError(""); // Clear error if valid or empty
//     }
//   };
//   const fetchTimeSlots = async (date) => {
//     // Pehle check karo ke staff_id (getidbyadmin) available hai ya nahi
//     if (!getidbyadmin) {
//       alert("Staff ID missing! Please select a provider.");
//       return;
//     }

//     if (!date) {
//       alert("Please select a date.");
//       return;
//     }

//     const formattedDate = format(date, "dd-MM-yyyy");

//     const payload = {
//       action: "get_slots",
//       api_key: "1",
//       selected_date: formattedDate,
//       staff_id: getidbyadmin, // Ensure ID is present
//     };
//     setLoading(true);
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/slots.php`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       console.log(response.data.response);
//       setTimeSlots(response.data.response);
//     } catch (error) {
//       console.error("Error fetching time slots:", error);
//       setTimeSlots([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // useEffect only depends on selectedDate now
//   useEffect(() => {
//     if (selectedDate) {
//       fetchTimeSlots(selectedDate);
//     }
//   }, [selectedDate]);

//   // Close modal
//   const closeRescheduleModal = () => {
//     // Changed name here
//     setShowRescheduleModal(false);
//   };

//   const handleUpdate = (e, rescheduleDate) => {
//     e.preventDefault();

//     // Validate the rescheduleDate
//     if (!rescheduleDate || isNaN(new Date(rescheduleDate).getTime())) {
//       alert("Invalid date. Please provide a valid date.");
//       return;
//     }

//     // Format the reschedule date into a readable format
//     const formattedDate = new Date(rescheduleDate)
//       .toISOString()
//       .slice(0, 19)
//       .replace("T", " ");

//     // Data to save
//     const dataToSave = {
//       rescheduleDate: formattedDate,
//     };

//     // Log data to the console (optional)
//     console.log("Rescheduled Data: ", dataToSave);

//     // Save the data into state (without displaying it on the page)
//     setRescheduledData(dataToSave);

//     // Optionally, handle additional actions (like resetting the form or other states)
//     closeRescheduleModal();
//   };

//   const handleRejectClick = () => {
//     setShowForm(!showForm); // Toggle form visibility
//   };

//   const handleReject = async (id, e) => {
//     setLoading(true);

//     e.preventDefault();
//     console.log("Reject Reason:", rejectReason, id);
//     // Add your logic here to handle the reject reason
//     try {
//       // Define the request payload
//       const payload = {
//         action: "reject_appointment", // Action to fetch all services
//         api_key: 1,
//         order_id: id,
//         reject_reason: rejectReason,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_reject.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         setSuccessMessage("Reject Appointment Successfully!");
//         const services = response.data;
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }

//     setShowForm(false); // Close the form after submission
//   };

//   const handlePaymentChange = (e) => {
//     setPaymentMethod(e.target.value);
//   };
//   const handleImageSectionToggle = () => {
//     setShowImageSection((prevState) => !prevState); // Toggle the visibility of the image section
//     setIcon((prevIcon) => (prevIcon === "+" ? "-" : "+")); // Toggle the icon between "+" and "-"
//   };
//   const editNavigate = () => {
//     navigate("editcustomer");
//   };

//   const handleBedroomChange = (unitId, value) => {
//     setBedroom((prevSelections) => ({
//       ...prevSelections,
//       [unitId]: value,
//     }));
//   };

//   // const addItemToBill = (
//   //   id,
//   //   itemName,
//   //   quantity,
//   //   pricePerItem,
//   //   serviceTitle
//   // ) => {
//   //   setBookingBill((prevBill) => {
//   //     const existingItemIndex = prevBill.findIndex(
//   //       (item) => item.name === itemName
//   //     );

//   //     let updatedBill;

//   //     if (existingItemIndex !== -1) {
//   //       updatedBill = [...prevBill];
//   //       updatedBill[existingItemIndex].quantity += quantity;
//   //       updatedBill[existingItemIndex].price += quantity * pricePerItem;
//   //     } else {
//   //       updatedBill = [
//   //         ...prevBill,
//   //         {
//   //           method_id: selectedMethod.method_id,
//   //           service_id: selectedService,
//   //           unit_id: id,
//   //           type: "unit",
//   //           name: itemName,
//   //           service_title: serviceTitle, // Add this for frontend display
//   //           qty: quantity,
//   //           rate: quantity * pricePerItem,
//   //         },
//   //       ];
//   //     }

//   //     // Calculate the new total time (add 60 minutes for each new unit added)
//   //     const newTotalTime =
//   //       prevBill.reduce(
//   //         (time, item) => time + (item.qty ? item.qty : 0) * 60,
//   //         0
//   //       ) +
//   //       quantity * 60;

//   //     // Update the state for both the bill and total time
//   //     setTotalTime(newTotalTime);
//   //     return updatedBill;
//   //   });
//   // };
//   const addItemToBill = (
//     id,
//     itemName,
//     quantity,
//     pricePerItem,
//     serviceTitle
//   ) => {
//     setBookingBill((prevBill) => {
//       // Find if the item already exists in the bill
//       const existingItemIndex = prevBill.findIndex(
//         (item) => item.unit_id === id && item.name === itemName
//       );

//       let updatedBill;

//       if (existingItemIndex !== -1) {
//         // If the item exists, replace it with the new quantity
//         updatedBill = [...prevBill];
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             method_id: selectedMethod.method_id,
//             service_id: selectedService,
//             unit_id: id,
//             type: "unit",
//             name: itemName,
//             service_title: serviceTitle,
//             qty: quantity, // Replace the old quantity with the new one
//             rate: quantity * pricePerItem, // Recalculate the price
//           };
//         } else {
//           // If quantity is 0, remove the item
//           updatedBill.splice(existingItemIndex, 1);
//         }
//       } else if (quantity > 0) {
//         // If the item doesn’t exist and quantity > 0, add it as a new entry
//         updatedBill = [
//           ...prevBill,
//           {
//             method_id: selectedMethod.method_id,
//             service_id: selectedService,
//             unit_id: id,
//             type: "unit",
//             name: itemName,
//             service_title: serviceTitle,
//             qty: quantity,
//             rate: quantity * pricePerItem,
//           },
//         ];
//       } else {
//         // If quantity is 0 and item doesn’t exist, return the bill unchanged
//         updatedBill = [...prevBill];
//       }

//       // Recalculate total time based on the updated bill
//       const newTotalTime = updatedBill.reduce(
//         (time, item) => time + (item.qty || 0) * 60,
//         0
//       );
//       setTotalTime(newTotalTime);

//       return updatedBill;
//     });
//   };
//   const calculateTotal = () => {
//     // Existing calculation for first two services
//     const existingTotal = bookingBill.reduce(
//       (total, item) => total + item.rate,
//       0
//     );

//     // Calculation for third service
//     if (selectedService === 3) {
//       const propertyTotal =
//         propertyQuantities.walls * 10 +
//         propertyQuantities.doors * 10 +
//         propertyQuantities.windows * 10 +
//         damagedFloors * 10 +
//         doorJams * 10;
//       const areaTotal = area * 2 + extraDamagedFloors * 10 + extraDoorJams * 10;
//       return existingTotal + propertyTotal + areaTotal;
//     }
//     if (selectedService === 4) {
//       const officeTotal =
//         (officeQuantities.rooms || 0) * 10 +
//         (officeQuantities.bathrooms || 0) * 10 +
//         (officeQuantities.kitchens || 0) * 10 +
//         (packing || 0) * 10 +
//         (storeroom || 0) * 10;

//       const areaTotal =
//         (officearea || 0) * 2 +
//         (officeextraDamagedFloors || 0) * 10 +
//         (officeextraDoorJams || 0) * 10;

//       return existingTotal + officeTotal + areaTotal;
//     }
//     return existingTotal;
//   };

//   // const calculateDiscountedTotal = () => {
//   //   const total = calculateTotal(); // Get the total price
//   //   setsubtotale(total);
//   //   if (isNaN(total)) {
//   //     console.error("Total calculation resulted in NaN:", total);
//   //     return 0; // Return 0 if the total is invalid
//   //   }
//   //   const discountPercentage = selectedDiscount; // Get the discount based on the frequency
//   //   const discountAmount = (total * discountPercentage) / 100; // Calculate the discount
//   //   const totalAfterDiscount = total - discountAmount; // Subtract the discount from the total
//   //   // const text = totalAfterDiscount + 10 ;
//   //   const taxsum = total === 0 ? 0 : 10;

//   //   const finalTotal = totalAfterDiscount;
//   //   setDisamount(discountAmount);
//   //   settax(taxsum);
//   //   setText(finalTotal);

//   //   return totalAfterDiscount;
//   // };

//   const fetchPromoCodes = async () => {
//     try {
//       const payload = {
//         action: "get_all_coupons",
//         api_key: "1",
//       };

//       const response = await axios.post(
//         `${BaseUrl}/backend/api/promocode.php`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.data.status === "true") {
//         setPromoCodes(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching promo codes:", error);
//     }
//   };

//   // Add this useEffect to fetch promocodes on component mount
//   useEffect(() => {
//     fetchPromoCodes();
//   }, []);

//   // Add this function to apply promocode (place it near your other handler functions)
//   const handleApplyPromoCode = () => {
//     if (!selectedService || selectedService.length === 0) {
//       alert("Please select at least one service");
//       return;
//     }

//     const today = new Date();
//     const foundPromo = promoCodes.find(
//       (promo) =>
//         promo.coupon_code === promoCode &&
//         promo.status === "on" &&
//         new Date(promo.coupon_expiry) >= today &&
//         parseInt(promo.coupon_used) < parseInt(promo.coupon_limit)
//     );

//     if (foundPromo) {
//       setidpromocode(foundPromo.id);
//       setAppliedPromoCode(foundPromo);
//       const discountValue =
//         foundPromo.coupon_type === "P"
//           ? (calculateTotal() * parseFloat(foundPromo.coupon_value)) / 100
//           : parseFloat(foundPromo.coupon_value);
//       setPromoDiscount(discountValue);
//       setSuccessMessage("Promo code applied successfully!");
//       setError("");
//     } else {
//       setAppliedPromoCode(null);
//       setPromoDiscount(0);
//       setError("Invalid or expired promo code");
//     }
//   };

//   const handleCancelPromo = () => {
//     setPromoDiscount(0);
//     setAppliedPromoCode(null);
//     setPromoCode(""); // Reset input field
//     setError(""); // Clear error messages
//   };

//   // Modified calculateDiscountedTotal function
//   const calculateDiscountedTotal = () => {
//     const total = calculateTotal();
//     setsubtotale(total);

//     if (isNaN(total)) {
//       console.error("Total calculation resulted in NaN:", total);
//       return 0;
//     }

//     const frequencyDiscountPercentage = selectedDiscount;
//     const frequencyDiscountAmount = (total * frequencyDiscountPercentage) / 100;
//     const totalAfterFrequencyDiscount = total - frequencyDiscountAmount;

//     const taxsum = total === 0 ? 0 : 10;
//     const finalTotal = totalAfterFrequencyDiscount - promoDiscount + taxsum;

//     setDisamount(frequencyDiscountAmount);
//     settax(taxsum);
//     setText(finalTotal);

//     return finalTotal;
//   };

//   // Add useEffect to recalculate when promoDiscount changes
//   useEffect(() => {
//     calculateDiscountedTotal();
//   }, [
//     promoDiscount,
//     selectedDiscount,
//     bookingBill,
//     propertyQuantities,
//     area,
//     damagedFloors,
//     doorJams,
//     officeQuantities,
//     officearea,
//     packing,
//     storeroom,
//   ]);
//   const handleLogin = async (e) => {
//     e.preventDefault();

//     if (!email || !password) {
//       setError("Please fill in both email and password.");
//       return;
//     }

//     setLoading(true);
//     setError("");

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/check_login.php`,
//         {
//           action: "check_login",
//           api_key: 1,
//           email: email,
//           password: password,
//         }
//       );

//       if (response.data.status === "true") {
//         setError("");
//         const userType = response.data?.usertype;
//         const userIdFromResponse = response.data?.userId;

//         console.log(userIdFromResponse);

//         if (userType && userIdFromResponse) {
//           setUserType(userType);
//           setUserId(userIdFromResponse); // Set userId in state
//           setIsLoggedIn(true);
//           sessionStorage.setItem("userId", userIdFromResponse);
//           sessionStorage.setItem("userType", userType);
//           sessionStorage.setItem("isLoggedIn", "true");
//         } else {
//           setError("User type or user ID not found in the response.");
//         }
//       } else {
//         setError(response.data.response || "Invalid email or password.");
//       }
//     } catch (error) {
//       setError("An error occurred. Please try again later.");
//       console.error("Login error:", error.response || error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handaldeleted = async (id) => {
//     setLoading(true);

//     try {
//       // Define the request payload
//       const payload = {
//         action: "delete_booking", // Action to fetch all services
//         api_key: 1,
//         order_id: id,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         setSuccessMessage("Delete Booking Successfully!");
//         const services = response.data;
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }

//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handalconfirm_appointment = async (id) => {
//     setLoading(true);

//     console.log(id, "DADSA");
//     try {
//       // Define the request payload
//       const payload = {
//         action: "confirm_appointment", // Action to fetch all services
//         api_key: "1",
//         order_id: id,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_confirm.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         setSuccessMessage("Confirm Booking Successfully!");
//         const services = response.data;
//         console.log(services);
//         setIsBookingComplete(true);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }

//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const crmget = () => {
//     setLoading(true);

//     axios
//       .get(`${BaseUrl}/backend/api/add_customer.php?action=getuser`)
//       .then((response) => {
//         console.log(response);
//         if (response.data.status === "true") {
//           setcrmgetdata(response.data.data);
//         } else {
//           console.log(response.data.message);
//         }
//       })
//       .catch((err) => {
//         console.log("An error occurred while fetching data");
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   const calendardata = () => {
//     setLoading(true);

//     axios
//       .get(`${BaseUrl}/backend/api/services.php?action=week_days_available`)
//       .then((response) => {
//         console.log(response);
//         if (response.data.status === "true") {
//           setcalenderdata(response.data.data);
//         } else {
//           console.log(response.data.message);
//         }
//       })
//       .catch((err) => {
//         console.log("An error occurred while fetching data");
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     const generateTimeSlots = async () => {
//       const today = new Date();
//       const currentWeek = Math.ceil(today.getDate() / 7); // Week of the month (1st, 2nd, etc.)
//       const currentDayOfWeek = today.getDay(); // Sunday = 0, Monday = 1, etc.
//       console.log(currentWeek, currentDayOfWeek);

//       // Filter schedule for the current week and weekday
//       const selectedSchedule = calenderdata.find(
//         (schedule) => schedule.provider_schedule_type === "weekly"
//         // schedule.week_id === currentWeek &&
//         // schedule.weekday_id === currentDayOfWeek &&
//         // schedule.off_day === "N"
//       );

//       console.log(selectedSchedule);

//       if (!selectedSchedule) {
//         setTimeSlots([]); // If no schedule for the day, return empty slots
//         return;
//       }

//       const dayStartTime = selectedSchedule.day_start_time;
//       const dayEndTime = selectedSchedule.day_end_time;
//       const slotDurationMinutes = 30;

//       const startTime = new Date(`1970-01-01T${dayStartTime}Z`);
//       const endTime = new Date(`1970-01-01T${dayEndTime}Z`);
//       const slots = [];
//       let currentTime = new Date(startTime);
//       let slotId = 1;

//       while (currentTime < endTime) {
//         const slotStart = new Date(currentTime);
//         const slotEnd = new Date(
//           currentTime.getTime() + slotDurationMinutes * 60000
//         );

//         const formatTime = (time) => {
//           let hours = time.getUTCHours();
//           let minutes = time.getUTCMinutes().toString().padStart(2, "0");
//           let period = hours >= 12 ? "PM" : "AM";
//           hours = hours % 12 || 12;
//           return `${hours}:${minutes} ${period}`;
//         };

//         const isToday =
//           today.toDateString() === new Date(selectedDate).toDateString();
//         const isPastSlot =
//           isToday &&
//           (today.getHours() > slotEnd.getUTCHours() ||
//             (today.getHours() === slotEnd.getUTCHours() &&
//               today.getMinutes() > slotEnd.getUTCMinutes()));

//         slots.push({
//           slot_id: slotId,
//           slot_start: formatTime(slotStart),
//           slot_end: formatTime(slotEnd),
//           disabled: isPastSlot,
//         });

//         currentTime = slotEnd;
//         slotId += 1;
//       }

//       setTimeSlots(slots);
//     };

//     generateTimeSlots();
//     const interval = setInterval(generateTimeSlots, 60000);
//     return () => clearInterval(interval);
//   }, [selectedDate, calenderdata]); // Re-run when selectedDate changes

//   useEffect(() => {
//     calendardata();
//   }, []);

//   useEffect(() => {
//     crmget();
//   }, []);

//   useEffect(() => {
//     calculateDiscountedTotal(); // Calculate discounted total whenever discount or total changes
//   }, [
//     selectedService,
//     bookingBill,
//     propertyQuantities,
//     area,
//     damagedFloors,
//     doorJams,
//     officeQuantities,
//     officearea,
//     packing,
//     storeroom,
//   ]);

//   // useEffect(() => {
//   //   const fetchAdminData = async () => {
//   //     setLoading(true);
//   //     try {
//   //       const response = await axios.get(
//   //         `${BaseUrl}/backend/api/services.php?action=getadmin`
//   //       );
//   //       console.log(response);

//   //       if (response.data.status === "true") {
//   //         setAdminData(response.data.data);
//   //       } else {
//   //         console.log(response.data.message);
//   //       }
//   //     } catch (err) {
//   //       console.error("An error occurred while fetching data:", err);
//   //       setError("Failed to fetch admin data. Please try again later.");
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   fetchAdminData();
//   // }, []);

//   useEffect(() => {
//     const fetchAdminData = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(
//           `${BaseUrl}/backend/api/services.php?action=getadmin`
//         );
//         console.log(response);

//         if (response.data.status === "true") {
//           // Filter admin data based on selectedService
//           const filteredAdminData = response.data.data.filter((provider) => {
//             const serviceIdsArray = provider.service_ids
//               .split(",")
//               .map((id) => id.trim()); // Split and trim the service_ids string into an array
//             return selectedService
//               ? serviceIdsArray.includes(selectedService.toString())
//               : true; // If no service selected, show all staff
//           });
//           setAdminData(filteredAdminData); // Set filtered data
//         } else {
//           console.log(response.data.message);
//         }
//       } catch (err) {
//         console.error("An error occurred while fetching data:", err);
//         setError("Failed to fetch admin data. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAdminData();
//   }, [selectedService]); // Add selectedService as a dependency so it refetches/filters when service changes

//   useEffect(() => {
//     // Update bedrooms and bathrooms directly in the bill
//     const updateOrAddToBill = (itemName, quantity, pricePerItem) => {
//       const existingItemIndex = bookingBill.findIndex(
//         (item) => item.name === itemName
//       );

//       if (existingItemIndex !== -1) {
//         const updatedBill = [...bookingBill];
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             ...updatedBill[existingItemIndex],
//             quantity,
//             price: quantity * pricePerItem,
//           };
//         } else {
//           updatedBill.splice(existingItemIndex, 1); // Remove the item if quantity is zero
//         }
//         setBookingBill(updatedBill);
//       } else if (quantity > 0) {
//         setBookingBill([
//           ...bookingBill,
//           { type: itemName, qty: quantity, rate: quantity * pricePerItem },
//         ]);
//       }
//     };

//     updateOrAddToBill("Bedrooms", bedroom, 5);
//     updateOrAddToBill("Bathrooms", bathroom, 5);
//   }, [bedroom, bathroom]);

//   useEffect(() => {
//     if (selectedService === 3) {
//       // Initialize or reset variables related to Service 3
//       setPropertyQuantities({
//         walls: 0,
//         doors: 0,
//         windows: 0,
//       });
//       setDamagedFloors(0);
//       setDoorJams(0);
//       setArea(0);
//       setExtraDamagedFloors(0);
//       setExtraDoorJams(0);
//     }
//   }, [selectedService]); // Whenever `selectedService` changes handaldeleted  deleteallbooking

//   useEffect(() => {
//     if (selectedService === 4) {
//       // Initialize or reset variables related to Service 4
//       setOfficeQuantities({
//         rooms: 0,
//         bathrooms: 0,
//         kitchens: 0,
//       });
//       setPacking(0);
//       setStoreroom(0);
//       setOfficeArea(0);
//       setofficeExtraDamagedFloors(0);
//       setofficeExtraDoorJams(0);
//     }
//   }, [selectedService]); // Whenever `selectedService` changes

//   // const removeItem = (idx) => {
//   //   setBookingBill((prevBill) => prevBill.filter((_, index) => index !== idx));
//   // };

//   useEffect(() => {
//     const maxAddons = Math.max(
//       ...allServices.map((s) => (s.addons ? s.addons.length : 0)),
//       extraServices.length
//     );
//     setQuantities(Array(maxAddons).fill(0));
//   }, [allServices]);

//   const removeItem = (idx) => {
//     setBookingBill((prevBill) => {
//       const updatedBill = prevBill.filter((_, index) => index !== idx);
//       const removedItem = prevBill[idx];

//       // Reset the quantity in the quantities array if the removed item is an addon
//       if (removedItem.type) {
//         const addonIndex = extraServices.findIndex(
//           (addon) => addon.name === removedItem.type
//         );
//         if (addonIndex !== -1) {
//           setQuantities((prevQuantities) => {
//             const newQuantities = [...prevQuantities];
//             newQuantities[addonIndex] = 0; // Reset to 0 when removed
//             return newQuantities;
//           });
//         } else {
//           // If the addon is from a service's addons (not extraServices), find it dynamically
//           allServices.forEach((service) => {
//             if (service.addons) {
//               const serviceAddonIndex = service.addons.findIndex(
//                 (addon) => addon.addon_name === removedItem.type
//               );
//               if (serviceAddonIndex !== -1) {
//                 setQuantities((prevQuantities) => {
//                   const newQuantities = [...prevQuantities];
//                   newQuantities[serviceAddonIndex] = 0; // Reset to 0
//                   return newQuantities;
//                 });
//               }
//             }
//           });
//         }
//       }

//       // Recalculate total time
//       const newTotalTime = updatedBill.reduce(
//         (time, item) => time + (item.qty || 0) * 60,
//         0
//       );
//       setTotalTime(newTotalTime);

//       return updatedBill;
//     });
//   };
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });

//     // Log the value for the selected bedroom
//     if (name === "bedroomCount") {
//       console.log(`Selected Bedroom: ${value}`);
//     }
//   };

//   const scrollRef = useRef(null);

//   const scroll = (direction) => {
//     const container = scrollRef.current;
//     if (container) {
//       const scrollAmount = container.offsetWidth * 0.8; // Scroll 80% of container width
//       container.scrollBy({
//         left: direction === "next" ? scrollAmount : -scrollAmount,
//         behavior: "smooth",
//       });
//     }
//   };

//   const generateCalendar = (year, month) => {
//     const date = new Date(year, month);
//     const daysInMonth = new Date(year, month + 1, 0).getDate();
//     const startDay = new Date(year, month, 1).getDay();
//     const calendar = [];

//     let currentDay = 1;

//     for (let week = 0; week < 6; week++) {
//       const weekDays = [];

//       for (let day = 0; day < 7; day++) {
//         if (week === 0 && day < startDay) {
//           weekDays.push(null);
//         } else if (currentDay <= daysInMonth) {
//           weekDays.push(currentDay);
//           currentDay++;
//         } else {
//           weekDays.push(null);
//         }
//       }

//       calendar.push(weekDays);
//     }

//     return calendar;
//   };

//   const calendar = generateCalendar(
//     currentDate.getFullYear(),
//     currentDate.getMonth()
//   );

//   // Function to handle date selection
//   const handleDateClick = (day) => {
//     setDaySelected(day);
//     if (day) {
//       const selectedDay = new Date(
//         currentDate.getFullYear(),
//         currentDate.getMonth(),
//         day
//       );

//       // Compare only the date (year, month, day) without time, ensuring past dates are blocked
//       const today = new Date();
//       today.setHours(0, 0, 0, 0); // Reset time part to compare just the date

//       if (selectedDay < today) {
//         alert("Sorry, past date booking is not possible.");
//         return;
//       }

//       // Format the date to MM/DD/YYYY
//       const formattedDate = selectedDay.toLocaleDateString("en-US", {
//         month: "2-digit",
//         day: "2-digit",
//         year: "numeric",
//       });

//       const key = formattedDate; // Use formattedDate as the key

//       if (bookedSlots[key]?.length === timeSlots.length) {
//         alert("Sorry, this date's time slots are fully booked.");
//         return;
//       }

//       setSelectedDate(key);
//       setSelectedTime(null);
//       setShowForm(false); // Hide form initially
//     }
//   };

//   // Function to handle time slot selection
//   const handleTimeSelect = (time) => {
//     setSelectedTime(time);
//     setShowForm(true);
//   };
//   const toggleCalendarPanel = () => {
//     setIsCalendarOpen((prev) => !prev); // Toggle this panel
//     if (!isCalendarOpen) {
//       // If opening this panel
//       setIsServiceOpen(false); // Close others
//       setIsFormOpen(false);
//     }
//   };

//   const toggleFormPanel = () => {
//     setIsFormOpen((prev) => !prev); // Toggle this panel
//     if (!isFormOpen) {
//       // If opening this panel
//       setIsServiceOpen(false); // Close others
//       setIsCalendarOpen(false);
//     }
//   };
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!isChecked) {
//       alert("Please accept the Terms & Conditions before proceeding.");
//       return;
//     }

//     if (!userId && !useriddata) {
//       // Check only `userId` since it’s now the single source of truth
//       alert("Please provide user details");
//       return;
//     }

//     if (!selectedProvider?.id) {
//       alert("Please select a provider");
//       return;
//     }

//     if (!selectedDate || !selectedTime) {
//       alert("Please select date and time for appointment");
//       return;
//     }

//     if (!selectedService || selectedService.length === 0) {
//       alert("Please select at least one service");
//       return;
//     }

//     if (!paymentMethod) {
//       alert("Please select a payment method");
//       return;
//     }

//     const hasAtLeastOneUnit = bookingBill.some((item) => item.method_id);
//     if (!hasAtLeastOneUnit) {
//       alert("You must select at least one unit.");
//       setLoading(false);
//       return;
//     }

//     setLoading(true);

//     const formattedData = {
//       action: "book_appointment",
//       api_key: "1",
//       user_id: userId || useriddata, // Use `userId` directly
//       staff_id: selectedProvider?.id || "",
//       payment_method: paymentMethod,
//       // sub_total: subtotale,
//       sub_total: promoDiscount ? subtotale - promoDiscount : subtotale,
//       discount: Disamount,
//       order_duration: totalTime,
//       tax: tax,
//       booking_date_time: `${selectedDate} ${selectedTime}`,
//       service_id: selectedService,
//       method_id: selectedMethod?.method_id,
//       cart_detail: bookingBill,
//       net_amount: text,
//       recurrence_id: selectedservices,
//       freq_discount_amount: 1,
//     };

//     console.log("Formatted Booking Data:", formattedData);
//     axios
//       .post(`${BaseUrl}/backend/api/book_appointment.php`, formattedData, {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       })
//       .then((response) => {
//         console.log(response.data.status);
//         if (response.data.status === "true") {
//           setSuccessMessage("Appointment Add successfully!");
//           setIsModalVisible(true);

//           if (idpromocode) {
//             const promoData = {
//               action: "increment_coupon_used",
//               api_key: "1",
//               coupon_id: idpromocode,
//             };

//             axios
//               .post(
//                 "http://10.27.1.104/megaclean(20-03-2025)/megaclean/backend/api/promocode.php",
//                 promoData,
//                 {
//                   headers: {
//                     "Content-Type": "application/json",
//                   },
//                 }
//               )
//               .then((promoResponse) => {
//                 console.log(
//                   "Promocode incremented successfully:",
//                   promoResponse.data
//                 );
//               })
//               .catch((promoError) => {
//                 console.error("Error incrementing promocode:", promoError);
//                 // Note: Not showing alert here to avoid disrupting user experience
//               });
//           }

//           setTimeout(() => {
//             setIsModalVisible(false);
//             window.location.reload();
//           }, 5000);
//         } else {
//           console.log(response.data.response);
//         }

//         handleClosebookingSummary();
//         bookeddata();
//       })
//       .catch((error) => {
//         console.error("Error occurred while submitting:", error);
//         alert("There was an error submitting the form. Please try again.");
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
//   const hours = Array.from({ length: 24 }, (_, i) => `${i}:00`);

//   // Function to navigate to next month or week
//   const nextMonth = () => {
//     if (activeView === "month") {
//       setCurrentMonth(addMonths(currentMonth, 1)); // Navigate to the next month
//     } else if (activeView === "week") {
//       const nextWeekStart = addDays(endOfWeek(currentMonth), 1); // Go to the start of the next week
//       setCurrentMonth(nextWeekStart);
//     }
//   };

//   // Function to navigate to the next day
//   const nextDay = () => {
//     setCurrentMonth(addDays(currentMonth, 1)); // Navigate to the next day
//   };

//   // Function to navigate to the previous day
//   const prevDay = () => {
//     setCurrentMonth(subDays(currentMonth, 1)); // Navigate to the previous day
//   };
//   // Function to navigate to previous month or week
//   const prevMonth = () => {
//     if (activeView === "month") {
//       setCurrentMonth(subMonths(currentMonth, 1)); // Navigate to the previous month
//     } else if (activeView === "week") {
//       const prevWeekStart = subDays(startOfWeek(currentMonth), 1); // Go to the start of the previous week
//       setCurrentMonth(prevWeekStart);
//     }
//   };

//   // Mock events data
//   const events = [
//     {
//       id: 1,
//       date: new Date(2024, 11, 10),
//       hour: "2",
//       bookingStatus: "Confirmed",
//       bookingDate: "10-Dec-2024 01:00 PM",
//       service: "House Cleaning",
//       methods: "Property Based",
//       units: "Bedroom(s)-3",
//       addons: "Fridge Cleaning-5",
//       price: "$65.00",
//       duration: "4 Hours 0 Minutes",
//       customer: {
//         name: "John Doe",
//         email: "johndoe@example.com",
//         phone: "+10000000000",
//         address: "Perrine, USA, Perrine, 90001, USA",
//         payment: "Pay Locally",
//         notes: "Happy Booking",
//       },
//     },
//   ];

//   //   // Render month view

//   const renderDaysInMonth = () => {
//     const startDate = new Date(
//       currentMonth.getFullYear(),
//       currentMonth.getMonth(),
//       1
//     );
//     const endDate = new Date(
//       currentMonth.getFullYear(),
//       currentMonth.getMonth() + 1,
//       0
//     );
//     const days = [];
//     let dayIndex = startDate.getDay();
//     let dayOfMonth = 1;

//     const today = new Date();
//     const todayDate = format(today, "yyyy-MM-dd");

//     while (dayIndex > 0) {
//       days.push(<div key={`empty-${dayIndex}`} className="p-4 border"></div>);
//       dayIndex--;
//     }

//     while (dayOfMonth <= endDate.getDate()) {
//       const date = new Date(
//         currentMonth.getFullYear(),
//         currentMonth.getMonth(),
//         dayOfMonth
//       );
//       const eventsForDay = bookingappointment.filter(
//         (event) =>
//           format(event.booking_date_time, "yyyy-MM-dd") ===
//           format(date, "yyyy-MM-dd")
//       );

//       const isToday = format(date, "yyyy-MM-dd") === todayDate;
//       const isPastDate = format(date, "yyyy-MM-dd") < todayDate;
//       const eventsToShow = eventsForDay.slice(0, 4);
//       const remainingEvents = eventsForDay.length - 4;

//       days.push(
//         <div
//           key={dayOfMonth}
//           className={`p-1 border h-32 relative ${
//             isToday ? "bg-blue-200" : ""
//           } ${isPastDate ? "bg-gray-200" : ""}`}
//           onClick={
//             !isPastDate
//               ? () => handleShowBookingSummary2(date)
//               : () => alert("You can't select a past date")
//           }
//         >
//           <p className={`text-right ${isToday ? "font-bold" : ""}`}>
//             {dayOfMonth}
//           </p>

//           {eventsForDay.length > 0 && (
//             <div className="absolute bottom-0 left-0 w-full px-2 py-1 space-y-1">
//               {eventsToShow.map((event, index) => (
//                 <button
//                   key={index}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleShowModal(event);
//                     setDetailsiud(event.order_id);
//                   }}
//                   onMouseEnter={() => setHoveredEvent(event)}
//                   onMouseLeave={() => setHoveredEvent(null)}
//                   className="text-xs bg-customlightGreen text-black px-2 py-1 rounded mb-1 relative"
//                 >
//                   Details
//                   {hoveredEvent === event && (
//                     <div className="absolute top-0 left-0 bg-white text-black p-4 rounded-lg shadow-lg z-20 border border-gray-200">
//                       <p className="text-sm font-medium mb-1">
//                         <strong>Title:</strong> {event.title}
//                       </p>
//                       <p className="text-sm mb-1">
//                         <strong>Time:</strong> {event.booking_date_time}
//                       </p>
//                       <p className="text-sm mb-1">
//                         <strong>Name:</strong> {detailsdata.client_name}
//                       </p>
//                       <p className="text-sm mb-1">
//                         <strong>Email:</strong> {detailsdata.client_email}
//                       </p>
//                       <p className="text-sm">
//                         <strong>Phone:</strong> {detailsdata.client_phone}
//                       </p>
//                     </div>
//                   )}
//                 </button>
//               ))}
//               {remainingEvents > 0 && !showAllEvents && (
//                 <button
//                   className="text-xs text-blue-500"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     setShowAllEvents(true);
//                   }}
//                 >
//                   +{remainingEvents} More
//                 </button>
//               )}
//               {showAllEvents && (
//                 <div className="space-y-1">
//                   {eventsForDay.slice(4).map((event, index) => (
//                     <button
//                       key={index}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleShowModal(event);
//                         setDetailsiud(event.order_id);
//                       }}
//                       onMouseEnter={() => setHoveredEvent(event)}
//                       onMouseLeave={() => setHoveredEvent(null)}
//                       className="text-xs bg-customlightGreen text-black px-2 py-1 rounded mb-1 relative"
//                     >
//                       Details
//                       {hoveredEvent === event && (
//                         <div className="absolute top-0 left-0 bg-white text-black p-2 rounded shadow-md z-10">
//                           <p className="text-xs">
//                             <strong>Title:</strong> {event.title}
//                           </p>
//                           <p className="text-xs">
//                             <strong>Time:</strong> {event.time}
//                           </p>
//                           <p className="text-xs">
//                             <strong>Location:</strong> {event.location}
//                           </p>
//                         </div>
//                       )}
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       );

//       dayOfMonth++;
//     }

//     return days;
//   };

//   const renderWeekView = () => {
//     const weekStart = startOfWeek(currentMonth, { weekStartsOn: 0 });
//     const weekEnd = endOfWeek(currentMonth, { weekStartsOn: 0 });
//     const weekDays = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));
//     const formattedRange = `${format(weekStart, "MMM d")} — ${format(
//       weekEnd,
//       "MMM d, yyyy"
//     )}`;

//     // Current date for highlighting
//     const today = new Date();
//     const todayDate = format(today, "yyyy-MM-dd");

//     return (
//       <div className="w-full mx-auto">
//         {successMessage && (
//           <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
//             <span className="block sm:inline">{successMessage}</span>
//           </div>
//         )}

//         {error && (
//           <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
//             <span className="block sm:inline">{error}</span>
//           </div>
//         )}
//         <div className="grid grid-cols-8 border border-gray-300 text-center text-sm font-semibold bg-gray-50">
//           <div className="col-span-1 border border-gray-200"></div>
//           {weekDays.map((date, index) => {
//             const isToday = format(date, "yyyy-MM-dd") === todayDate; // Check if it's today's date
//             return (
//               <div
//                 key={index}
//                 className={`py-2 border lg:text-base md:text-base border-gray-200 min-[320px]:text-[11px] max-[640px]:text-[11px] ${
//                   isToday ? "bg-blue-100 font-bold" : ""
//                 }`}
//               >
//                 {`${daysOfWeek[date.getDay()]} ${format(date, "MM/dd")}`}
//               </div>
//             );
//           })}
//         </div>

//         <div className="grid grid-cols-8 divide-x border border-gray-300 text-sm">
//           <div className="border-r border-gray-300">
//             {hours.map((hour, index) => (
//               <div
//                 key={index}
//                 className="h-16 flex items-center justify-end pr-2 border-b border-gray-300"
//               >
//                 {hour}
//               </div>
//             ))}
//           </div>

//           {weekDays.map((date, dayIndex) => {
//             const isToday = format(date, "yyyy-MM-dd") === todayDate; // Check if it's today's date
//             const isPastDate = format(date, "yyyy-MM-dd") < todayDate; // Check if it's a past date

//             return (
//               <div
//                 key={dayIndex}
//                 className={`border-b border-gray-300 ${
//                   isToday ? "bg-blue-50" : ""
//                 }`}
//                 onClick={
//                   !isPastDate
//                     ? () => handleShowBookingSummary2(date)
//                     : () => alert("You can't select a past date")
//                 }
//               >
//                 {hours.map((hour, hourIndex) => {
//                   // Corrected hour calculation based on the `date`
//                   const hourStart = format(addHours(date, hourIndex), "HH:00"); // Use `date` here instead of `new Date()`
//                   const hourEnd = format(
//                     addHours(date, hourIndex + 1),
//                     "HH:00"
//                   );

//                   // Filter events for the current hour (for the given date and hour)
//                   const eventsForHour = bookingappointment.filter((event) => {
//                     const eventDateTime = format(
//                       new Date(event.booking_date_time),
//                       "yyyy-MM-dd HH:00"
//                     ); // Full date and hour
//                     const checkDateTime =
//                       format(date, "yyyy-MM-dd") + " " + hourStart;
//                     return eventDateTime === checkDateTime;
//                   });

//                   return (
//                     <div
//                       key={hourIndex}
//                       className={`h-16 border-b border-gray-300 ${
//                         isToday
//                           ? "bg-blue-100"
//                           : hourIndex % 2 === 0
//                           ? "bg-gray-50"
//                           : "bg-white"
//                       }`}
//                     >
//                       {/* Render event buttons for this hour */}
//                       {eventsForHour.length > 0 && (
//                         <div className="space-y-1">
//                           {eventsForHour.map((event, eventIndex) => (
//                             <button
//                               key={eventIndex}
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleShowModal(event); // Show modal with event details
//                                 setDetailsiud(event.order_id); // Set the event's order_id
//                               }}
//                               className="text-xs bg-customlightGreen text-black px-2 py-1 rounded mb-1"
//                             >
//                               Details
//                             </button>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   const renderDayView = () => {
//     const day = currentMonth; // Assuming currentMonth is the date representing the current day view
//     const formattedDay = format(day, "EEEE, MMM d, yyyy");

//     const today = new Date();
//     const todayDate = format(today, "yyyy-MM-dd");
//     const isToday = format(day, "yyyy-MM-dd") === todayDate;
//     const isFutureDate = format(day, "yyyy-MM-dd") > todayDate;

//     return (
//       <div className="w-full mx-auto">
//         <div className="text-center text-lg font-medium">{formattedDay}</div>
//         <div className="grid grid-cols-1 divide-y border border-gray-300 text-sm">
//           {hours.map((hour, index) => {
//             const hourStart = format(addHours(formattedDay, index), "HH:00"); // Calculate start time for each hour
//             const hourEnd = format(addHours(formattedDay, index + 1), "HH:00"); // Calculate end time for each hour

//             const eventsForHour = bookingappointment.filter((event) => {
//               const eventDateTime = format(
//                 new Date(event.booking_date_time),
//                 "yyyy-MM-dd HH:00"
//               );
//               const checkDateTime =
//                 format(formattedDay, "yyyy-MM-dd") + " " + hourStart;
//               return eventDateTime === checkDateTime;
//             });

//             return (
//               <div
//                 key={index}
//                 onClick={
//                   isToday || isFutureDate
//                     ? () => handleShowBookingSummary2(day)
//                     : () => alert("You can't select a past date")
//                 }
//                 className={`py-4 flex items-center px-2 text-base border-b border-gray-300 ${
//                   isToday ? "bg-blue-100" : ""
//                 }`}
//               >
//                 <div className="pr-20">{hour}</div>
//                 {eventsForHour.length > 0 && (
//                   <div className="space-y-1">
//                     {eventsForHour.map((event, eventIndex) => (
//                       <button
//                         key={eventIndex}
//                         onClick={(e) => {
//                           e.stopPropagation(); // Prevent event propagation
//                           handleShowModal(event); // Show modal with event details
//                           setDetailsiud(event.order_id); // Set the event's order_id
//                         }}
//                         className="text-xs bg-customlightGreen text-black px-2 py-1 rounded mb-1"
//                       >
//                         Details
//                       </button>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   const handleShowModal = (event) => {
//     console.log(event);
//     setSelectedEvent(event);
//     setShowModal(true);
//     setShowEditModal(false);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedEvent(null);
//   };
//   const handleShowEditModal = () => {
//     setShowEditModal(true);
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//   };

//   const handleShowBookingSummary = () => {
//     setShowBookingSummary(true);
//   };

//   const handleShowBookingSummary2 = () => {
//     setShowBookingSummary2(true);
//   };
//   const handleCloseBookingSummary = () => {
//     setShowBookingSummary(false);
//     setShowBookingSummary2(false);
//   };
//   const handleGoToToday = () => {
//     setCurrentMonth(new Date()); // Set currentMonth to today's date
//   };

//   const handlePersonalDetailsChange = (e) => {
//     const { name, value } = e.target;
//     setPersonalDetails((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };
//   // Handle same as above toggle
//   const handleSameAsAbove = (e) => {
//     setSameAsAbove(e.target.checked);
//     if (e.target.checked) {
//       setAppointmentDetails(personalDetails);
//     }
//   };
//   // Handle change for appointment details
//   const handleAppointmentDetailsChange = (e) => {
//     const { name, value } = e.target;
//     setAppointmentDetails((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };
//   // const handleQuantityChange = (
//   //   idx,
//   //   increment,
//   //   addon_name,
//   //   addon_price,
//   //   max_quantity
//   // ) => {
//   //   console.log(`Addon Name: ${addon_name}`);

//   //   // Update quantities array
//   //   const newQuantities = [...quantities];
//   //   if (increment) {
//   //     if (newQuantities[idx] >= max_quantity) {
//   //       alert(`Maximum quantity of ${max_quantity} reached for ${addon_name}`);
//   //     } else {
//   //       newQuantities[idx] += 1;
//   //     }
//   //   } else {
//   //     newQuantities[idx] = Math.max(0, newQuantities[idx] - 1); // Prevent negative quantities
//   //   }
//   //   setQuantities(newQuantities);

//   //   // Extract quantity and calculate price
//   //   const quantity = newQuantities[idx];
//   //   const totalPrice = quantity * addon_price;

//   //   // Log for debugging
//   //   console.log(`Quantity: ${quantity}, Price: ${totalPrice}`);

//   //   // Update bookingBill
//   //   const updatedBill = [...bookingBill];
//   //   const existingItemIndex = updatedBill.findIndex(
//   //     (item) => item.type === addon_name
//   //   );

//   //   if (existingItemIndex !== -1) {
//   //     if (quantity > 0) {
//   //       // Update existing item
//   //       updatedBill[existingItemIndex] = {
//   //         ...updatedBill[existingItemIndex],
//   //         qty: quantity,
//   //         rate: totalPrice,
//   //         service_id: idx, // Include service_id here if needed
//   //       };
//   //     } else {
//   //       // Remove item if quantity is zero
//   //       updatedBill.splice(existingItemIndex, 1);
//   //     }
//   //   } else if (quantity > 0) {
//   //     // Add new item to bookingBill
//   //     updatedBill.push({
//   //       type: addon_name,
//   //       qty: quantity,
//   //       rate: totalPrice,
//   //       service_id: idx,
//   //     });
//   //   }

//   //   // Update the bookingBill state
//   //   setBookingBill(updatedBill);

//   //   // Update total time by adding 60 minutes for each selected addon
//   //   if (quantity > 0) {
//   //     setTotalTime((prevTime) => prevTime + 60); // Add 60 minutes for each addon
//   //   } else {
//   //     setTotalTime((prevTime) => prevTime - 60); // Subtract 60 minutes when addon is removed
//   //   }

//   //   // Log for debugging
//   //   console.log("Updated Booking Bill:", updatedBill);
//   //   console.log("Total Time:", totalTime);
//   // };

//   const handleQuantityChange = (
//     idx,
//     increment,
//     addon_name,
//     addon_price,
//     max_quantity
//   ) => {
//     // Update quantities array
//     const newQuantities = [...quantities];
//     if (increment) {
//       if (newQuantities[idx] >= max_quantity) {
//         alert(`Maximum quantity of ${max_quantity} reached for ${addon_name}`);
//       } else {
//         newQuantities[idx] += 1;
//       }
//     } else {
//       newQuantities[idx] = Math.max(0, newQuantities[idx] - 1);
//     }
//     setQuantities(newQuantities);

//     // Update bookingBill
//     const quantity = newQuantities[idx];
//     const totalPrice = quantity * addon_price;

//     setBookingBill((prevBill) => {
//       const existingItemIndex = prevBill.findIndex(
//         (item) => item.type === addon_name
//       );

//       let updatedBill = [...prevBill];

//       if (existingItemIndex !== -1) {
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             ...updatedBill[existingItemIndex],
//             qty: quantity,
//             rate: totalPrice,
//             service_id: idx, // Using index as a unique identifier for addon
//           };
//         } else {
//           updatedBill.splice(existingItemIndex, 1);
//         }
//       } else if (quantity > 0) {
//         updatedBill.push({
//           type: addon_name,
//           qty: quantity,
//           rate: totalPrice,
//           service_id: idx,
//         });
//       }

//       // Update total time
//       const newTotalTime = updatedBill.reduce(
//         (time, item) => time + (item.qty || 0) * 60,
//         0
//       );
//       setTotalTime(newTotalTime);

//       return updatedBill;
//     });
//   };
//   const getappointmentdetails = async () => {
//     setLoading(true);
//     try {
//       // Define the request payload
//       const payload = {
//         action: "getbookingdetails", // Action to fetch all services
//         order_id: Detailsiud, // API key for authentication
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;

//         setDetailsdata(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getappointmentdetails();
//   }, [Detailsiud]);

//   const deleteallbooking = async (id) => {
//     setLoading(true);
//     try {
//       // Define the request payload
//       const payload = {
//         action: "delete_recurring_booking", // Action to fetch all services
//         recurring_id: id,
//         api_key: "1", // API key for authentication
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;
//         console.log(services);
//         // setDetailsdata(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//     bookeddata();
//     handleCloseModal();
//   };

//   useEffect(() => {
//     deleteallbooking();
//   }, []);

//   const userIdta = sessionStorage.getItem("userId") || useriddata;

//   const getuserdataa = crmgetdata?.find((user) => user.id === userIdta);
//   console.log(getuserdataa);

//   const getservicesdata = async () => {
//     // setApiCallsPending((prev) => prev + 1);
//     setLoading(true); // Set loading to true before fetching data
//     try {
//       const payload = {
//         action: "all_services",
//         api_key: "1",
//       };

//       const response = await axios.post(
//         `${BaseUrl}/backend/api/services.php`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       console.log(response.data);

//       if (response.data && response.data.status === "true") {
//         const services = response.data;
//         setallServices(services.response);

//         if (Array.isArray(services.response)) {
//           console.log("Fetched Data:", services);
//         } else {
//           console.log("No valid array in response data:", response.data);
//         }
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       // setApiCallsPending((prev) => prev - 1); // Decrement pending API calls
//       // if (apiCallsPending === 1) {
//       setLoading(false); // Set loading to false when all API calls are done
//       // } // Set loading to false after data is fetched
//     }
//   };
//   const bookeddata = async () => {
//     setLoading(true);
//     try {
//       const currentDate = new Date(); // Current date

//       // Format the date in YYYY-MM-DD format
//       const formattedDate = currentDate.toISOString().split("T")[0];

//       // Convert formattedDate back to Date object to extract year and month
//       const currentDateObj = new Date(formattedDate);

//       // Get the first day of the current month
//       const start_date = new Date(
//         currentDateObj.getFullYear(),
//         currentDateObj.getMonth(),
//         1
//       )
//         .toISOString()
//         .split("T")[0];

//       // Get the last day of the month, 3 months from now
//       const end_date = new Date(
//         currentDateObj.getFullYear(),
//         currentDateObj.getMonth() + 3 + 1,
//         0
//       )
//         .toISOString()
//         .split("T")[0];

//       // Define the request payload
//       const payload = {
//         action: "getallbookings", // Action to fetch all services
//         api_key: "1", // API key for authentication
//         start_date: start_date,
//         end_date: end_date,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data && response.data.status === "true") {
//         const services = response.data;
//         console.log(services.response);

//         if (Array.isArray(services.response)) {
//           console.log("Fetched Data:", services); // Log the fetched data
//           setbookingappointment(services.response);
//           // setTableData(services); // Uncomment to update the table
//         } else {
//           console.log("No valid array in response data:", response.data);
//         }
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     bookeddata();
//   }, []);

//   useEffect(() => {
//     getservicesdata();
//   }, []);

//   useEffect(() => {
//     calculateDiscountedTotal(); // Calculate discounted total whenever discount or total changes
//   }, [selectedDiscount]);

//   const frequently_discount = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(
//         `${BaseUrl}/backend/api/services.php?action=frequently_discount`
//       );

//       console.log("Raw Response:", response.data);

//       // Parse the response if necessary
//       let responseData = response.data;
//       if (typeof responseData === "string") {
//         try {
//           responseData = JSON.parse(responseData.trim()); // Remove extra whitespace and parse
//         } catch (error) {
//           console.log("Error parsing response data:", error);
//           return;
//         }
//       }

//       // Handle the parsed response
//       if (responseData.status === "true") {
//         const services = responseData.data;
//         console.log("Fetched Data:", services);
//         setServices_frequently_discount(services); // Update state
//       } else {
//         console.log("API response indicates failure:", responseData.message);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     frequently_discount();
//   }, []);

//   // const handleClick = () => {
//   //   window.open("/login", "_blank"); // Opens in a new tab
//   // };
//   const [isAuthenticateddata, setIsAuthenticated] = useState(false);
//   useEffect(() => {
//     // Get values from localStorage
//     const storedUserType = sessionStorage.getItem("userType");
//     const isLoggedInData = sessionStorage.getItem("isLoggedIn");

//     // Check if both values exist and isLoggedIn is 'true'
//     if (storedUserType && isLoggedInData === "true") {
//       setUserTypelocal(storedUserType);
//       setIsAuthenticated(true);
//     }
//   }, []); // Empty dependency array means this runs once on mount

//   const [authStatus, setAuthStatus] = useState(isAuthenticateddata);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setAuthStatus(isAuthenticateddata);
//     }, []);

//     return () => clearInterval(interval); // Cleanup interval on unmount
//   }, [isAuthenticateddata]);

//   const handleClick = () => {
//     if (authStatus) {
//       switch (UserTypelocal) {
//         case "admin":
//           navigate("/admin");
//           break;
//         case "staff":
//           navigate("/staff");
//           break;
//         case "client":
//           navigate("/user");
//           break;
//         default:
//           navigate("/");
//           break;
//       }
//     } else {
//       navigate("/login");
//     }
//   };

//   // useEffect(() => {
//   //   handleClick();
//   // }, []);

//   const handleClosebookingSummary = () => {
//     setShowBookingSummary(false);
//     setShowBookingSummary2(false);
//   };

//   const toggleServicePanel = () => {
//     setIsServiceOpen((prev) => !prev); // Toggle this panel
//     if (!isServiceOpen) {
//       // If opening this panel
//       setIsCalendarOpen(false); // Close others
//       setIsFormOpen(false);
//     }
//   };

//   const handleMethodSelection = (method, id) => {
//     switch ((method.method_title, id)) {
//       case "Residential Services":
//         setResidential(true);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Commercial Services":
//         setResidential(false);
//         setCommercial(true);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Property Based":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(true);
//         officesetCommercial(false);
//         break;
//       case "Area Based (Feet)":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(true);
//         break;
//       default:
//         // Reset all states if no match is found
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//     }

//     setSelectedMethod(method, id);
//   };

//   const handlePrevMonth = () => {
//     const newDate = new Date(currentDate);
//     newDate.setMonth(newDate.getMonth() - 1);
//     setCurrentDate(newDate);
//   };

//   // Function to handle next month button click
//   const handleNextMonth = () => {
//     const newDate = new Date(currentDate);
//     newDate.setMonth(newDate.getMonth() + 1);
//     setCurrentDate(newDate);
//   };

//   const handleUserTypeChange = (value) => {
//     setUserType(value); // Set the user type

//     if (value === "new") {
//       // Reset the form fields for a new user
//       setUserDetails({
//         id: "",
//         email: "",
//         password: "",
//         firstName: "",
//         lastName: "",
//         phone: "",
//         streetAddress: "",
//         zipCode: "",
//         city: "",
//         state: "",
//         specialRequests: "",
//       });
//     } else if (value === "existing") {
//       // Optionally, handle the reset when switching to "Existing User"
//       setUserDetails({
//         id: optiondata?.id || "",
//         email: optiondata?.user_email || "",
//         password: optiondata?.user_pwd || "",
//         firstName: optiondata?.first_name || "",
//         lastName: optiondata?.last_name || "",
//         phone: optiondata?.phone || "",
//         streetAddress: optiondata?.address || optiondata?.street_address || "",
//         city: optiondata?.city || "",
//         state: optiondata?.state || "",
//         zipCode: optiondata?.zip || "",
//         specialRequests: optiondata?.notes || "",
//       });
//     }
//   };

//   const handleConfirmClick = (id) => {
//     console.log(`Confirming appointment with ID: ${id}`);
//     // Add logic for confirming the appointment here
//   };

//   const handleChangedata = (event) => {
//     const selectedId = event.target.value;
//     setSelectedOption(selectedId); // Update the selected option

//     const selectedUser = crmgetdata.find((user) => user.id === selectedId); // Find the selected user
//     setoptiondata(selectedUser);

//     if (selectedUser) {
//       // Populate the form fields with the selected user's data
//       setUserDetails({
//         id: selectedUser.id || "",
//         email: selectedUser.user_email || "",
//         password: selectedUser.user_pwd || "",
//         firstName: selectedUser.first_name || "",
//         lastName: selectedUser.last_name || "",
//         phone: selectedUser.phone || "",
//         streetAddress:
//           selectedUser.address || selectedUser.street_address || "",
//         city: selectedUser.city || "",
//         state: selectedUser.state || "",
//         zipCode: selectedUser.zip || "",
//         specialRequests: selectedUser.notes || "",
//       });
//     } else {
//       // Reset the form if no user is selected
//       setUserDetails({
//         id: "",
//         email: "",
//         password: "",
//         firstName: "",
//         lastName: "",
//         phone: "",
//         streetAddress: "",
//         zipCode: "",
//         city: "",
//         state: "",
//         specialRequests: "",
//       });
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!userDetails.email) {
//       newErrors.email = "Email is required";
//     } else if (!/\S+@\S+\.\S+/.test(userDetails.email)) {
//       newErrors.email = "Email is invalid";
//     }
//     // Password Validation
//     if (!userDetails.password) {
//       newErrors.password = "Password is required";
//     } else if (userDetails.password.length < 8) {
//       newErrors.password = "Password must be at least 8 characters";
//     }
//     if (!userDetails.firstName) {
//       newErrors.firstName = "First Name is required";
//     }
//     if (!userDetails.lastName) {
//       newErrors.lastName = "Last Name is required";
//     }
//     if (!userDetails.phone) {
//       newErrors.phone = "Phone is required";
//     }
//     if (!userDetails.streetAddress) {
//       newErrors.streetAddress = "Street Address is required";
//     }
//     if (!userDetails.zipCode) {
//       newErrors.zipCode = "Zip Code is required";
//     }
//     if (!userDetails.city) {
//       newErrors.city = "City is required";
//     }
//     if (!userDetails.state) {
//       newErrors.state = "State is required";
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };
//   const handleUserDetailsChange = (event) => {
//     const { name, value } = event.target;
//     setUserDetails({ ...userDetails, [name]: value });
//   };

//   // const handleSubmitdata = (e) => {
//   //   e.preventDefault(); // Prevent the default form submission behavior

//   //   // Clear existing errors
//   //   const newErrors = {};

//   //   // Validate password length
//   //   if (userDetails.password && userDetails.password.length > 8) {
//   //     newErrors.password = "Password must be at most 8 characters.";
//   //   }

//   //   // If errors exist, update the error state and prevent form submission
//   //   if (Object.keys(newErrors).length > 0) {
//   //     setErrors(newErrors);
//   //     return;
//   //   }

//   //   // Proceed with form submission if no validation errors
//   //   if (validateForm()) {
//   //     setLoading(true);

//   //     const data = {
//   //       action: "add_customerdata",
//   //       api_key: "1", // Use the actual API key for authentication
//   //       email: userDetails.email,
//   //       password: userDetails.password,
//   //       first_name: userDetails.firstName,
//   //       last_name: userDetails.lastName,
//   //       phone: userDetails.phone,
//   //       address: userDetails.streetAddress,
//   //       zipcode: userDetails.zipCode,
//   //       city: userDetails.city,
//   //       state: userDetails.state,
//   //       notes: userDetails.specialRequests,
//   //     };

//   //     // Send the data using axios POST request
//   //     axios
//   //       .post(`${BaseUrl}/backend/api/add_customer.php`, data)
//   //       .then((response) => {
//   //         console.log(response.data);

//   //         if (response.data.status === "true") {
//   //           // Handle success (e.g., show success message or redirect)
//   //           alert("Customer created successfully!");
//   //           setSuccessMessage("Add Customer successfully!");
//   //           getservicesdata();
//   //           setuseriddata(response.data.customer_data.id);
//   //         } else {
//   //           // Handle failure (e.g., show error message)
//   //           alert(response.data.response);

//   //           getservicesdata();
//   //         }
//   //       })
//   //       .catch((error) => {
//   //         // Handle any errors during the request
//   //         console.error("Error occurred while submitting:", error);
//   //         alert("There was an error submitting the form. Please try again.");
//   //       })
//   //       .finally(() => {
//   //         setLoading(false);
//   //       });
//   //   }
//   // };

//   const handleSubmitdata = (e) => {
//     e.preventDefault(); // Prevent the default form submission behavior

//     // Clear existing errors
//     const newErrors = {};

//     // Validate password length
//     if (userDetails.password && userDetails.password.length > 8) {
//       newErrors.password = "Password must be at most 8 characters.";
//     }

//     // If errors exist, update the error state and prevent form submission
//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       return;
//     }

//     // Proceed with form submission if no validation errors
//     if (validateForm()) {
//       setLoading(true);

//       const data = {
//         action: "add_customerdata", // Keeping your original action name
//         api_key: "1", // Use the actual API key for authentication
//         email: userDetails.email,
//         password: userDetails.password,
//         first_name: userDetails.firstName,
//         last_name: userDetails.lastName,
//         phone: userDetails.phone,
//         address: userDetails.streetAddress,
//         zipcode: userDetails.zipCode,
//         city: userDetails.city,
//         state: userDetails.state,
//         notes: userDetails.specialRequests,
//         vc_status: vacuum === "yes" ? "Y" : "N", // Map vacuum cleaner status
//         p_status: parking === "yes" ? "Y" : "N", // Map parking status
//         contact_status: access === "home" ? "Active" : access, // Map access method
//       };

//       console.log(data);

//       // Send the data using axios POST request
//       axios
//         .post(`${BaseUrl}/backend/api/add_customer.php`, data)
//         .then((response) => {
//           console.log(response.data);

//           if (response.data.status === "true") {
//             // Handle success (e.g., show success message or redirect)
//             alert("Customer created successfully!");
//             setSuccessMessage("Add Customer successfully!");
//             getservicesdata();
//             setuseriddata(response.data.customer_data.id);
//           } else {
//             // Handle failure (e.g., show error message)
//             getservicesdata();
//           }
//         })
//         .catch((error) => {
//           // Handle any errors during the request
//           console.error("Error occurred while submitting:", error);
//           alert("There was an error submitting the form. Please try again.");
//         })
//         .finally(() => {
//           setLoading(false);
//         });
//     }
//   };

//   const today = new Date();

//   const handleLogout = () => {
//     sessionStorage.removeItem("userId");
//     sessionStorage.removeItem("userType");
//     sessionStorage.removeItem("isLoggedIn");
//     setIsLoggedIn(false);
//   };

//   return (
//     <div className="flex items-center justify-center min-h-screen ">
//       {loading ? (
//         <>
//           <Circles height="80" width="80" color="grey" ariaLabel="loading" />
//           <br></br>
//           <h1>Please wait...</h1>
//         </>
//       ) : (
//         <div className="flex flex-col bg-gray-100 p-4 w-full">
//           <div className="w-full max-w-6xl mx-auto">
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//               {/* Left Section - Booking Form */}
//               <div className="col-span-2 bg-white p-6 rounded-lg shadow-lg">
//                 <button
//                   onClick={handleClick}
//                   className="px-4 py-2 mt-3 bg-blue-500 text-white flex items-end justify-end rounded-md hover:bg-blue-600 transition duration-200"
//                 >
//                   My Booking
//                 </button>
//                 <h1 className="text-3xl font-medium text-center text-blue-800 mb-6">
//                   Megaclean
//                 </h1>
//                 <p className="text-center text-gray-700 mb-4">Amroli Surat</p>

//                 <form onSubmit={handleSubmit} className="space-y-6">
//                   {/* Service Location */}
//                   <div>
//                     <label
//                       htmlFor="serviceLocation"
//                       className="block text-lg font-medium text-gray-800"
//                     >
//                       Where would you like us to provide service?
//                     </label>
//                   </div>

//                   {/* Zip Code Input */}
//                   {/* <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6">
//                     <div className="flex flex-col w-full">
//                       <label
//                         htmlFor="zipCode"
//                         className="block text-lg font-medium text-gray-800"
//                       >
//                         Zip Code
//                       </label>
//                       <input
//                         type="number"
//                         id="zipCode"
//                         name="zipCode"
//                         value={formData.zipCode}
//                         onChange={handleChange}
//                         className="mt-2 p-2 w-full border border-gray-400 rounded-md"
//                         placeholder="Zip Code"
//                         onInput={(e) => {
//                           if (e.target.value.length > 6) {
//                             e.target.value = e.target.value.slice(0, 6); // Max 6 digits
//                           }
//                         }}
//                       />
//                     </div>
//                   </div> */}
//                   {/* // Update your Zip Code input section in the JSX */}
//                   <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6">
//                     <div className="flex flex-col w-full">
//                       <label
//                         htmlFor="zipCode"
//                         className="block text-lg font-medium text-gray-800"
//                       >
//                         Zip Code
//                       </label>
//                       <input
//                         type="number"
//                         id="zipCode"
//                         name="zipCode"
//                         value={formData.zipCode}
//                         onChange={handleZipCodeChange} // Use new handler
//                         className="mt-2 p-2 w-full border border-gray-400 rounded-md"
//                         placeholder="Enter Zip Code"
//                         onInput={(e) => {
//                           if (e.target.value.length > 6) {
//                             e.target.value = e.target.value.slice(0, 6); // Max 6 digits
//                           }
//                         }}
//                       />
//                       {/* Display error message if zip code is invalid */}
//                       {zipCodeError && (
//                         <p className="text-red-500 text-sm mt-1">
//                           {zipCodeError}
//                         </p>
//                       )}
//                     </div>
//                   </div>
//                   {/* Choose Service */}
//                   <div>
//                     <label
//                       htmlFor="selectedService"
//                       className="block text-lg font-medium text-gray-800"
//                     >
//                       Choose Service
//                     </label>
//                   </div>

//                   <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-6 min-[320px]:grid-cols-2 max-[640px]:grid-cols-2">
//                     {allServices?.map((service) => (
//                       <div
//                         key={service.service_id}
//                         onClick={() => {
//                           if (service.service_id) {
//                             setSelectedService(service.service_id);
//                           } else {
//                             console.error("Service ID is missing", service);
//                           }
//                         }}
//                         className={`cursor-pointer border rounded-lg text-center shadow-md ${
//                           selectedService === service.service_id
//                             ? "bg-blue-400 text-white"
//                             : "bg-white"
//                         } hover:bg-blue-300`}
//                       >
//                         {service?.service_image ? (
//                           // If image exists, show image with title overlay
//                           <div className="relative">
//                             <img
//                               src={service.service_image}
//                               className="w-full h-52 object-cover rounded-md min-[320px]:h-36 max-[640px]:h-36"
//                             />
//                             <div className="absolute inset-0 flex items-center justify-center text-white font-bold bg-black bg-opacity-50 rounded-md">
//                               {service?.service_title}
//                             </div>
//                           </div>
//                         ) : (
//                           // If no image, show only title with a colored background
//                           <div className="flex items-center justify-center h-20 p-4 text-white font-bold bg-gray-500 rounded-md">
//                             {service?.service_title}
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>

//                   {/* Conditionally render the selected service details */}
//                   {selectedService && (
//                     <div>
//                       {/* Find the selected service */}
//                       {allServices
//                         .filter((s) => s.service_id === selectedService)
//                         ?.map((service) => (
//                           <>
//                             <div>
//                               {/* Dropdowns */}
//                               {service.units && service.units.length > 0 && (
//                                 <div>
//                                   {service.units?.map((unit) => (
//                                     <div
//                                       key={unit.unit_id}
//                                       className="flex gap-4 mb-6"
//                                     >
//                                       <div>
//                                         <div className="flex items-center space-x-2">
//                                           {/* Display the unit title */}
//                                           <label className="block font-medium mb-2">
//                                             {unit.unit_title}
//                                           </label>
//                                           <img
//                                             src={Bed}
//                                             className="w-6 h-6"
//                                             alt="Unit Icon"
//                                           />
//                                         </div>
//                                         <select
//                                           className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-400"
//                                           value={
//                                             bedroom[unit.unit_id] ||
//                                             unit.unit_min
//                                           } // Default to `unit_min`
//                                           onChange={(e) =>
//                                             handleBedroomChange(
//                                               unit.unit_id,
//                                               parseInt(e.target.value)
//                                             )
//                                           }
//                                         >
//                                           {Array.from(
//                                             {
//                                               length:
//                                                 unit.unit_max -
//                                                 unit.unit_min +
//                                                 1,
//                                             },
//                                             (_, i) => (
//                                               <option
//                                                 key={i + unit.unit_min}
//                                                 value={i + unit.unit_min}
//                                               >
//                                                 {i}
//                                               </option>
//                                             )
//                                           )}
//                                         </select>
//                                       </div>
//                                     </div>
//                                   ))}
//                                 </div>
//                               )}

//                               {/* Render methods */}
//                               {service.methods &&
//                                 service.methods.length > 0 && (
//                                   <div className="flex flex-col space-y-6 mb-5">
//                                     {/* Upper part: Methods Buttons */}
//                                     <div>
//                                       <h3>Methods</h3>
//                                       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//                                         {service.methods?.map((method) => (
//                                           <button
//                                             type="button"
//                                             key={method.method_id}
//                                             onClick={() =>
//                                               handleMethodSelection(
//                                                 method,
//                                                 method.method_id
//                                               )
//                                             }
//                                             className={`p-4 border rounded-lg text-center shadow-md transition-all ${
//                                               selectedMethod &&
//                                               selectedMethod.method_id ===
//                                                 method.method_id
//                                                 ? "bg-blue-400 text-white"
//                                                 : "bg-white hover:bg-gray-200"
//                                             }`}
//                                           >
//                                             {method.method_title}
//                                           </button>
//                                         ))}
//                                       </div>
//                                     </div>

//                                     {/* Bottom part: Submethods and Quantity Buttons */}
//                                     {selectedMethod && (
//                                       <div className="mt-6">
//                                         {selectedMethod.submethods &&
//                                         selectedMethod.submethods.length > 0 ? (
//                                           <>
//                                             {/* Mobile View - Dropdown */}
//                                             <div className="block md:hidden">
//                                               {selectedMethod.submethods.map(
//                                                 (submethod) => (
//                                                   <div
//                                                     key={submethod.unit_id}
//                                                     className="mb-4"
//                                                   >
//                                                     <label className="block font-medium mb-2">
//                                                       {submethod.unit_title} (₹
//                                                       {submethod.unit_price})
//                                                     </label>
//                                                     <select
//                                                       className="w-full p-2 border rounded-lg"
//                                                       onChange={(e) => {
//                                                         const selectedQuantity =
//                                                           parseInt(
//                                                             e.target.value,
//                                                             10
//                                                           );
//                                                         addItemToBill(
//                                                           submethod.unit_id,
//                                                           submethod.unit_title,
//                                                           selectedQuantity,
//                                                           submethod.unit_price
//                                                         );
//                                                       }}
//                                                     >
//                                                       <option value="">
//                                                         Select Quantity
//                                                       </option>
//                                                       {[
//                                                         ...Array(
//                                                           submethod.unit_max -
//                                                             submethod.unit_min +
//                                                             1
//                                                         ).keys(),
//                                                       ].map((qty) => {
//                                                         const quantity =
//                                                           1 + qty;
//                                                         return (
//                                                           <option
//                                                             key={quantity}
//                                                             value={quantity}
//                                                           >
//                                                             {quantity}
//                                                           </option>
//                                                         );
//                                                       })}
//                                                     </select>
//                                                   </div>
//                                                 )
//                                               )}
//                                             </div>

//                                             {/* Desktop & Tablet View - Buttons */}
//                                             <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-2 gap-2">
//                                               {selectedMethod.submethods.map(
//                                                 (submethod) => (
//                                                   <div
//                                                     key={submethod.unit_id}
//                                                     className="mb-4"
//                                                   >
//                                                     <label className="block font-medium mb-2">
//                                                       {submethod.unit_title}{" "}
//                                                       &nbsp;(₹
//                                                       {submethod.unit_price})
//                                                     </label>
//                                                     <select
//                                                       className="w-full p-2 border rounded-lg"
//                                                       onChange={(e) => {
//                                                         const selectedQuantity =
//                                                           parseInt(
//                                                             e.target.value,
//                                                             10
//                                                           );
//                                                         addItemToBill(
//                                                           submethod.unit_id,
//                                                           submethod.unit_title,
//                                                           selectedQuantity,
//                                                           submethod.unit_price,
//                                                           service.service_title
//                                                         );
//                                                       }}
//                                                       value={
//                                                         bookingBill.find(
//                                                           (item) =>
//                                                             item.unit_id ===
//                                                             submethod.unit_id
//                                                         )?.qty || ""
//                                                       }
//                                                     >
//                                                       <option value="">
//                                                         Select Quantity
//                                                       </option>
//                                                       {[
//                                                         ...Array(
//                                                           submethod.unit_max -
//                                                             submethod.unit_min +
//                                                             1
//                                                         ).keys(),
//                                                       ].map((qty) => {
//                                                         const quantity =
//                                                           qty + 1;
//                                                         return (
//                                                           <option
//                                                             key={quantity}
//                                                             value={quantity}
//                                                           >
//                                                             {quantity}
//                                                           </option>
//                                                         );
//                                                       })}
//                                                     </select>
//                                                   </div>
//                                                 )
//                                               )}
//                                             </div>
//                                           </>
//                                         ) : (
//                                           <p className="text-gray-600">
//                                             No submethods available for this
//                                             method.
//                                           </p>
//                                         )}
//                                       </div>
//                                     )}
//                                   </div>
//                                 )}

//                               {selectedMethod && (
//                                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//                                   {service.addons?.map((addon, index) => (
//                                     <div
//                                       key={index}
//                                       className="p-4 border rounded-lg text-center bg-white shadow-md"
//                                     >
//                                       <p className="text-lg font-semibold mb-2">
//                                         {addon.addon_name}
//                                       </p>
//                                       <p className="text-lg mb-4">
//                                         Price: ₹{addon.addon_price}
//                                       </p>
//                                       <div className="flex items-center justify-center gap-2">
//                                         <button
//                                           type="button"
//                                           onClick={() =>
//                                             handleQuantityChange(
//                                               index,
//                                               false,
//                                               addon.addon_name,
//                                               addon.addon_price,
//                                               addon.addon_maxqty
//                                             )
//                                           }
//                                           className="p-2 bg-red-400 text-white rounded-lg"
//                                         >
//                                           -
//                                         </button>
//                                         <span className="text-lg">
//                                           {quantities[index] || 0}
//                                         </span>
//                                         <button
//                                           type="button"
//                                           onClick={() =>
//                                             handleQuantityChange(
//                                               index,
//                                               true,
//                                               addon.addon_name,
//                                               addon.addon_price,
//                                               addon.addon_maxqty
//                                             )
//                                           }
//                                           className="p-2 bg-green-400 text-white rounded-lg"
//                                           disabled={
//                                             quantities[index] >=
//                                             addon.addon_maxqty
//                                           }
//                                         >
//                                           +
//                                         </button>
//                                       </div>
//                                     </div>
//                                   ))}
//                                 </div>
//                               )}
//                             </div>
//                           </>
//                         ))}
//                     </div>
//                   )}

//                   <div className="p-4">
//                     <h2 className="text-lg font-semibold mb-4 text-center sm:text-left">
//                       How often would you like us to provide service?
//                     </h2>
//                     <div className="flex flex-wrap justify-center sm:justify-start gap-4">
//                       {Services_frequently_discount?.map((v) => (
//                         <div className="flex flex-col items-center w-28 sm:w-auto">
//                           <button
//                             type="button"
//                             className={`px-6 py-2 w-full sm:w-auto border rounded-md ${
//                               selectedFrequency === v.discount_typename
//                                 ? "border-teal-500 text-teal-500"
//                                 : "border-gray-300"
//                             }`}
//                             onClick={() => {
//                               setSelectedFrequency(v?.discount_typename);
//                               setSelectedDiscount(v?.rates);
//                               setselectedservices(v?.id);
//                             }}
//                           >
//                             {v.discount_typename}
//                           </button>
//                           <p className="text-sm text-gray-500 mt-2">
//                             {v.labels}
//                           </p>
//                         </div>
//                       ))}
//                     </div>
//                   </div>

//                   {/* Service Provider Section */}
//                   <div>
//                     <h2 className="text-lg font-semibold mb-4">
//                       Please select provider
//                     </h2>

//                     <div className="relative px-4 pb-4">
//                       {/* Previous Button */}
//                       <button
//                         type="button"
//                         onClick={() => scroll("prev")}
//                         className="absolute left-0 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full z-10 opacity-75 hover:opacity-100 transition-opacity"
//                       >
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           className="w-6 h-6"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M15 19l-7-7 7-7"
//                           />
//                         </svg>
//                       </button>

//                       {/* Scrollable Container */}
//                       <div
//                         ref={scrollRef}
//                         className="flex overflow-x-auto lg:flex lg:space-x-8 px-4 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
//                       >
//                         {adminData?.length > 0 ? (
//                           adminData.map((provider, index) => (
//                             <div
//                               key={index}
//                               className={`flex flex-col items-center cursor-pointer flex-shrink-0 ${
//                                 selectedProvider === provider
//                                   ? "border-teal-500"
//                                   : "border-gray-300"
//                               } border rounded-md p-4 m-2 sm:m-5 w-full sm:w-auto max-w-xs mx-auto`}
//                               onClick={() => {
//                                 setSelectedProvider(provider);
//                                 setgetidbyadmin(provider.id); // Assuming you want to set staff ID here
//                               }}
//                             >
//                               <img
//                                 src={provider.image || "default-image.jpg"} // Fallback image if none provided
//                                 className="w-16 h-16 sm:w-24 sm:h-24 rounded-full mb-2 object-cover"
//                               />
//                               <p className="font-semibold text-gray-800 text-center text-sm sm:text-base">
//                                 {provider.fullname}
//                               </p>
//                               {/* Rating */}
//                               <div className="flex space-x-1 mt-2">
//                                 {[...Array(5)].map((_, i) => (
//                                   <svg
//                                     key={i}
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     fill={i < 4 ? "currentColor" : "none"}
//                                     viewBox="0 0 24 24"
//                                     stroke="currentColor"
//                                     className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400"
//                                   >
//                                     <path
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                       strokeWidth={2}
//                                       d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
//                                     />
//                                   </svg>
//                                 ))}
//                               </div>
//                             </div>
//                           ))
//                         ) : (
//                           <p className="text-gray-500 text-center w-full">
//                             No staff available for the selected service.
//                           </p>
//                         )}
//                       </div>

//                       {/* Next Button */}
//                       <button
//                         type="button"
//                         onClick={() => scroll("next")}
//                         className="absolute right-0 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full z-10 opacity-75 hover:opacity-100 transition-opacity"
//                       >
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           className="w-6 h-6"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M9 5l7 7-7 7"
//                           />
//                         </svg>
//                       </button>
//                     </div>
//                   </div>

//                   <div>
//                     {/* Left Column - Calendar */}
//                     <div className="max-auto bg-white">
//                       <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
//                         <div className="text-center mb-8">
//                           <h2 className="text-3xl sm:text-4xl font-bold text-gray-800">
//                             Book Your Appointment
//                           </h2>
//                         </div>

//                         {/* Calendar */}
//                         <div>
//                           <div>
//                             <div className="flex flex-col items-center mb-6 px-2 py-2 overflow-hidden ">
//                               <div className="flex justify-between items-center w-full max-w-4xl px-4 mb-4">
//                                 <button
//                                   type="button"
//                                   onClick={handlePrevMonth}
//                                   className="bg-gray-200 text-gray-800 px-3 py-1 rounded-md shadow-md hover:bg-gray-300"
//                                 >
//                                   Previous
//                                 </button>
//                                 <h2 className="text-xl font-semibold text-gray-700">
//                                   {currentDate.toLocaleString("default", {
//                                     month: "long",
//                                   })}{" "}
//                                   {currentDate.getFullYear()}
//                                 </h2>
//                                 <button
//                                   type="button"
//                                   onClick={handleNextMonth}
//                                   className="bg-gray-200 text-gray-800 px-3 py-1 rounded-md shadow-md hover:bg-gray-300"
//                                 >
//                                   Next
//                                 </button>
//                               </div>

//                               <div className="grid grid-cols-4 sm:grid-cols-7 gap-4 p-4 bg-gray-100 rounded-2xl shadow-inner">
//                                 {calendar?.map((week, index) => (
//                                   <div key={index} className="contents">
//                                     {week?.map((day, dayIndex) => {
//                                       const currentDay = new Date(
//                                         currentDate.getFullYear(),
//                                         currentDate.getMonth(),
//                                         day
//                                       );
//                                       const isPastDate =
//                                         currentDay <
//                                         new Date().setHours(0, 0, 0, 0);
//                                       const isSelected =
//                                         daySelected === day && !isPastDate; // Check if this day is selected

//                                       return (
//                                         <button
//                                           key={dayIndex}
//                                           type="button"
//                                           className={`w-12 h-12 sm:w-16 sm:h-12 flex items-center justify-center rounded-full transition-all duration-300 ease-in-out 
//                                         ${
//                                           day
//                                             ? "cursor-pointer"
//                                             : "cursor-default"
//                                         }
//                                         ${
//                                           day
//                                             ? "hover:bg-blue-200 hover:text-white hover:shadow-lg hover:scale-110"
//                                             : "opacity-0"
//                                         }
//                                         ${
//                                           isPastDate
//                                             ? "bg-gray-300 text-gray-500 cursor-not-allowed"
//                                             : "bg-white text-gray-700 border border-gray-200"
//                                         }
//                                         ${
//                                           day === daySelected
//                                             ? " !bg-blue-500 !text-white"
//                                             : ""
//                                         }`} // Red background for selected date
//                                           onClick={() => handleDateClick(day)}
//                                           disabled={!day || isPastDate}
//                                         >
//                                           {day}
//                                         </button>
//                                       );
//                                     })}
//                                   </div>
//                                 ))}
//                               </div>

//                               {selectedDate && (
//                                 <div className="mt-4">
//                                   <h3 className="text-lg font-semibold mb-4">
//                                     Available Times for{" "}
//                                     {format(selectedDate, "dd-MM-yyyy")}
//                                   </h3>
//                                   <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
//                                     {timeSlots?.map((slot, index) => {
//                                       // Convert slot time to Date object for comparison
//                                       const [hours, minutes] = slot.split(":");
//                                       const slotDate = new Date(selectedDate);
//                                       slotDate.setHours(
//                                         parseInt(hours),
//                                         parseInt(minutes),
//                                         0
//                                       );

//                                       // Check if slot is in the past
//                                       const isPast = slotDate < new Date();

//                                       return (
//                                         <button
//                                           type="button"
//                                           key={index}
//                                           onClick={() =>
//                                             !isPast && handleTimeSelect(slot)
//                                           }
//                                           disabled={isPast}
//                                           className={`
//                                                       py-3 px-4 rounded-xl text-sm font-semibold transition-all duration-200
//                                                       ${
//                                                         isPast
//                                                           ? "bg-gray-100 text-gray-400 cursor-not-allowed opacity-60"
//                                                           : selectedTime ===
//                                                             slot
//                                                           ? "bg-blue-600 text-white shadow-md transform scale-105"
//                                                           : "bg-white text-gray-800 hover:bg-blue-50 hover:text-blue-600 border border-gray-200"
//                                                       }
//                                                     `}
//                                         >
//                                           <div className="flex flex-col items-center space-y-1">
//                                             <span>{slot}</span>
//                                             <span className="text-xs font-normal">
//                                               {isPast
//                                                 ? "Not Available"
//                                                 : "Available"}
//                                             </span>
//                                           </div>
//                                         </button>
//                                       );
//                                     })}
//                                   </div>
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className=" mx-auto p-6 border border-gray-300 ">
//                     <h2 className="text-xl font-bold mb-4">
//                       Your Personal Details
//                     </h2>
//                     <p className="text-sm text-gray-600 mb-4">
//                       Please provide your address and contact details
//                     </p>
//                     <div className="w-full mx-auto bg-white rounded-lg p-8">
//                       {/* Radio Buttons */}
//                       <div className="flex items-center space-x-6 mb-6">
//                         <label className="flex items-center">
//                           <input
//                             type="radio"
//                             name="userType"
//                             value="existing"
//                             checked={userType === "existing"}
//                             onChange={() => handleUserTypeChange("existing")}
//                             className="mr-2"
//                           />
//                           Existing User
//                         </label>
//                         {/* Conditionally render New User radio button only if not logged in */}
//                         {!isLoggedIn && (
//                           <label className="flex items-center">
//                             <input
//                               type="radio"
//                               name="userType"
//                               value="new"
//                               checked={userType === "new"}
//                               onChange={() => handleUserTypeChange("new")}
//                               className="mr-2"
//                             />
//                             New User
//                           </label>
//                         )}
//                       </div>
//                       {isLoggedIn ? (
//                         <div className="max-w-lg mx-auto bg-white rounded-lg shadow-lg p-6 mt-6 transform transition-all ">
//                           <div className="flex justify-between items-center mb-4">
//                             <h2 className="text-xl font-semibold text-green-600">
//                               You are logged innn!
//                             </h2>
//                             <button
//                               onClick={handleLogout}
//                               className="px-4 py-2 bg-red-500 text-white rounded-md shadow-md hover:bg-red-600 transition duration-200 text-sm"
//                             >
//                               Logout
//                             </button>
//                           </div>
//                           {getuserdataa ? (
//                             <div className="space-y-4">
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Name:
//                                 </span>
//                                 <p className="text-gray-800">{`${getuserdataa?.first_name} ${getuserdataa?.last_name}`}</p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Email:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.user_email}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Phone:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.phone || "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Address:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.address ||
//                                     getuserdataa?.street_address ||
//                                     "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Zip Code:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.zip || "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   City:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.city || "N/A"}
//                                 </p>
//                               </div>
//                               {/* <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   State:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.state || "N/A"}
//                                 </p>
//                               </div> */}
//                             </div>
//                           ) : (
//                             <div className="space-y-4">
//                               {/* <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Name:
//                                 </span>
//                                 <p className="text-gray-800">{`${getuserdataa?.first_name} ${getuserdataa?.last_name}`}</p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Email:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.user_email || "n/a"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Phone:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.phone || "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Address:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.address ||
//                                     getuserdataa?.street_address ||
//                                     "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   Zip Code:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.zip || "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   City:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.city || "N/A"}
//                                 </p>
//                               </div>
//                               <div className="flex items-center space-x-3">
//                                 <span className="font-medium text-gray-700 w-32">
//                                   State:
//                                 </span>
//                                 <p className="text-gray-800">
//                                   {getuserdataa?.state || "N/A"}
//                                 </p>
//                               </div> */}
//                               <h1 classN> But Only user Login </h1>
//                             </div>
//                             // <p className="text-gray-500 text-center">Loading user details...</p>
//                           )}
//                         </div>
//                       ) : (
//                         // Show this if user is NOT logged in
//                         <>
//                           {userType === "existing" ? (
//                             <div>
//                               <div className="space-y-5">
//                                 <div>
//                                   <label
//                                     htmlFor="email"
//                                     className="block text-sm font-medium text-gray-700 mb-1"
//                                   >
//                                     Email address
//                                   </label>
//                                   <input
//                                     type="email"
//                                     id="email"
//                                     value={email}
//                                     onChange={(e) => setEmail(e.target.value)}
//                                     className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 transition"
//                                     placeholder="Enter your email"
//                                   />
//                                 </div>
//                                 <div className="relative">
//                                   <label
//                                     htmlFor="password"
//                                     className="block text-sm font-medium text-gray-700 mb-1"
//                                   >
//                                     Password
//                                   </label>
//                                   <input
//                                     type={showPassword ? "text" : "password"}
//                                     id="password"
//                                     value={password}
//                                     onChange={(e) =>
//                                       setPassword(e.target.value)
//                                     }
//                                     className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 transition pr-10"
//                                     placeholder="Enter your password"
//                                   />
//                                   <button
//                                     type="button"
//                                     className="absolute right-3 top-9 text-gray-500"
//                                     onClick={() =>
//                                       setShowPassword(!showPassword)
//                                     }
//                                   >
//                                     {showPassword ? (
//                                       <EyeOffIcon size={20} />
//                                     ) : (
//                                       <EyeIcon size={20} />
//                                     )}
//                                   </button>
//                                 </div>
//                                 <div className="flex justify-center">
//                                   <button
//                                     onClick={handleLogin}
//                                     disabled={loading}
//                                     className={`w-32 bg-blue-500 text-white py-2 rounded-lg shadow-md hover:bg-blue-600 transition text-sm flex justify-center items-center ${
//                                       loading
//                                         ? "opacity-50 cursor-not-allowed"
//                                         : ""
//                                     }`}
//                                   >
//                                     {loading ? (
//                                       <Circles
//                                         height="20"
//                                         width="20"
//                                         color="#fff"
//                                       />
//                                     ) : (
//                                       "Log in"
//                                     )}
//                                   </button>
//                                 </div>
//                               </div>
//                               {error && (
//                                 <p className="text-center text-sm mt-4 text-red-500">
//                                   {error}
//                                 </p>
//                               )}
//                               {successMessage && (
//                                 <p className="text-center text-sm mt-4 text-green-500">
//                                   {successMessage}
//                                 </p>
//                               )}
//                             </div>
//                           ) : (
//                             <div className="grid grid-cols-1 gap-4 mb-6 p-6 bg-white shadow-lg rounded-lg max-w-lg mx-auto">
//                               {/* Email */}
//                               <input
//                                 type="email"
//                                 name="email"
//                                 placeholder="Preferred Email"
//                                 value={userDetails.email || ""}
//                                 onChange={handleUserDetailsChange}
//                                 className="border p-2 rounded-md w-full"
//                               />

//                               {/* Password */}
//                               <input
//                                 type="password"
//                                 name="password"
//                                 placeholder="Preferred Password"
//                                 value={userDetails.password || ""}
//                                 onChange={handleUserDetailsChange}
//                                 className="border p-2 rounded-md w-full"
//                               />

//                               {/* First Name and Last Name */}
//                               <div className="grid grid-cols-2 gap-4">
//                                 <input
//                                   type="text"
//                                   name="firstName"
//                                   placeholder="First Name"
//                                   value={userDetails.firstName || ""}
//                                   onChange={handleUserDetailsChange}
//                                   className="border p-2 rounded-md"
//                                 />
//                                 <input
//                                   type="text"
//                                   name="lastName"
//                                   placeholder="Last Name"
//                                   value={userDetails.lastName || ""}
//                                   onChange={handleUserDetailsChange}
//                                   className="border p-2 rounded-md"
//                                 />
//                               </div>

//                               {/* Phone and Street Address */}
//                               <div className="grid grid-cols-2 gap-4">
//                                 <input
//                                   type="text"
//                                   name="phone"
//                                   placeholder="Phone"
//                                   value={userDetails.phone || ""}
//                                   onChange={handleUserDetailsChange}
//                                   className="border p-2 rounded-md"
//                                 />
//                                 <input
//                                   type="text"
//                                   name="streetAddress"
//                                   placeholder="Street Address"
//                                   value={userDetails.streetAddress || ""}
//                                   onChange={handleUserDetailsChange}
//                                   className="border p-2 rounded-md w-full"
//                                 />
//                               </div>

//                               {/* Zip Code, City, and State */}
//                               <div className="grid grid-cols-3 gap-4">
//                                 <input
//                                   type="text"
//                                   name="zipCode"
//                                   placeholder="Zip Code"
//                                   value={userDetails.zipCode || ""}
//                                   onChange={handleUserDetailsChange}
//                                   className="border p-2 rounded-md"
//                                 />
//                                 <input
//                                   type="text"
//                                   name="city"
//                                   placeholder="City"
//                                   value={userDetails.city || ""}
//                                   onChange={handleUserDetailsChange}
//                                   className="border p-2 rounded-md"
//                                 />
//                                 <input
//                                   type="text"
//                                   name="state"
//                                   placeholder="State"
//                                   value={userDetails.state || ""}
//                                   onChange={handleUserDetailsChange}
//                                   className="border p-2 rounded-md"
//                                 />
//                               </div>

//                               {/* Special Requests */}
//                               <textarea
//                                 name="specialRequests"
//                                 placeholder="Special Requests (Notes)"
//                                 value={userDetails.specialRequests || ""}
//                                 onChange={handleUserDetailsChange}
//                                 className="border p-2 rounded-md w-full"
//                                 rows="3"
//                               ></textarea>

//                               {/* Vacuum Cleaner */}
//                               <div className="flex justify-between items-center mb-4">
//                                 <span className="text-gray-700">
//                                   Do you have a vacuum cleaner?
//                                 </span>
//                                 <div className="flex space-x-4">
//                                   <label className="flex items-center space-x-1">
//                                     <input
//                                       type="radio"
//                                       name="vacuum"
//                                       value="yes"
//                                       checked={vacuum === "yes"}
//                                       onChange={() => setVacuum("yes")}
//                                       className="accent-blue-500"
//                                     />
//                                     <span>Yes</span>
//                                   </label>
//                                   <label className="flex items-center space-x-1">
//                                     <input
//                                       type="radio"
//                                       name="vacuum"
//                                       value="no"
//                                       checked={vacuum === "no"}
//                                       onChange={() => setVacuum("no")}
//                                       className="accent-gray-500"
//                                     />
//                                     <span>No</span>
//                                   </label>
//                                 </div>
//                               </div>

//                               {/* Parking */}
//                               <div className="flex justify-between items-center mb-4">
//                                 <span className="text-gray-700">
//                                   Do you have parking?
//                                 </span>
//                                 <div className="flex space-x-4">
//                                   <label className="flex items-center space-x-1">
//                                     <input
//                                       type="radio"
//                                       name="parking"
//                                       value="yes"
//                                       checked={parking === "yes"}
//                                       onChange={() => setParking("yes")}
//                                       className="accent-blue-500"
//                                     />
//                                     <span>Yes</span>
//                                   </label>
//                                   <label className="flex items-center space-x-1">
//                                     <input
//                                       type="radio"
//                                       name="parking"
//                                       value="no"
//                                       checked={parking === "no"}
//                                       onChange={() => setParking("no")}
//                                       className="accent-gray-500"
//                                     />
//                                     <span>No</span>
//                                   </label>
//                                 </div>
//                               </div>

//                               {/* How will we get in? */}
//                               <div className="mb-4">
//                                 <label className="block text-gray-700 mb-2">
//                                   How will we get in?
//                                 </label>
//                                 <select
//                                   value={access}
//                                   onChange={(e) => setAccess(e.target.value)}
//                                   className="w-full p-2 border border-gray-300 rounded-lg"
//                                 >
//                                   <option value="home">I'll be at home</option>
//                                   <option value="please">Please call me</option>
//                                   <option value="doorman">
//                                     The key is with the doorman
//                                   </option>
//                                   <option value="other">Other</option>
//                                 </select>
//                               </div>

//                               {/* Submit Button */}
//                               <button
//                                 onClick={handleSubmitdata}
//                                 className="bg-blue-500 text-white p-2 rounded-md w-full"
//                               >
//                                 Booked And New User Created
//                               </button>
//                             </div>
//                           )}
//                         </>
//                       )}
//                     </div>
//                     <div className="max-w-md mx-auto border rounded-lg shadow-lg mt-5 p-5 bg-white">
//                       <h3 className="text-lg font-semibold mb-3">
//                         Apply Promo Code
//                       </h3>
//                       <div className="flex gap-2">
//                         <input
//                           type="text"
//                           value={promoCode}
//                           onChange={(e) => setPromoCode(e.target.value)}
//                           placeholder="Enter promo code"
//                           className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         />
//                         <button
//                           type="button"
//                           onClick={handleApplyPromoCode}
//                           className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
//                         >
//                           Apply
//                         </button>
//                       </div>

//                       {/* Error Message */}
//                       {error && <p className="text-red-600 mt-2">{error}</p>}

//                       {/* Success Message & Cancel Button */}
//                       {appliedPromoCode && (
//                         <div className="flex justify-between items-center mt-2 p-2 bg-green-100 rounded-md">
//                           <p className="text-green-700">
//                             Promo code "{appliedPromoCode.coupon_code}" applied!
//                             ({appliedPromoCode.coupon_value}
//                             {appliedPromoCode.coupon_type === "P"
//                               ? "%"
//                               : "$"}{" "}
//                             off)
//                           </p>
//                           <button
//                             type="button"
//                             onClick={handleCancelPromo}
//                             className="text-red-600 font-semibold hover:underline"
//                           >
//                             Cancel
//                           </button>
//                         </div>
//                       )}
//                     </div>

//                     {/* Payment Method */}
//                     <div className="mb-6">
//                       <h3 className="font-bold mb-2">
//                         Preferred Payment Method
//                       </h3>

//                       {/* Pay Locally option */}
//                       <label className="flex items-center">
//                         <input
//                           type="radio"
//                           name="paymentMethod"
//                           value="payLocally"
//                           checked={paymentMethod === "payLocally"}
//                           onChange={handlePaymentChange}
//                           className="mr-2"
//                         />
//                         Pay Locally
//                       </label>

//                       {/* Pay Online option */}
//                       <label className="flex items-center ">
//                         <input
//                           type="radio"
//                           name="paymentMethod"
//                           value="payOnline"
//                           checked={paymentMethod === "payOnline"}
//                           onChange={handlePaymentChange}
//                           className="mr-2"
//                         />
//                         Pay Online
//                       </label>
//                     </div>

//                     {/* Terms & Conditions */}
//                     <div className="mb-6">
//                       <label className="items-center flex">
//                         <input
//                           type="checkbox"
//                           className="mr-2"
//                           checked={isChecked}
//                           onChange={() => setIsChecked(!isChecked)}
//                         />
//                         I have read and accepted the{" "}
//                         <a className="text-teal-600 underline" href="#terms">
//                           Terms & Conditions
//                         </a>
//                         .
//                       </label>
//                     </div>

//                     <div id="terms" className="mt-4 text-sm text-gray-700">
//                       <h3 className="font-semibold">Terms & Conditions</h3>
//                       <p>
//                         By confirming your booking, you agree to the following
//                         conditions:
//                       </p>
//                       <ul className="list-disc list-inside">
//                         <li>
//                           You must make any edits or reschedule your appointment
//                           at least 15 days before the selected booking date.
//                         </li>
//                         <li>
//                           If you attempt to edit, reschedule, or cancel your
//                           appointment within 15 days of the booking date, you
//                           will not be able to make any changes.
//                         </li>
//                       </ul>
//                     </div>
//                   </div>

//                   {/* Submit Button */}
//                   <div className="flex justify-center mt-6">
//                     <button
//                       type="submit"
//                       className="bg-blue-800 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-600 transition duration-300"
//                     >
//                       Submit Booking
//                     </button>
//                   </div>
//                 </form>
//               </div>

//               {isModalVisible && (
//                 <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
//                   <div className="bg-white p-6 rounded-lg shadow-lg text-center">
//                     <h2 className="text-xl font-bold text-green-600">
//                       Thank You!
//                     </h2>
//                     <p className="mt-2">{bookingSuccessMessage}</p>
//                     <p>Great! Your appointment is booked successfully.</p>
//                     <p>
//                       Thank you for booking your appointment with MegaClean!
//                     </p>
//                   </div>
//                 </div>
//               )}

//               {/* Right Section - Privacy Policy */}

//               {/* <div>
//                 <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-all duration-300 z-40"> */}
//               {/* SAFETY Section */}
//               {/* <div className="flex justify-center my-4 group">
//                     <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300 transform group-hover:scale-110">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="w-8 h-8"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
//                         />
//                       </svg>
//                     </div>
//                   </div>
//                   <h2 className="text-xl font-bold text-gray-800 text-center mb-2 relative group">
//                     <span className="bg-gradient-to-r from-blue-500 to-blue-700 bg-[length:0%_2px] group-hover:bg-[length:100%_2px] bg-no-repeat bg-bottom transition-all duration-500">
//                       SAFETY
//                     </span>
//                   </h2>
//                   <p className="text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
//                     Safety is a top priority in cleaning services to protect
//                     both clients and staff. This includes using non-toxic
//                     cleaning products, following proper sanitation protocols,
//                     and ensuring staff are trained in safe handling of
//                     equipment. Additionally, background checks and insurance
//                     coverage provide extra security for clients.
//                   </p>
//                   <div className="border border-t mt-4  group-hover:w-full transition-all duration-500 mx-auto" /> */}

//               {/* Best in Quality Section */}
//               {/* <div className="flex justify-center my-4 group">
//                     <div className="w-14 h-14 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 group-hover:bg-purple-600 group-hover:text-white transition-all duration-300 transform group-hover:scale-110">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="w-8 h-8"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
//                         />
//                       </svg>
//                     </div>
//                   </div>
//                   <h2 className="text-xl font-bold text-gray-800 text-center mb-2 relative group">
//                     <span className="bg-gradient-to-r from-purple-500 to-purple-700 bg-[length:0%_2px] group-hover:bg-[length:100%_2px] bg-no-repeat bg-bottom transition-all duration-500">
//                       Best in Quality
//                     </span>
//                   </h2>
//                   <p className="text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
//                     Providing the best quality cleaning means using top-grade
//                     cleaning products, advanced equipment, and skilled
//                     professionals. Attention to detail, thorough sanitization,
//                     and consistent service ensure a spotless and hygienic
//                     environment. Customer satisfaction is the key measure of
//                     quality excellence.
//                   </p>
//                   <div className="border border-t mt-4  group-hover:w-full transition-all duration-500 mx-auto" /> */}

//               {/* Communication Section */}
//               {/* <div className="flex justify-center my-4 group">
//                     <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center text-green-600 group-hover:bg-green-600 group-hover:text-white transition-all duration-300 transform group-hover:scale-110">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="w-8 h-8"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
//                         />
//                       </svg>
//                     </div>
//                   </div>
//                   <h2 className="text-xl font-bold text-gray-800 text-center mb-2 relative group">
//                     <span className="bg-gradient-to-r from-green-500 to-green-700 bg-[length:0%_2px] group-hover:bg-[length:100%_2px] bg-no-repeat bg-bottom transition-all duration-500">
//                       Communication
//                     </span>
//                   </h2>
//                   <p className="text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
//                     Effective communication ensures clarity between clients and
//                     the cleaning service provider. This includes promptly
//                     responding to inquiries, understanding customer needs, and
//                     providing clear service details. Regular updates and
//                     feedback channels help build trust and improve service
//                     quality.
//                   </p>
//                   <div className="border border-t mt-4  group-hover:w-full transition-all duration-500 mx-auto" /> */}

//               {/* Saves You Time Section */}
//               {/* <div className="flex justify-center my-4 group">
//                     <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center text-amber-600 group-hover:bg-amber-600 group-hover:text-white transition-all duration-300 transform group-hover:scale-110">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="w-8 h-8"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                         />
//                       </svg>
//                     </div>
//                   </div>
//                   <h2 className="text-xl font-bold text-gray-800 text-center mb-2 relative group">
//                     <span className="bg-gradient-to-r from-amber-500 to-amber-700 bg-[length:0%_2px] group-hover:bg-[length:100%_2px] bg-no-repeat bg-bottom transition-all duration-500">
//                       Saves You Time
//                     </span>
//                   </h2>
//                   <p className="text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
//                     Professional cleaning services save you time by handling all
//                     the cleaning tasks efficiently, allowing you to focus on
//                     work, family, or personal activities. With trained experts
//                     and the right tools, cleaning is done faster and more
//                     effectively than DIY efforts. This convenience enhances
//                     productivity and reduces stress.
//                   </p>
//                   <div className="border border-t mt-4  group-hover:w-full transition-all duration-500 mx-auto" /> */}

//               {/* Card Payment Section */}
//               {/* <div className="flex justify-center my-4 group">
//                     <div className="w-14 h-14 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300 transform group-hover:scale-110">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="w-8 h-8"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
//                         />
//                       </svg>
//                     </div>
//                   </div>
//                   <h2 className="text-xl font-bold text-gray-800 text-center mb-2 relative group">
//                     <span className="bg-gradient-to-r from-indigo-500 to-indigo-700 bg-[length:0%_2px] group-hover:bg-[length:100%_2px] bg-no-repeat bg-bottom transition-all duration-500">
//                       Card Payment
//                     </span>
//                   </h2>
//                   <p className="text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
//                     Offering card payment options provides a convenient and
//                     secure way for customers to pay for services. It eliminates
//                     the hassle of cash transactions, ensures quick processing,
//                     and enhances customer trust. Secure payment gateways also
//                     protect customer data and prevent fraud.
//                   </p>
//                 </div>

//                 <div className="max-w-md mx-auto border rounded-lg shadow-lg mt-10 p-5 bg-white sticky top-10">
//                   <h2 className="text-xl font-bold text-center border-b pb-3 mb-4">
//                     Booking Summary
//                   </h2>

//                   <div className="flex items-center text-sm text-black-800 mb-4">
//                     <div className="flex items-center space-x-2">
//                       <span className="material-icons font-bold text-black-800">
//                         Calendar Today :
//                       </span>
//                       {selectedDate && selectedTime && (
//                         <p>
//                           {selectedDate} @ {selectedTime}
//                         </p>
//                       )}
//                     </div>
//                   </div>
//                   <div className="flex items-center space-x-2">
//                     <span className="material-icons font-bold text-black-900">
//                       Auto Renew :
//                     </span>
//                     <p>{selectedFrequency}</p>
//                   </div>
//                   <div className="flex items-center space-x-2  text-black-900">
//                     <span className="material-icons font-bold text-black-900">
//                       Time duration :
//                     </span>
//                     <p>
//                       {Math.floor(totalTime / 60)} Hours {totalTime % 60}{" "}
//                       Minutes
//                     </p>

//                   </div>
//  <div className="flex items-center space-x-2 mb-4">
//                     <span className="material-icons font-bold text-black-900">
//                     Payment Method :-
//                     </span>
//                     <p>{paymentMethod}</p>
//                   </div>
//                   <div className="mb-6">
//                       <h3 className="font-bold mb-2">Cart Items :</h3>
//                       <ul>
//                         {bookingBill.map((item, idx) => (
//                           <li key={idx} className="flex justify-between mb-2">
//                             <span>
//                               {item.name}{item.type} (x{item.qty})
//                             </span>
//                             <div className="flex gap-4">
//                               <span>₹{item.rate}</span>
//                               <span
//                                 onClick={() => removeItem(idx)}
//                                 className="text-red-500 cursor-pointer"
//                               >
//                                 X
//                               </span>
//                             </div>
//                           </li>
//                         ))}
//                       </ul>
//                     </div>

//                   <div className="border-t pt-4 text-black-800">
//                     <div className="flex justify-between font-bold mb-2">
//                       <p>Sub Total :</p>
//                       <p>₹{isNaN(calculateTotal()) ? 0 : calculateTotal()}</p>
//                     </div>
//                     <div className="flex justify-between font-bold mb-2">
//                       <p>Frequently Discount :</p>
//                       <p>-₹{Disamount}</p>
//                     </div>
//                     {appliedPromoCode && (
//                       <div className="flex justify-between font-bold mb-2">
//                         <p>Promo Code ({appliedPromoCode.coupon_code}) :</p>
//                         <p>-₹{promoDiscount}</p>
//                       </div>
//                     )}
//                     <div className="flex font-bold justify-between mb-4">
//                       <p>Tax :</p>
//                       <p>₹{tax}</p>
//                     </div>
//                     <div className="flex justify-between font-bold text-lg">
//                       <p>Total :</p>
//                       <p>₹{parseFloat(text).toFixed(2)}</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//     </div> */}
//               <div>
//                 <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-all duration-300 z-40">
//                   {featuresContent.map((feature, index) => (
//                     <div key={index} className=" justify-center  my-4 group">
//                       <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300 transform group-hover:scale-110">
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           className="w-8 h-8"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
//                           />
//                         </svg>
//                       </div>

//                       <h2 className="text-xl font-bold text-gray-800 text-center mb-2 relative group">
//                         <span className="bg-gradient-to-r from-blue-500 to-blue-700 bg-[length:0%_2px] group-hover:bg-[length:100%_2px] bg-no-repeat bg-bottom transition-all duration-500">
//                           {feature.title}
//                         </span>
//                       </h2>

//                       <p className="text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
//                         {feature.description}
//                       </p>

//                       <div className="border border-t mt-4  group-hover:w-full transition-all duration-500 mx-auto" />
//                     </div>
//                   ))}

//                   <div className="max-w-md mx-auto border rounded-lg shadow-lg mt-10 p-5 bg-white sticky top-10">
//                     <h2 className="text-xl font-bold text-center border-b pb-3 mb-4">
//                       Booking Summary
//                     </h2>

//                     <div className="flex items-center text-sm text-black-800 mb-4">
//                       <div className="flex items-center space-x-2">
//                         <span className="material-icons font-bold text-black-800">
//                           Calendar Today :
//                         </span>

//                         {selectedDate && selectedTime && (
//                           <p>
//                             {selectedDate} @ {selectedTime}
//                           </p>
//                         )}
//                       </div>
//                     </div>

//                     <div className="flex items-center space-x-2">
//                       <span className="material-icons font-bold text-black-900">
//                         Auto Renew :
//                       </span>

//                       <p>{selectedFrequency}</p>
//                     </div>

//                     <div className="flex items-center space-x-2  text-black-900">
//                       <span className="material-icons font-bold text-black-900">
//                         Time duration :
//                       </span>

//                       <p>
//                         {Math.floor(totalTime / 60)} Hours {totalTime % 60}{" "}
//                         Minutes
//                       </p>
//                     </div>

//                     <div className="flex items-center space-x-2 mb-4">
//                       <span className="material-icons font-bold text-black-900">
//                         Payment Method :-
//                       </span>

//                       <p>{paymentMethod}</p>
//                     </div>

//                     <div className="mb-6">
//                       <h3 className="font-bold mb-2">Cart Items :</h3>

//                       <ul>
//                         {bookingBill.map((item, idx) => (
//                           <li key={idx} className="flex justify-between mb-2">
//                             <span>
//                               {item.name}
//                               {item.type} (x{item.qty})
//                             </span>

//                             <div className="flex gap-4">
//                               <span>₹{item.rate}</span>

//                               <span
//                                 onClick={() => removeItem(idx)}
//                                 className="text-red-500 cursor-pointer"
//                               >
//                                 X
//                               </span>
//                             </div>
//                           </li>
//                         ))}
//                       </ul>
//                     </div>

//                     <div className="border-t pt-4 text-black-800">
//                       <div className="flex justify-between font-bold mb-2">
//                         <p>Sub Total :</p>

//                         <p>₹{isNaN(calculateTotal()) ? 0 : calculateTotal()}</p>
//                       </div>

//                       <div className="flex justify-between font-bold mb-2">
//                         <p>Frequently Discount :</p>

//                         <p>-₹{Disamount}</p>
//                       </div>

//                       {appliedPromoCode && (
//                         <div className="flex justify-between font-bold mb-2">
//                           <p>Promo Code ({appliedPromoCode.coupon_code}) :</p>

//                           <p>-₹{promoDiscount}</p>
//                         </div>
//                       )}

//                       <div className="flex font-bold justify-between mb-4">
//                         <p>Tax :</p>

//                         <p>₹{tax}</p>
//                       </div>

//                       <div className="flex justify-between font-bold text-lg">
//                         <p>Total :</p>

//                         <p>₹{parseFloat(text).toFixed(2)}</p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default MyBookingPage;
